import * as React from 'react'
import CalendarImage from './assets/calendar.svg'
import CheckImage from './assets/check.svg'
import ChevronDownIconImage from './assets/chevron-down.svg'
import ChevronLeftIconImage from './assets/chevron-left.svg'
import PlusImage from './assets/plus.svg'
import SpinnerImage from './assets/spinner.svg'
import User01Image from './assets/user-01.svg'
import XCloseImage from './assets/x-close.svg'
import { getSrcFromImport } from './utils'

type IconProps = React.ComponentProps<'svg'>

export function Gift01Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      {...props}
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M9.08333 4.08333V17.4167M9.08333 4.08333H6.1369C5.70277 4.08333 5.28642 3.90774 4.97944 3.59518C4.67246 3.28262 4.5 2.85869 4.5 2.41667C4.5 1.97464 4.67246 1.55072 4.97944 1.23816C5.28642 0.925595 5.70277 0.75 6.1369 0.75C8.42857 0.75 9.08333 4.08333 9.08333 4.08333ZM9.08333 4.08333H12.0298C12.4639 4.08333 12.8802 3.90774 13.1872 3.59518C13.4942 3.28262 13.6667 2.85869 13.6667 2.41667C13.6667 1.97464 13.4942 1.55072 13.1872 1.23816C12.8802 0.925595 12.4639 0.75 12.0298 0.75C9.73809 0.75 9.08333 4.08333 9.08333 4.08333ZM15.75 8.25V14.75C15.75 15.6834 15.75 16.1501 15.5683 16.5067C15.4086 16.8203 15.1536 17.0752 14.84 17.235C14.4835 17.4167 14.0168 17.4167 13.0833 17.4167L5.08333 17.4167C4.14991 17.4167 3.6832 17.4167 3.32668 17.235C3.01308 17.0752 2.75811 16.8203 2.59832 16.5066C2.41667 16.1501 2.41667 15.6834 2.41667 14.75V8.25M0.75 5.41667L0.75 6.91667C0.75 7.38338 0.75 7.61673 0.840828 7.79499C0.920722 7.95179 1.04821 8.07928 1.20501 8.15917C1.38327 8.25 1.61662 8.25 2.08333 8.25L16.0833 8.25C16.55 8.25 16.7834 8.25 16.9617 8.15917C17.1185 8.07928 17.2459 7.95179 17.3258 7.79499C17.4167 7.61673 17.4167 7.38338 17.4167 6.91667V5.41667C17.4167 4.94996 17.4167 4.7166 17.3258 4.53834C17.2459 4.38154 17.1185 4.25406 16.9617 4.17416C16.7834 4.08333 16.55 4.08333 16.0833 4.08333L2.08333 4.08333C1.61662 4.08333 1.38327 4.08333 1.20501 4.17416C1.04821 4.25406 0.920723 4.38154 0.840828 4.53834C0.75 4.7166 0.75 4.94996 0.75 5.41667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AllInclusiveIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_11930_610)">
        <path
          d="M13.9839 4.57357C12.6506 4.17357 11.2772 4.54691 10.3906 5.43357L8.50391 7.10691L7.49057 8.00024H7.49724L5.70391 9.59357C5.16391 10.1336 4.40391 10.3602 3.62391 10.2069C2.79057 10.0402 2.10391 9.37357 1.91057 8.54691C1.56391 7.06024 2.68391 5.74691 4.10391 5.74691C4.71057 5.74691 5.27724 5.98024 5.73057 6.43357L6.04391 6.70691C6.29724 6.93357 6.67724 6.93357 6.93057 6.70691C7.23057 6.44024 7.23057 5.97357 6.93057 5.70691L6.65057 5.46691C5.97057 4.78691 5.06391 4.41357 4.10391 4.41357C2.11724 4.41357 0.503906 6.02691 0.503906 8.00024C0.503906 9.97357 2.11724 11.5869 4.10391 11.5869C5.06391 11.5869 5.97057 11.2136 6.61724 10.5669L8.50391 8.90024L8.51057 8.90691L9.51724 8.00024H9.51057L11.3039 6.40691C11.8439 5.86691 12.6039 5.64024 13.3839 5.79357C14.2172 5.96024 14.9039 6.62691 15.0972 7.45357C15.4439 8.94024 14.3239 10.2536 12.9039 10.2536C12.3039 10.2536 11.7306 10.0202 11.2772 9.56691L10.9572 9.28691C10.7039 9.06024 10.3239 9.06024 10.0706 9.28691C9.77057 9.55357 9.77057 10.0202 10.0706 10.2869L10.3506 10.5336C11.0306 11.2069 11.9306 11.5802 12.8972 11.5802C15.0772 11.5802 16.8039 9.64691 16.4506 7.41357C16.2506 6.08691 15.2706 4.95357 13.9839 4.57357Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11930_610">
          <rect width="16" height="16" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Image05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0001 21H20.0105C20.9817 21 21.4673 21 21.7349 20.7975C21.9681 20.6211 22.1124 20.3515 22.1298 20.0596C22.1498 19.7246 21.8805 19.3205 21.3418 18.5125L18.3314 13.9969C17.8863 13.3292 17.6637 12.9954 17.3832 12.8791C17.138 12.7773 16.8623 12.7773 16.6171 12.8791C16.3365 12.9954 16.114 13.3292 15.6689 13.9969L14.9247 15.1132M19.0001 21L11.3156 9.90018C10.8737 9.26182 10.6527 8.94264 10.3767 8.83044C10.1353 8.73228 9.86502 8.73228 9.62356 8.83044C9.34754 8.94264 9.12657 9.26182 8.68463 9.90018L2.73834 18.4893C2.17531 19.3025 1.8938 19.7092 1.90983 20.0473C1.92379 20.3419 2.06701 20.6152 2.30121 20.7943C2.57014 21 3.06471 21 4.05385 21H19.0001ZM21.0001 6C21.0001 7.65685 19.657 9 18.0001 9C16.3433 9 15.0001 7.65685 15.0001 6C15.0001 4.34315 16.3433 3 18.0001 3C19.657 3 21.0001 4.34315 21.0001 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PenToolIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18 13L16.7004 6.50182C16.6278 6.13883 16.5915 5.95733 16.5032 5.80953C16.4252 5.67886 16.3183 5.56773 16.1908 5.4846C16.0466 5.39057 15.8667 5.34714 15.5069 5.26028L2 2M2 2L5.26028 15.5069C5.34714 15.8667 5.39057 16.0466 5.4846 16.1908C5.56773 16.3183 5.67886 16.4252 5.80953 16.5032C5.95733 16.5915 6.13883 16.6278 6.50182 16.7004L13 18M2 2L9.586 9.586M16.1314 20.8686L20.8686 16.1314C21.2646 15.7354 21.4627 15.5373 21.5368 15.309C21.6021 15.1082 21.6021 14.8918 21.5368 14.691C21.4627 14.4627 21.2646 14.2646 20.8686 13.8686L20.1314 13.1314C19.7354 12.7354 19.5373 12.5373 19.309 12.4632C19.1082 12.3979 18.8918 12.3979 18.691 12.4632C18.4627 12.5373 18.2646 12.7354 17.8686 13.1314L13.1314 17.8686C12.7354 18.2646 12.5373 18.4627 12.4632 18.691C12.3979 18.8918 12.3979 19.1082 12.4632 19.309C12.5373 19.5373 12.7354 19.7354 13.1314 20.1314L13.8686 20.8686C14.2646 21.2646 14.4627 21.4627 14.691 21.5368C14.8918 21.6021 15.1082 21.6021 15.309 21.5368C15.5373 21.4627 15.7354 21.2646 16.1314 20.8686ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11Z"
      />
    </svg>
  )
}

export function PenSquareIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3264_54832)">
        <path
          d="M7.33301 2.66666H4.53301C3.4129 2.66666 2.85285 2.66666 2.42503 2.88464C2.0487 3.07639 1.74274 3.38235 1.55099 3.75867C1.33301 4.1865 1.33301 4.74655 1.33301 5.86666V11.4667C1.33301 12.5868 1.33301 13.1468 1.55099 13.5746C1.74274 13.951 2.0487 14.2569 2.42503 14.4487C2.85285 14.6667 3.4129 14.6667 4.53301 14.6667H10.133C11.2531 14.6667 11.8132 14.6667 12.241 14.4487C12.6173 14.2569 12.9233 13.951 13.115 13.5746C13.333 13.1468 13.333 12.5868 13.333 11.4667V8.66666M5.33299 10.6667H6.44935C6.77547 10.6667 6.93853 10.6667 7.09198 10.6298C7.22803 10.5972 7.35809 10.5433 7.47739 10.4702C7.61194 10.3877 7.72724 10.2724 7.95785 10.0418L14.333 3.66666C14.8853 3.11437 14.8853 2.21894 14.333 1.66666C13.7807 1.11437 12.8853 1.11437 12.333 1.66665L5.95783 8.04182C5.72723 8.27242 5.61193 8.38772 5.52947 8.52228C5.45637 8.64157 5.40249 8.77163 5.36983 8.90768C5.33299 9.06113 5.33299 9.22419 5.33299 9.55031V10.6667Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3264_54832">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function CalendarIcon(props: IconProps) {
  return (
    <svg width="24" height="24" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" />
    </svg>
  )
}

CalendarIcon.src = getSrcFromImport(CalendarImage)

export function WandIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8 13.8L21 15M19.8 4.2L21 3M2.5 21.5L10 14M10.2 4.2L9 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 17C15.5217 17 15.9493 16.6163 16.0217 16.0733C16.7391 11.2371 17.3986 10.5638 22.0507 10.0353C22.587 9.97014 23 9.52127 23 9C23 8.47149 22.5942 8.0371 22.058 7.95747C17.4348 7.31312 16.8623 6.74842 16.0217 1.91946C15.9275 1.38371 15.5145 1 15 1C14.471 1 14.0507 1.38371 13.9638 1.9267C13.2609 6.75566 12.6014 7.42896 7.95652 7.95747C7.4058 8.02986 7 8.46425 7 9C7 9.52127 7.3913 9.95566 7.94203 10.0353C12.5725 10.6941 13.1377 11.2516 13.9638 16.0805C14.0725 16.6235 14.4928 17 15 17Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Building07Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M19 21V6.2C19 5.0799 19 4.51984 18.782 4.09202C18.5903 3.71569 18.2843 3.40973 17.908 3.21799C17.4802 3 16.9201 3 15.8 3H8.2C7.07989 3 6.51984 3 6.09202 3.21799C5.71569 3.40973 5.40973 3.71569 5.21799 4.09202C5 4.51984 5 5.0799 5 6.2V21M21 21H3M9.5 8H9.51M14.5 8H14.51M10 8C10 8.27614 9.77614 8.5 9.5 8.5C9.22386 8.5 9 8.27614 9 8C9 7.72386 9.22386 7.5 9.5 7.5C9.77614 7.5 10 7.72386 10 8ZM15 8C15 8.27614 14.7761 8.5 14.5 8.5C14.2239 8.5 14 8.27614 14 8C14 7.72386 14.2239 7.5 14.5 7.5C14.7761 7.5 15 7.72386 15 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BoardsIcon(props: IconProps) {
  return (
    <svg
      width="26"
      height="22"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 22"
      fill="none"
    >
      <path
        d="M12.0193 15.5279C12.6393 15.1393 13.1888 14.5952 13.7311 14.0692C14.6692 13.1456 15.3307 12.5437 16.0176 12.5148C16.061 12.6793 16.1116 12.9233 16.1387 13.0878C16.2851 13.865 16.6123 15.7032 18.3746 15.7123H18.3836C19.3127 15.7123 20.3267 15.0417 21.0841 13.9048C21.5142 13.2631 21.4022 12.3503 20.8346 11.8641C20.2671 11.3778 19.4591 11.5044 19.0289 12.146C18.9078 12.3214 18.7795 12.466 18.6764 12.5744C18.6764 12.5545 18.6764 12.5256 18.6674 12.5057C18.512 11.6707 18.2625 10.2608 16.9485 9.72576C16.8707 9.69684 16.793 9.66792 16.708 9.65708C14.6619 9.28834 13.1997 10.7271 12.0302 11.8821C11.9615 11.9508 11.8838 12.0177 11.8151 12.0954C11.8838 11.7556 12.0555 11.2893 12.3483 10.5879C12.6664 9.81072 13.0026 9.0136 13.0966 8.1478C13.1653 7.51516 12.8653 6.91326 12.3573 6.65117C10.8698 5.87394 8.70254 6.38908 5.35863 8.33216C4.72238 8.7009 4.47294 9.57574 4.80011 10.2951C5.12727 11.0145 5.90992 11.2965 6.53713 10.9278C8.19644 9.96616 9.29722 9.5179 10.0202 9.33353V9.34257C9.37494 10.888 8.3085 13.4728 10.6312 15.4267C10.8553 15.6219 11.13 15.7177 11.3957 15.7177C11.6108 15.7177 11.8259 15.6599 12.023 15.5333V15.5243L12.0193 15.5279ZM24.0574 0.841797H1.94242C1.24652 0.841797 0.669922 1.4925 0.669922 2.28058V19.7177C0.669922 20.5058 1.24652 21.1565 1.94242 21.1565H24.0574C24.7533 21.1565 25.3299 20.5058 25.3299 19.7177V2.28058C25.3299 1.4925 24.7533 0.841797 24.0574 0.841797ZM22.8102 3.69045V18.3097H3.1896V3.69045H22.812H22.8102Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CheckSquareIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        id="Icon"
        d="M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      {...props}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98999 7.12012L7.97999 11.1101L11.97 7.12012"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  )
}

ChevronDownIcon.src = getSrcFromImport(ChevronDownIconImage)

export function ChevronLeftIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.24 3.98999L6.24999 7.97999L10.24 11.97"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  )
}

ChevronLeftIcon.src = getSrcFromImport(ChevronLeftIconImage)

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.18005 11.97L11.1701 7.97997L7.18005 3.98997"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function ChevronUpIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98999 10.6401L7.97999 6.65014L11.97 10.6401"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function ChevronSelectorHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7L4 12L9 17M15 7L20 12L15 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DownloadCloudIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 17L12 21M12 21L16 17M12 21V12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DownloadCloud02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8 17L12 21M12 21L16 17M12 21V12M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EclipseIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.665"
        y="0.665"
        width="14.63"
        height="14.63"
        rx="7.315"
        stroke="currentColor"
        strokeWidth="1.33"
      />
    </svg>
  )
}

export function EditIcon(props: IconProps) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7157 7.51667L12.4824 8.28333L4.93236 15.8333H4.16569V15.0667L11.7157 7.51667ZM14.7157 2.5C14.5074 2.5 14.2907 2.58333 14.1324 2.74167L12.6074 4.26667L15.7324 7.39167L17.2574 5.86667C17.5824 5.54167 17.5824 5.01667 17.2574 4.69167L15.3074 2.74167C15.1407 2.575 14.9324 2.5 14.7157 2.5ZM11.7157 5.15833L2.49902 14.375V17.5H5.62402L14.8407 8.28333L11.7157 5.15833Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Edit04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 18L19.9999 19.094C19.4695 19.6741 18.7501 20 18.0001 20C17.2501 20 16.5308 19.6741 16.0004 19.094C15.4692 18.5151 14.75 18.1901 14.0002 18.1901C13.2504 18.1901 12.5311 18.5151 12 19.094M3 20H4.67454C5.16372 20 5.40832 20 5.63849 19.9447C5.84256 19.8957 6.03765 19.8149 6.2166 19.7053C6.41843 19.5816 6.59138 19.4086 6.93729 19.0627L19.5 6.49998C20.3285 5.67156 20.3285 4.32841 19.5 3.49998C18.6716 2.67156 17.3285 2.67156 16.5 3.49998L3.93726 16.0627C3.59136 16.4086 3.4184 16.5816 3.29472 16.7834C3.18506 16.9624 3.10425 17.1574 3.05526 17.3615C3 17.5917 3 17.8363 3 18.3255V20Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Edit05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.5C22.3284 4.67157 22.3284 3.32843 21.5 2.5C20.6716 1.67157 19.3284 1.67157 18.5 2.5L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1575 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DrawingIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="21"
      {...props}
      viewBox="0 0 25 21"
      fill="none"
    >
      <path
        d="M11.3494 14.6861C11.9694 14.2975 12.5189 13.7534 13.0611 13.2274C13.9992 12.3038 14.6608 11.7019 15.3477 11.673C15.391 11.8375 15.4416 12.0815 15.4688 12.246C15.6152 13.0232 15.9423 14.8614 17.7047 14.8705H17.7137C18.6428 14.8705 19.6568 14.1999 20.4141 13.063C20.8443 12.4213 20.7323 11.5085 20.1647 11.0223C19.5971 10.536 18.7892 10.6626 18.359 11.3042C18.2379 11.4796 18.1095 11.6242 18.0065 11.7326C18.0065 11.7127 18.0065 11.6838 17.9975 11.6639C17.842 10.8289 17.5926 9.41899 16.2785 8.88396C16.2008 8.85504 16.1231 8.82612 16.0381 8.81528C13.992 8.44654 12.5297 9.88533 11.3603 11.0403C11.2916 11.109 11.2139 11.1759 11.1452 11.2536C11.2139 10.9138 11.3856 10.4475 11.6784 9.74615C11.9965 8.96892 12.3327 8.1718 12.4267 7.306C12.4954 6.67337 12.1953 6.07146 11.6874 5.80937C10.1998 5.03214 8.03262 5.54728 4.68871 7.49037C4.05246 7.8591 3.80302 8.73394 4.13018 9.45333C4.45735 10.1727 5.24 10.4547 5.86721 10.086C7.52652 9.12436 8.62729 8.6761 9.3503 8.49173V8.50077C8.70502 10.0462 7.63858 12.631 9.96124 14.5849C10.1854 14.7801 10.4601 14.8759 10.7258 14.8759C10.9409 14.8759 11.156 14.8181 11.353 14.6915V14.6825L11.3494 14.6861ZM23.3875 0H1.27249C0.576599 0 0 0.650708 0 1.43879V18.8759C0 19.664 0.576599 20.3147 1.27249 20.3147H23.3875C24.0834 20.3147 24.66 19.664 24.66 18.8759V1.43879C24.66 0.650708 24.0834 0 23.3875 0ZM22.1403 2.84865V17.4679H2.51968V2.84865H22.1421H22.1403Z"
        fill="white"
      />
    </svg>
  )
}

export function FlowIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="18"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 18"
      fill="none"
    >
      <path
        d="M11.9427 9.95431L4.30983 17.5871C3.78227 18.1147 2.92919 18.1147 2.40724 17.5871L1.13884 16.3187C0.611273 15.7912 0.611273 14.9381 1.13884 14.4162L6.54918 9.00581L1.13884 3.59547C0.611273 3.06791 0.611273 2.21483 1.13884 1.69288L2.40162 0.413251C2.92919 -0.114313 3.78227 -0.114313 4.30422 0.413251L11.9371 8.04609C12.4702 8.57366 12.4702 9.42674 11.9427 9.95431ZM22.7185 8.04609L15.0856 0.413251C14.558 -0.114313 13.705 -0.114313 13.183 0.413251L11.9146 1.68165C11.3871 2.20921 11.3871 3.0623 11.9146 3.58425L17.325 8.99459L11.9146 14.4049C11.3871 14.9325 11.3871 15.7856 11.9146 16.3075L13.183 17.5759C13.7106 18.1035 14.5637 18.1035 15.0856 17.5759L22.7185 9.94308C23.246 9.42674 23.246 8.57366 22.7185 8.04609Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FlowIconTwo(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      {...props}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M4 4.64001L12.36 13L4 21.36"
        stroke="currentColor"
        strokeWidth="3.04"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 4.64001L21.36 13L13 21.36"
        stroke="currentColor"
        strokeWidth="3.04"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FolderIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FolderSearchIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="20"
      {...props}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5L10.8845 2.76892C10.5634 2.1268 10.4029 1.80573 10.1634 1.57116C9.95158 1.36373 9.69632 1.20597 9.41607 1.10931C9.09916 1 8.74021 1 8.02229 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.0799 1 4.2V5M1 5H16.2C17.8802 5 18.7202 5 19.362 5.32698C19.9265 5.6146 20.3854 6.07354 20.673 6.63803C21 7.27976 21 8.11984 21 9.8V14.2C21 15.8802 21 16.7202 20.673 17.362C20.3854 17.9265 19.9265 18.3854 19.362 18.673C18.7202 19 17.8802 19 16.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5ZM14.5 15.5L13 14M14 11.5C14 13.433 12.433 15 10.5 15C8.567 15 7 13.433 7 11.5C7 9.567 8.567 8 10.5 8C12.433 8 14 9.567 14 11.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FontGeneratorIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.40785 17.136L10.2946 19.4368H7.13104C6.36411 19.4368 5.6571 19.4368 5.6571 19.4368C5.27364 19.4368 4.96207 19.1252 4.96207 18.7418C4.96207 18.3343 4.96207 17.9389 4.96207 17.5315C4.96207 17.16 5.27364 16.8484 5.64512 16.8484C5.96867 16.8484 6.29221 16.8484 6.61576 16.8484C6.85542 16.8484 7.05914 16.6327 7.05914 16.393C7.05914 16.2013 7.05914 16.0096 7.05914 15.8059L8.73679 16.453C8.86861 16.5009 9.10827 16.5968 9.2281 16.6447C9.25207 16.7046 9.35992 16.9802 9.40785 17.124V17.136ZM9.21612 10.0659C9.26405 9.94607 9.3719 9.69443 9.40785 9.58658L10.3186 7.22588V2.60036H13.554C13.7937 2.60036 13.9974 2.80407 13.9974 3.04374C13.9974 3.36729 13.9974 3.69083 13.9974 4.01438C13.9974 4.38586 14.309 4.69742 14.6805 4.69742C15.0879 4.69742 15.4833 4.69742 15.8908 4.69742C16.2742 4.69742 16.5738 4.38586 16.5858 4.0024C16.5858 4.0024 16.5858 1.09047 16.5858 0.695027C16.5858 0.311564 16.2742 0.0119832 15.8908 0C15.7709 0 15.6391 0 15.4953 0H13.2904H1.93032C1.78652 0 1.64272 0 1.53487 0C1.15141 0 0.839844 0.311564 0.839844 0.695027C0.839844 1.10246 0.839844 4.0024 0.839844 4.0024C0.839844 4.38586 1.15141 4.69742 1.53487 4.69742C1.9423 4.69742 2.33775 4.69742 2.74518 4.69742C3.11666 4.69742 3.42822 4.38586 3.42822 4.01438C3.42822 3.69083 3.42822 3.36729 3.42822 3.04374C3.42822 2.80407 3.63194 2.61234 3.8716 2.60036H7.14302V10.8688L8.74877 10.2457C8.88059 10.1977 9.10827 10.1019 9.2281 10.0539L9.21612 10.0659ZM18.8027 12.834L15.759 11.6597C15.2317 11.456 15.0639 11.3841 14.9321 11.2882C14.8003 11.1923 14.6805 11.0845 14.5846 10.9407C14.4887 10.8089 14.4288 10.6531 14.2131 10.1138L13.0388 7.0701C12.9549 6.8544 12.7392 6.7106 12.5115 6.7106C12.2838 6.7106 12.0681 6.8544 11.9842 7.0701L10.8099 10.1138C10.6062 10.6411 10.5343 10.8089 10.4384 10.9407C10.4025 10.9886 10.3545 11.0246 10.3186 11.0605C10.2467 11.1324 10.1868 11.2163 10.1029 11.2762C9.97106 11.3721 9.8033 11.444 9.27604 11.6477L7.13104 12.4745L6.22031 12.822C6.00461 12.9059 5.84883 13.1216 5.84883 13.3493C5.84883 13.577 5.99263 13.7927 6.22031 13.8766L7.13104 14.2241L9.27604 15.0509C9.81528 15.2546 9.97106 15.3265 10.1029 15.4224C10.2107 15.4943 10.2946 15.5902 10.3665 15.686C10.3905 15.71 10.4264 15.734 10.4384 15.7579C10.5343 15.8898 10.5942 16.0455 10.8099 16.5848L10.9058 16.8364L11.9004 19.4248L11.9842 19.6405C12.0681 19.8562 12.2718 20 12.5115 20C12.7512 20 12.9549 19.8562 13.0388 19.6405L14.2131 16.5968C14.4168 16.0575 14.4887 15.9017 14.5846 15.7699C14.6805 15.6381 14.8003 15.5183 14.9321 15.4224C15.0639 15.3265 15.2197 15.2666 15.759 15.0509L18.8027 13.8766C19.0184 13.7927 19.1622 13.577 19.1622 13.3493C19.1622 13.1216 19.0184 12.9059 18.8027 12.822V12.834Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FolderPlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M13 7L11.8845 4.76892C11.5634 4.1268 11.4029 3.80573 11.1634 3.57116C10.9516 3.36373 10.6963 3.20597 10.4161 3.10931C10.0992 3 9.74021 3 9.02229 3H5.2C4.0799 3 3.51984 3 3.09202 3.21799C2.71569 3.40973 2.40973 3.71569 2.21799 4.09202C2 4.51984 2 5.0799 2 6.2V7M2 7H17.2C18.8802 7 19.7202 7 20.362 7.32698C20.9265 7.6146 21.3854 8.07354 21.673 8.63803C22 9.27976 22 10.1198 22 11.8V16.2C22 17.8802 22 18.7202 21.673 19.362C21.3854 19.9265 20.9265 20.3854 20.362 20.673C19.7202 21 18.8802 21 17.2 21H6.8C5.11984 21 4.27976 21 3.63803 20.673C3.07354 20.3854 2.6146 19.9265 2.32698 19.362C2 18.7202 2 17.8802 2 16.2V7ZM12 17V11M9 14H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HiddenIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.35421 6.52257C2.66172 6.96292 2.06069 7.41655 1.59462 7.79645C1.00593 8.27629 1.02412 9.14135 1.62566 9.60498C3.15079 10.7804 6.03417 12.7097 8.53005 12.7097C8.74912 12.7097 8.97118 12.6949 9.19505 12.667M7.86505 4.76538C8.08626 4.74208 8.30815 4.72974 8.53005 4.72974C11.2746 4.72974 14.0192 6.61761 15.4651 7.79617C16.0538 8.276 16.0351 9.14211 15.4335 9.60571C15.0014 9.93871 14.4603 10.3321 13.85 10.725"
        stroke="currentColor"
        strokeWidth="1.33"
      />
      <path
        d="M2.54504 2.73486C7.21962 7.40944 9.84047 10.0303 14.515 14.7049"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function ImagePlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M19 8V2M16 5H22M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ImageIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      {...props}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.665039 5.21518V2.55518H7.31504M13.965 5.21518V2.55518H7.31504M7.31504 2.55518V14.5252M9.97504 14.5252H4.65504"
        stroke="currentColor"
        strokeWidth="1.33"
      />
    </svg>
  )
}

export function LineHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.225 9.54492H1.59497" stroke="currentColor" strokeWidth="1.33" />
    </svg>
  )
}

export function LineVerticalIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.91001 0.949931V16.9099" stroke="currentColor" strokeWidth="1.33" />
    </svg>
  )
}

export function LineIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.2251 0.665039L1.5951 15.295" stroke="currentColor" strokeWidth="1.33" />
    </svg>
  )
}

export function LockIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M12.4993 5.66667H11.8327V4.33333C11.8327 2.49333 10.3393 1 8.49935 1C6.65935 1 5.16602 2.49333 5.16602 4.33333V5.66667H4.49935C3.76602 5.66667 3.16602 6.26667 3.16602 7V13.6667C3.16602 14.4 3.76602 15 4.49935 15H12.4993C13.2327 15 13.8327 14.4 13.8327 13.6667V7C13.8327 6.26667 13.2327 5.66667 12.4993 5.66667ZM8.49935 11.6667C7.76602 11.6667 7.16602 11.0667 7.16602 10.3333C7.16602 9.6 7.76602 9 8.49935 9C9.23268 9 9.83268 9.6 9.83268 10.3333C9.83268 11.0667 9.23268 11.6667 8.49935 11.6667ZM6.49935 5.66667V4.33333C6.49935 3.22667 7.39268 2.33333 8.49935 2.33333C9.60602 2.33333 10.4993 3.22667 10.4993 4.33333V5.66667H6.49935Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LockedIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.25509"
        y="8.76485"
        width="9.31"
        height="6.65"
        rx="0.665"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.33"
      />
      <path
        d="M6.25 7.43495V4.10995C6.25 2.64087 7.44092 1.44995 8.91 1.44995V1.44995C10.3791 1.44995 11.57 2.64087 11.57 4.10995V7.43495"
        stroke="currentColor"
        strokeWidth="1.33"
      />
    </svg>
  )
}

export function PageIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="3.33329"
        y1="2.91409e-08"
        x2="3.33329"
        y2="16"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
      <line
        x1="12.6667"
        y1="2.91409e-08"
        x2="12.6667"
        y2="16"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
      <line
        x1="16"
        y1="3.33341"
        x2="-5.82819e-08"
        y2="3.33341"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
      <line
        x1="16"
        y1="12.6667"
        x2="-5.82819e-08"
        y2="12.6667"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
    </svg>
  )
}

export function PartnerPrintfulIcon(props: IconProps) {
  return (
    <svg
      width="32"
      height="32"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M11.7,14.7l-4.8,8.3H.2l8.1-13.9,3.3,5.6ZM23.6,9l-3.3,5.6,4.8,8.3h6.6l-8.1-13.9ZM19.3,14.7l-3.3-5.6-3.3,5.6,3.3,5.6,3.3-5.6ZM12.2,15.6l-4.3,7.4h6.6l1-1.8-3.3-5.6ZM17.6,23h6.6l-4.3-7.4-3.3,5.6,1,1.8ZM15.5,23h1l-.5-.9-.5.9Z"
        strokeWidth="0"
        stroke="currentColor"
        fill="currentColor"
      />
    </svg>
  )
}

export function PolygonIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4901 13.9649L8.84006 2.65991L2.19006 13.9649H15.4901Z"
        stroke="currentColor"
        strokeWidth="1.33"
      />
    </svg>
  )
}

export function SquareIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.666667"
        y="0.666667"
        width="14.6667"
        height="14.6667"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="0.666667"
        y="0.666667"
        width="14.6667"
        height="14.6667"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}

// Same width/height as SquareIcon
export function CheckSquareIcon2(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.666667"
        y="0.666667"
        width="14.6667"
        height="14.6667"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.33333"
      />
      <path
        d="M4.5 8.5L7 11L11.5 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ScreenDivideIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2" />
      <path d="M12 6L12 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export function ScaleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V8M11.5 12.5L17 7M17 7H12M17 7V12M6.2 21H8.8C9.9201 21 10.4802 21 10.908 20.782C11.2843 20.5903 11.5903 20.2843 11.782 19.908C12 19.4802 12 18.9201 12 17.8V15.2C12 14.0799 12 13.5198 11.782 13.092C11.5903 12.7157 11.2843 12.4097 10.908 12.218C10.4802 12 9.92011 12 8.8 12H6.2C5.0799 12 4.51984 12 4.09202 12.218C3.71569 12.4097 3.40973 12.7157 3.21799 13.092C3 13.5198 3 14.0799 3 15.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Scale02Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 17.5H13.5C14.9001 17.5 15.6002 17.5 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.5 15.6002 17.5 14.9001 17.5 13.5V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V6.66667M9.58333 10.4167L14.1667 5.83333M14.1667 5.83333H10M14.1667 5.83333V10M5.16667 17.5H7.33333C8.26675 17.5 8.73346 17.5 9.08998 17.3183C9.40359 17.1586 9.65855 16.9036 9.81834 16.59C10 16.2335 10 15.7668 10 14.8333V12.6667C10 11.7332 10 11.2665 9.81834 10.91C9.65855 10.5964 9.40359 10.3414 9.08998 10.1817C8.73346 10 8.26675 10 7.33333 10H5.16667C4.23325 10 3.76654 10 3.41002 10.1817C3.09641 10.3414 2.84144 10.5964 2.68166 10.91C2.5 11.2665 2.5 11.7332 2.5 12.6667V14.8333C2.5 15.7668 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1586 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ScaleFitIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10 2H14M22 10V14M18 22C18.93 22 19.395 22 19.7765 21.8978C20.8117 21.6204 21.6204 20.8117 21.8978 19.7765C22 19.395 22 18.93 22 18M22 6C22 5.07003 22 4.60504 21.8978 4.22354C21.6204 3.18827 20.8117 2.37962 19.7765 2.10222C19.395 2 18.93 2 18 2M6 2C5.07003 2 4.60504 2 4.22354 2.10222C3.18827 2.37962 2.37962 3.18827 2.10222 4.22354C2 4.60504 2 5.07003 2 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 22L10 22M2 14L2 10M2 18C2 18.93 2 19.395 2.10222 19.7765C2.37962 20.8117 3.18827 21.6204 4.22354 21.8978C4.60504 22 5.07003 22 6 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.97465 8V15.2727H8.00022V9.81818H7.95761L6.3667 10.7699V9.09375L8.15647 8H9.97465Z"
        fill="currentColor"
      />
      <path
        d="M12.4946 14.4688C12.2199 14.4688 11.9844 14.3729 11.7879 14.1811C11.5938 13.987 11.4979 13.7514 11.5002 13.4744C11.4979 13.2045 11.5938 12.9737 11.7879 12.782C11.9844 12.5902 12.2199 12.4943 12.4946 12.4943C12.755 12.4943 12.9846 12.5902 13.1835 12.782C13.3847 12.9737 13.4865 13.2045 13.4889 13.4744C13.4865 13.6591 13.438 13.8272 13.3433 13.9787C13.251 14.1278 13.1302 14.2474 12.9811 14.3374C12.8319 14.425 12.6698 14.4688 12.4946 14.4688ZM12.4946 10.9744C12.2199 10.9744 11.9844 10.8786 11.7879 10.6868C11.5938 10.4927 11.4979 10.2571 11.5002 9.98011C11.4979 9.71023 11.5938 9.4794 11.7879 9.28764C11.9844 9.09588 12.2199 9 12.4946 9C12.755 9 12.9846 9.09588 13.1835 9.28764C13.3847 9.4794 13.4865 9.71023 13.4889 9.98011C13.4865 10.1648 13.438 10.3329 13.3433 10.4844C13.251 10.6335 13.1302 10.7531 12.9811 10.843C12.8319 10.9306 12.6698 10.9744 12.4946 10.9744Z"
        fill="currentColor"
      />
      <path
        d="M17.9747 8V15.2727H16.0002V9.81818H15.9576L14.3667 10.7699V9.09375L16.1565 8H17.9747Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TextIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.665"
        y="0.665"
        width="14.63"
        height="14.63"
        rx="1.995"
        stroke="currentColor"
        strokeWidth="1.33"
      />
      <path
        d="M0.665039 10.6402L4.65504 7.31519L12.635 15.2952"
        stroke="currentColor"
        strokeWidth="1.33"
      />
      <circle cx="10.64" cy="5.32016" r="2.66" stroke="currentColor" strokeWidth="1.33" />
    </svg>
  )
}

export function UnlockedIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.21505"
        y="8.76485"
        width="9.31"
        height="6.65"
        rx="0.665"
        stroke="currentColor"
        strokeWidth="1.33"
      />
      <path
        d="M8.53003 7.43495V4.10995C8.53003 2.64087 9.72095 1.44995 11.19 1.44995V1.44995C12.6591 1.44995 13.85 2.64087 13.85 4.10995V7.43495"
        stroke="currentColor"
        strokeWidth="1.33"
      />
    </svg>
  )
}

export function BackgroundRemoverIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <g id="bg-remover-g" clipPath="url(#bg-remover-path)">
        <path
          d="M21.6334 12.5331L19.1285 8.36107C18.9423 8.53879 18.7392 8.69111 18.5022 8.81805L18.443 8.8519L18.3753 8.87729L15.3795 10.079C15.1933 10.1551 15.0918 10.1975 15.0241 10.2228L14.9733 10.2736C14.9479 10.3413 14.8971 10.4429 14.8294 10.6291L13.6447 13.591C13.3146 14.5049 12.5022 15.0889 11.5629 15.0889C10.7335 15.0889 9.96344 14.5811 9.54877 13.7518L9.44722 13.5487L9.41337 13.4725L9.38798 13.3963L8.38939 10.7983L8.37246 10.7645V10.7306L8.31322 10.5952L7.19616 11.2638L2.66866 13.9803C0.959206 15.0042 0.400673 17.2384 1.42465 18.9478L3.4049 22.2398C4.42888 23.9492 6.66301 24.5078 8.37246 23.4838L12.9 20.7673L20.7787 16.0451C21.9888 15.3173 22.3866 13.7433 21.6588 12.5331H21.6334ZM7.26386 21.6728C6.553 22.0959 5.63057 21.8674 5.19898 21.1566L3.21873 17.8646C2.7956 17.1537 3.02409 16.2313 3.73495 15.7997L7.06076 13.8025L10.5897 19.6756L7.26386 21.6728ZM4.75046 6.49929C4.75046 6.29619 4.95356 6.10155 5.1482 6L6.04524 5.70381L8.24552 4.89986C8.74482 4.69676 8.94792 4.60367 9.14256 4.50212C9.24411 4.50212 9.24411 4.40056 9.34566 4.29901L9.44722 4.19746C9.54877 4.09591 9.65032 3.90127 9.84496 3.39351L11.0467 0.397743C11.1482 0.101551 11.3428 0 11.5459 0C11.7491 0 11.9437 0.203103 12.0452 0.397743L13.2469 3.39351C13.45 3.89281 13.5431 4.09591 13.6447 4.19746C13.6447 4.29901 13.8478 4.40056 13.9409 4.49365C14.034 4.58674 14.2371 4.69676 14.7448 4.8914L17.7406 6.09309C17.9437 6.19464 18.1383 6.38928 18.1383 6.79549C18.1383 6.99859 17.9352 7.19323 17.7406 7.29478L14.7448 8.49647C14.2455 8.69958 14.0424 8.79267 13.9409 8.89422C13.8393 8.89422 13.7378 9.09732 13.6447 9.19041C13.5516 9.2835 13.4416 9.4866 13.2469 9.99436L12.0452 12.9901C11.9437 13.2863 11.7491 13.3879 11.5459 13.3879C11.3428 13.3879 11.1482 13.1848 11.0467 12.9901L10.9451 12.787L9.94651 10.189L9.84496 9.89281C9.64186 9.39351 9.54877 9.19041 9.44722 9.08886C9.44722 8.98731 9.34566 8.98731 9.34566 8.98731L9.04947 8.69111C8.94792 8.58956 8.75328 8.48801 8.24552 8.29337L6.04524 7.29478L5.1482 6.99859C4.85201 6.89704 4.75046 6.7024 4.75046 6.49929ZM1.33156 10.3836L0.493762 10.0028L0.155257 9.89281C0.0452428 9.85896 0.00292969 9.78279 0.00292969 9.70663C0.00292969 9.63047 0.0790933 9.5543 0.155257 9.52045L0.493762 9.41044L1.33156 9.10578C1.51774 9.02962 1.5939 8.99577 1.67007 8.95345C1.70392 8.95345 1.70392 8.91961 1.74623 8.87729L1.78008 8.84344C1.78008 8.84344 1.85624 8.73343 1.93241 8.53879L2.38939 7.39633C2.42324 7.28632 2.4994 7.24401 2.57557 7.24401C2.65173 7.24401 2.72789 7.32017 2.76174 7.39633L3.21873 8.53879C3.29489 8.72497 3.32874 8.80113 3.37105 8.84344C3.37105 8.87729 3.44722 8.91961 3.48107 8.95345C3.51492 8.98731 3.59108 9.02962 3.78572 9.10578L4.92818 9.56276C5.00434 9.59661 5.0805 9.67278 5.0805 9.82511C5.0805 9.90127 5.00434 9.97743 4.92818 10.0113L3.78572 10.4683C3.59954 10.5444 3.52338 10.5783 3.48107 10.6206C3.44722 10.6206 3.4049 10.6968 3.37105 10.7306C3.3372 10.7645 3.29489 10.8406 3.21873 11.0353L2.76174 12.1777C2.72789 12.2877 2.65173 12.33 2.57557 12.33C2.4994 12.33 2.42324 12.2539 2.38939 12.1777L2.35554 12.1016L1.97472 11.1114L1.94087 11.0014C1.86471 10.8152 1.83086 10.7391 1.78854 10.6968C1.78854 10.6629 1.75469 10.6629 1.75469 10.6629L1.64468 10.5529C1.64468 10.5529 1.53466 10.4767 1.34002 10.4006L1.33156 10.3836Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="bg-remover-path">
          <rect width="21.9944" height="24" fill="white" transform="translate(0.00292969)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function VectorizerIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="26"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 26"
      fill="none"
    >
      <path
        d="M21.9459 3.54212C21.9459 1.84355 20.5676 0.465211 18.869 0.465211C17.1704 0.465211 15.7921 1.84355 15.7921 3.54212C15.7921 4.24289 16.0381 4.87173 16.4325 5.38919L11.4088 19.3977C11.3461 19.3977 11.2858 19.3722 11.2115 19.3722C11.1489 19.3722 11.1002 19.3838 11.0398 19.3838L6.04159 5.34974C6.41054 4.84389 6.63331 4.21737 6.63331 3.5398C6.63331 1.84123 5.25496 0.462891 3.5564 0.462891C1.85784 0.462891 0.479492 1.84123 0.479492 3.5398C0.479492 5.07825 1.61187 6.33361 3.07607 6.56797L8.5175 20.9965C8.28314 21.4281 8.13695 21.9316 8.13695 22.4607C8.13695 24.1592 9.51529 25.5376 11.2139 25.5376C12.9124 25.5376 14.2908 24.1592 14.2908 22.4607C14.2908 21.9432 14.1423 21.4513 13.9218 21.0197L19.3516 6.56797C20.8158 6.33361 21.9482 5.07825 21.9482 3.5398L21.9459 3.54212Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function VisibleIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      {...props}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.91" cy="8.71981" r="1.995" stroke="currentColor" strokeWidth="1.33" />
      <path
        d="M8.91005 4.72974C6.16549 4.72974 3.42093 6.61761 1.97496 7.79617C1.38626 8.276 1.40412 9.14135 2.00567 9.60497C3.5308 10.7804 6.41418 12.7097 8.91005 12.7097C11.4059 12.7097 14.2893 10.7804 15.8144 9.60498C16.416 9.14135 16.4338 8.276 15.8451 7.79617C14.3992 6.61761 11.6546 4.72974 8.91005 4.72974Z"
        stroke="currentColor"
        strokeWidth="1.33"
      />
    </svg>
  )
}

export function XCloseIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M12.5 4L4.5 12M4.5 4L12.5 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

XCloseIcon.src = getSrcFromImport(XCloseImage)

export function SpinnerIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25" />
      <path
        className="opacity-25"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}

SpinnerIcon.src = getSrcFromImport(SpinnerImage)

export function UndoIcon(props: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.37109 9H16.8711C19.3564 9 21.3711 11.0147 21.3711 13.5C21.3711 15.9853 19.3564 18 16.8711 18H12.3711M3.37109 9L7.37109 5M3.37109 9L7.37109 13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RedoIcon(props: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3711 9H7.87109C5.38581 9 3.37109 11.0147 3.37109 13.5C3.37109 15.9853 5.38581 18 7.87109 18H12.3711M21.3711 9L17.3711 5M21.3711 9L17.3711 13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ExpandIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PlusIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00004 3.33203V12.6654M3.33337 7.9987H12.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

PlusIcon.src = getSrcFromImport(PlusImage)

export function MinusIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33337 8H12.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Menu01Icon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 10H18M3 5H18M3 15H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Menu03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 12H21M3 6H21M3 18H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Menu05Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2 5.66675H14M2 10.3334H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BackwardIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1789 10.3516L22 7.94101L12.3578 3.11989C12.2266 3.0543 12.161 3.0215 12.0922 3.0086C12.0313 2.99716 11.9687 2.99716 11.9078 3.0086C11.839 3.0215 11.7734 3.0543 11.6422 3.11989L2 7.94101L6.82111 10.3516"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.935L12 20.9844M12 20.9844L8 16.9646M12 20.9844L16 16.9646"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ForwardIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1789 13.5312L22 15.9418L12.3578 20.7629C12.2266 20.8285 12.161 20.8613 12.0922 20.8742C12.0313 20.8856 11.9687 20.8856 11.9078 20.8742C11.839 20.8613 11.7734 20.8285 11.6422 20.7629L2 15.9418L6.82111 13.5312"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.065L12 3.01562M12 3.01562L8 7.03539M12 3.01562L16 7.03539"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Rocket02Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 15.0002L9 12.0002M12 15.0002C13.3968 14.469 14.7369 13.799 16 13.0002M12 15.0002V20.0002C12 20.0002 15.03 19.4502 16 18.0002C17.08 16.3802 16 13.0002 16 13.0002M9 12.0002C9.53214 10.6197 10.2022 9.29631 11 8.05025C12.1652 6.18723 13.7876 4.6533 15.713 3.59434C17.6384 2.53538 19.8027 1.98662 22 2.00025C22 4.72025 21.22 9.50025 16 13.0002M9 12.0002H4C4 12.0002 4.55 8.97025 6 8.00025C7.62 6.92025 11 8.00025 11 8.00025M4.5 16.5002C3 17.7602 2.5 21.5002 2.5 21.5002C2.5 21.5002 6.24 21.0002 7.5 19.5002C8.21 18.6602 8.2 17.3702 7.41 16.5902C7.02131 16.2193 6.50929 16.0049 5.97223 15.9883C5.43516 15.9717 4.91088 16.154 4.5 16.5002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ToBackIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 7.98047L11.6422 3.13553C11.7734 3.06961 11.839 3.03665 11.9078 3.02368C11.9687 3.01219 12.0313 3.01219 12.0922 3.02368C12.161 3.03665 12.2266 3.06961 12.3578 3.13553L22 7.98047"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.9389L12 21.9883M12 21.9883L8 17.9685M12 21.9883L16 17.9685"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1789 13.9492L22 11.5267L12.3578 6.68181C12.2266 6.61589 12.161 6.58293 12.0922 6.56996C12.0313 6.55847 11.9687 6.55847 11.9078 6.56996C11.839 6.58293 11.7734 6.61589 11.6422 6.68181L2 11.5267L6.82111 13.9492"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ToFrontIcon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.46631 14.1875L10.5015 18.225C10.6108 18.2799 10.6655 18.3073 10.7228 18.3182C10.7736 18.3277 10.8257 18.3277 10.8765 18.3182C10.9338 18.3073 10.9885 18.2799 11.0978 18.225L19.133 14.1875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8 10.8867L10.8 2.51221M10.8 2.51221L7.46663 5.86202M10.8 2.51221L14.1333 5.86202"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1154 9.21191L19.133 11.2306L11.0978 15.2681C10.9885 15.323 10.9338 15.3505 10.8765 15.3613C10.8257 15.3709 10.7736 15.3709 10.7228 15.3613C10.6655 15.3505 10.6108 15.323 10.5015 15.2681L2.46631 11.2306L6.4839 9.21191"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TickIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6L9 17L4 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SearchIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SearchSmIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SearchMdIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LayersThree01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 11.9996L11.6422 16.8207C11.7734 16.8863 11.839 16.9191 11.9078 16.932C11.9687 16.9434 12.0313 16.9434 12.0922 16.932C12.161 16.9191 12.2266 16.8863 12.3578 16.8207L22 11.9996M2 16.9996L11.6422 21.8207C11.7734 21.8863 11.839 21.9191 11.9078 21.932C11.9687 21.9434 12.0313 21.9434 12.0922 21.932C12.161 21.9191 12.2266 21.8863 12.3578 21.8207L22 16.9996M2 6.99958L11.6422 2.17846C11.7734 2.11287 11.839 2.08008 11.9078 2.06717C11.9687 2.05574 12.0313 2.05574 12.0922 2.06717C12.161 2.08008 12.2266 2.11287 12.3578 2.17846L22 6.99958L12.3578 11.8207C12.2266 11.8863 12.161 11.9191 12.0922 11.932C12.0313 11.9434 11.9687 11.9434 11.9078 11.932C11.839 11.9191 11.7734 11.8863 11.6422 11.8207L2 6.99958Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Settings03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.0505 9H5.5C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4H15.0505M8.94949 20H18.5C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15H8.94949M3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14C4.567 14 3 15.567 3 17.5ZM21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Settings04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Share01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V12M16 7L12 3M12 3L8 7M12 3V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ShoppingCart03Icon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66613 11.6665H15.6126C16.4566 11.6665 16.8786 11.6665 17.2146 11.5091C17.5105 11.3705 17.7592 11.148 17.9296 10.8691C18.1231 10.5526 18.1697 10.1332 18.2629 9.29432L18.7504 4.90679C18.7789 4.65057 18.7931 4.52246 18.7519 4.4233C18.7157 4.33622 18.6511 4.26398 18.5685 4.2184C18.4745 4.1665 18.3456 4.1665 18.0878 4.1665H4.24947M2.16602 1.6665H3.20638C3.4269 1.6665 3.53716 1.6665 3.62342 1.70844C3.69936 1.74536 3.7623 1.80448 3.80388 1.87797C3.85112 1.96145 3.85799 2.0715 3.87175 2.29159L4.62695 14.3748C4.6407 14.5948 4.64758 14.7049 4.69482 14.7884C4.7364 14.8619 4.79933 14.921 4.87528 14.9579C4.96154 14.9998 5.0718 14.9998 5.29232 14.9998H16.3327M6.74935 17.9165H6.75768M14.2493 17.9165H14.2577M7.16602 17.9165C7.16602 18.1466 6.97947 18.3332 6.74935 18.3332C6.51923 18.3332 6.33268 18.1466 6.33268 17.9165C6.33268 17.6864 6.51923 17.4998 6.74935 17.4998C6.97947 17.4998 7.16602 17.6864 7.16602 17.9165ZM14.666 17.9165C14.666 18.1466 14.4795 18.3332 14.2493 18.3332C14.0192 18.3332 13.8327 18.1466 13.8327 17.9165C13.8327 17.6864 14.0192 17.4998 14.2493 17.4998C14.4795 17.4998 14.666 17.6864 14.666 17.9165Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Hash01Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 8H20M4 16H20M8 3V21M16 3V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CheckIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      {...props}
      viewBox="0 0 18 14"
      fill="none"
    >
      <path
        d="M5.79508 10.875L1.62508 6.70504L0.205078 8.11504L5.79508 13.705L17.7951 1.70504L16.3851 0.295044L5.79508 10.875Z"
        fill="currentColor"
      />
    </svg>
  )
}

CheckIcon.src = getSrcFromImport(CheckImage)

export function CheckCircleIcon(props: IconProps) {
  return (
    <svg {...props} width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
      />
    </svg>
  )
}

export function CheckCircleBrokenIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.6668 7.3904V8.00373C14.666 9.44135 14.2005 10.8402 13.3397 11.9916C12.4789 13.1431 11.269 13.9854 9.8904 14.393C8.51178 14.8006 7.03834 14.7517 5.68981 14.2535C4.34128 13.7552 3.18993 12.8345 2.40747 11.6284C1.62501 10.4224 1.25336 8.99578 1.34795 7.56128C1.44254 6.12678 1.9983 4.76129 2.93235 3.66845C3.8664 2.57561 5.12869 1.81399 6.53096 1.49717C7.93322 1.18034 9.40034 1.32529 10.7135 1.9104M14.6668 2.66659L8.00016 9.33992L6.00016 7.33992"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CheckCircleInvertedIcon(props: IconProps) {
  return (
    <svg {...props} width="21" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
      <path
        d="M10.2503 2.4165C5.65033 2.4165 1.91699 6.14984 1.91699 10.7498C1.91699 15.3498 5.65033 19.0832 10.2503 19.0832C14.8503 19.0832 18.5837 15.3498 18.5837 10.7498C18.5837 6.14984 14.8503 2.4165 10.2503 2.4165ZM10.2503 17.4165C6.57533 17.4165 3.58366 14.4248 3.58366 10.7498C3.58366 7.07484 6.57533 4.08317 10.2503 4.08317C13.9253 4.08317 16.917 7.07484 16.917 10.7498C16.917 14.4248 13.9253 17.4165 10.2503 17.4165ZM13.4837 7.65817L8.58366 12.5582L7.01699 10.9915C6.69199 10.6665 6.16699 10.6665 5.84199 10.9915C5.51699 11.3165 5.51699 11.8415 5.84199 12.1665L8.00033 14.3248C8.32533 14.6498 8.85033 14.6498 9.17533 14.3248L14.667 8.83317C14.992 8.50817 14.992 7.98317 14.667 7.65817C14.342 7.33317 13.8087 7.33317 13.4837 7.65817Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Settings02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      {...props}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.3951 19.3731L9.97955 20.6875C10.1533 21.0788 10.4368 21.4112 10.7958 21.6446C11.1547 21.8779 11.5737 22.002 12.0018 22.002C12.4299 22.002 12.8488 21.8779 13.2078 21.6446C13.5667 21.4112 13.8503 21.0788 14.024 20.6875L14.6084 19.3731C14.8165 18.9067 15.1664 18.5178 15.6084 18.262C16.0532 18.0054 16.5678 17.8961 17.0784 17.9497L18.5084 18.102C18.9341 18.147 19.3637 18.0675 19.7451 17.8733C20.1265 17.679 20.4434 17.3783 20.6573 17.0075C20.8715 16.637 20.9735 16.2122 20.9511 15.7848C20.9286 15.3574 20.7825 14.9458 20.5307 14.5997L19.684 13.4364C19.3825 13.0191 19.2214 12.5168 19.224 12.002C19.2239 11.4885 19.3865 10.9883 19.6884 10.5731L20.5351 9.40973C20.787 9.06371 20.933 8.65202 20.9555 8.22463C20.978 7.79723 20.8759 7.37249 20.6618 7.00195C20.4479 6.63119 20.131 6.33044 19.7496 6.13618C19.3681 5.94192 18.9386 5.86248 18.5129 5.90751L17.0829 6.05973C16.5722 6.11336 16.0577 6.00407 15.6129 5.74751C15.17 5.49021 14.82 5.09931 14.6129 4.63084L14.024 3.3164C13.8503 2.92512 13.5667 2.59267 13.2078 2.35935C12.8488 2.12604 12.4299 2.00188 12.0018 2.00195C11.5737 2.00188 11.1547 2.12604 10.7958 2.35935C10.4368 2.59267 10.1533 2.92512 9.97955 3.3164L9.3951 4.63084C9.18803 5.09931 8.83798 5.49021 8.3951 5.74751C7.95032 6.00407 7.43577 6.11336 6.9251 6.05973L5.49066 5.90751C5.06499 5.86248 4.6354 5.94192 4.25397 6.13618C3.87255 6.33044 3.55567 6.63119 3.34177 7.00195C3.12759 7.37249 3.02555 7.79723 3.04804 8.22463C3.07052 8.65202 3.21656 9.06371 3.46844 9.40973L4.3151 10.5731C4.61704 10.9883 4.77964 11.4885 4.77955 12.002C4.77964 12.5154 4.61704 13.0156 4.3151 13.4308L3.46844 14.5942C3.21656 14.9402 3.07052 15.3519 3.04804 15.7793C3.02555 16.2067 3.12759 16.6314 3.34177 17.002C3.55589 17.3725 3.8728 17.6731 4.25417 17.8673C4.63554 18.0616 5.06502 18.1411 5.49066 18.0964L6.92066 17.9442C7.43133 17.8905 7.94587 17.9998 8.39066 18.2564C8.83519 18.513 9.18687 18.9039 9.3951 19.3731Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.002C13.6568 15.002 15 13.6588 15 12.002C15 10.3451 13.6568 9.00195 12 9.00195C10.3431 9.00195 8.99998 10.3451 8.99998 12.002C8.99998 13.6588 10.3431 15.002 12 15.002Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StudioIcon(props: IconProps) {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M14.6415 27.8643C14.1471 27.8643 13.7133 27.5657 13.5361 27.104L11.092 20.7528C10.6613 19.6303 10.5276 19.31 10.327 19.0301C10.1327 18.7565 9.89327 18.5155 9.61342 18.3149C9.33512 18.119 9.01484 17.9838 7.8892 17.55L1.54111 15.1075C1.08557 14.9333 0.779297 14.4871 0.779297 14.0005C0.779297 13.5139 1.08401 13.0707 1.54111 12.8951L7.8892 10.451C8.99152 10.0281 9.33201 9.8866 9.61186 9.68604C9.89327 9.48859 10.1327 9.24604 10.327 8.97085C10.5245 8.69099 10.6691 8.35361 11.092 7.24973L13.5361 0.896997C13.7102 0.443008 14.1533 0.136719 14.6415 0.136719C15.1297 0.136719 15.5744 0.441453 15.7485 0.896997L18.191 7.24973C18.6248 8.37382 18.76 8.6941 18.9559 8.97085C19.1534 9.25071 19.3959 9.4917 19.6742 9.68604C19.9525 9.88349 20.2899 10.0281 21.3954 10.451L27.7465 12.8951C28.2005 13.0692 28.5068 13.5123 28.5068 14.0005C28.5068 14.4887 28.2021 14.9333 27.7465 15.1075L21.3954 17.55C20.2682 17.9838 19.9494 18.119 19.6742 18.3149C19.3959 18.5108 19.155 18.7534 18.9559 19.0286C18.7616 19.3053 18.6248 19.624 18.191 20.7528L15.7485 27.104C15.5744 27.558 15.1312 27.8643 14.6415 27.8643Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TagIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon_2"
        d="M8 8H8.01M2 5.2L2 9.67451C2 10.1637 2 10.4083 2.05526 10.6385C2.10425 10.8425 2.18506 11.0376 2.29472 11.2166C2.4184 11.4184 2.59135 11.5914 2.93726 11.9373L10.6059 19.6059C11.7939 20.7939 12.388 21.388 13.0729 21.6105C13.6755 21.8063 14.3245 21.8063 14.927 21.6105C15.612 21.388 16.2061 20.7939 17.3941 19.6059L19.6059 17.3941C20.7939 16.2061 21.388 15.612 21.6105 14.927C21.8063 14.3245 21.8063 13.6755 21.6105 13.0729C21.388 12.388 20.7939 11.7939 19.6059 10.6059L11.9373 2.93726C11.5914 2.59135 11.4184 2.4184 11.2166 2.29472C11.0376 2.18506 10.8425 2.10425 10.6385 2.05526C10.4083 2 10.1637 2 9.67452 2L5.2 2C4.0799 2 3.51984 2 3.09202 2.21799C2.7157 2.40973 2.40973 2.71569 2.21799 3.09202C2 3.51984 2 4.07989 2 5.2ZM8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 7.72386 7.72386 7.5 8 7.5C8.27614 7.5 8.5 7.72386 8.5 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TransferIcon(props: IconProps) {
  return (
    <svg
      width="23"
      height="26"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23 26"
      fill="none"
    >
      <path
        d="M22.1814 7.22425L16.2991 1.35585C15.3755 0.525133 13.2964 0.585465 13.2964 2.91055V3.20292L13.25 23.9802C13.25 24.6276 13.7883 25.1357 14.4357 25.1357H15.9904C16.6378 25.1357 17.1599 24.6276 17.146 23.9802V7.44005L19.5477 9.84171C19.9793 10.2733 20.687 10.2733 21.1186 9.84171L22.1651 8.79519C22.5967 8.36359 22.5967 7.65585 22.1651 7.22425H22.1814Z"
        fill="currentColor"
      />
      <path
        d="M0.819177 18.7585L6.7015 24.6269C7.62503 25.4576 9.70415 25.3973 9.70415 23.0722V22.7799L9.75056 2.00262C9.75056 1.37146 9.21222 0.863281 8.56481 0.863281H7.01012C6.36271 0.863281 5.84061 1.37146 5.85454 2.01886V18.559L3.45288 16.1573C3.02128 15.7257 2.31354 15.7257 1.88194 16.1573L0.83542 17.2038C0.403818 17.6354 0.403818 18.3432 0.83542 18.7748L0.819177 18.7585Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FileConverterIcon(props: IconProps) {
  return (
    <svg
      width="26"
      height="20"
      viewBox="0 0 26 20"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53745 0.801797C9.87205 0.972672 10.0826 1.31668 10.0826 1.69239V3.88765H14.1736C14.7258 3.88765 15.1736 4.33537 15.1736 4.88765C15.1736 5.43994 14.7258 5.88765 14.1736 5.88765H9.08264C8.53036 5.88765 8.08264 5.43994 8.08264 4.88765V3.65056L2.72485 7.52825L8.08264 11.2756V10.1967C8.08264 9.64443 8.53036 9.19671 9.08264 9.19671H15.9174V7.0506C15.9174 6.67634 16.1263 6.3334 16.459 6.16185C16.7916 5.99029 17.1922 6.01884 17.4971 6.23583L25.5798 11.9873C25.8464 12.177 26.0033 12.4851 25.9999 12.8123C25.9966 13.1395 25.8334 13.4444 25.563 13.6286L17.4803 19.1342C17.174 19.3429 16.7775 19.365 16.4499 19.1918C16.1223 19.0186 15.9174 18.6784 15.9174 18.3078V16.3583H11.876C11.3237 16.3583 10.876 15.9106 10.876 15.3583C10.876 14.806 11.3237 14.3583 11.876 14.3583H16.9174C17.4696 14.3583 17.9174 14.806 17.9174 15.3583V16.4166L23.25 12.7842L17.9174 8.98952V10.1967C17.9174 10.749 17.4696 11.1967 16.9174 11.1967H10.0826V13.1953C10.0826 13.5682 9.87526 13.91 9.54463 14.0822C9.21399 14.2545 8.815 14.2285 8.5095 14.0148L0.426857 8.36164C0.161681 8.17617 0.00264577 7.87385 3.27011e-05 7.55026C-0.00258043 7.22667 0.151552 6.92182 0.413698 6.73209L8.49634 0.882295C8.8007 0.662015 9.20285 0.630922 9.53745 0.801797Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ImageCompressorIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6094 5.32803H4.60938C3.64288 5.32803 2.85938 6.11153 2.85938 7.07803V18.7411C2.86417 18.7359 2.8691 18.7306 2.87402 18.7255L5.10938 16.413C5.47722 16.0326 6.08691 16.0309 6.45703 16.4091L7.75293 17.7333C8.14329 18.1318 8.79288 18.1046 9.14844 17.6747L12.8545 13.1923C13.2151 12.7562 13.8763 12.7359 14.2637 13.1483L18.3545 17.5028C18.356 17.5044 18.3579 17.5061 18.3594 17.5077V12.078H20.8594V19.078C20.8594 21.4252 18.9566 23.328 16.6094 23.328H4.60938C2.26217 23.328 0.359375 21.4252 0.359375 19.078V7.07803C0.359375 4.73082 2.26216 2.82803 4.60938 2.82803H11.6094V5.32803ZM8.24902 11.078C9.09234 11.0781 9.77637 11.762 9.77637 12.6054C9.77625 13.4486 9.09227 14.1326 8.24902 14.1327C7.40568 14.1327 6.72179 13.4487 6.72168 12.6054C6.72168 11.762 7.40561 11.078 8.24902 11.078ZM21.5068 0.366117C21.995 -0.122039 22.7872 -0.122039 23.2754 0.366117C23.7633 0.854221 23.7633 1.64559 23.2754 2.13369L17.7979 7.61123L21.123 7.61026C21.8131 7.61043 22.3728 8.17022 22.373 8.86026C22.3731 9.55051 21.8133 10.1101 21.123 10.1103L14.7803 10.1112C14.4488 10.1112 14.1309 9.97932 13.8965 9.74502C13.6622 9.5107 13.5304 9.19261 13.5303 8.86123V2.51846C13.5303 1.82815 14.09 1.26852 14.7803 1.26846C15.4706 1.26847 16.0303 1.8281 16.0303 2.51846V5.84268L21.5068 0.366117Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LogoCreatorIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0385 2L22 2L22 7C22 9.76142 19.7614 12 17 12L7 12C4.23858 12 2 9.76142 2 7L2 2L7 2C9.76143 2 12 4.23858 12 7L12 17C12 19.7614 9.76142 22 7 22L2 22L2 17.0962C2 14.3347 4.23858 12.0962 7 12.0962L17 12.0962C19.7614 12.0962 22 14.3347 22 17.0962L22 22L17.0962 22C14.3347 22 12.0962 19.7614 12.0962 17L12.0962 12.0962"
        stroke="currentColor"
        strokeWidth="2.5"
      />
    </svg>
  )
}

export function TrashIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Cursor02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      {...props}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5054 10.7783C21.1223 10.5384 21.4308 10.4184 21.5174 10.2488C21.5924 10.1019 21.5901 9.92739 21.5112 9.78247C21.4202 9.61519 21.1087 9.50337 20.4857 9.27973L4.59605 3.57573C4.08635 3.39276 3.8315 3.30128 3.6649 3.35898C3.52005 3.40914 3.40621 3.52297 3.35605 3.66783C3.29835 3.83443 3.38983 4.08928 3.5728 4.59898L9.27675 20.4887C9.50039 21.1117 9.61221 21.4232 9.77949 21.5142C9.92441 21.5931 10.0989 21.5954 10.2458 21.5203C10.4154 21.4337 10.5354 21.1253 10.7753 20.5084L13.3722 13.8308C13.4191 13.7099 13.4426 13.6495 13.4789 13.5986C13.5111 13.5535 13.5505 13.5141 13.5956 13.4819C13.6465 13.4456 13.7069 13.4221 13.8278 13.3751L20.5054 10.7783Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Brush02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.99997 11.2214L12.7778 14.9992M7.97485 20.9741C6.60801 22.3409 4 21.9992 2 21.9992C3.0251 19.9992 1.65827 17.3912 3.0251 16.0243C4.39194 14.6575 6.60801 14.6575 7.97485 16.0243C9.34168 17.3912 9.34168 19.6072 7.97485 20.9741ZM11.9216 15.9238L21.0587 6.05574C21.8635 5.18657 21.8375 3.83679 20.9999 2.9992C20.1624 2.1616 18.8126 2.13565 17.9434 2.94044L8.07534 12.0775C7.5654 12.5497 7.31043 12.7858 7.16173 13.0376C6.80514 13.6413 6.79079 14.3877 7.12391 15.0048C7.26283 15.2621 7.50853 15.5078 7.99995 15.9992C8.49136 16.4906 8.73707 16.7363 8.99438 16.8752C9.6114 17.2083 10.3578 17.194 10.9616 16.8374C11.2134 16.6887 11.4494 16.4337 11.9216 15.9238Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Pencil01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 21.5L8.04927 19.3657C8.40421 19.2291 8.58168 19.1609 8.74772 19.0718C8.8952 18.9926 9.0358 18.9012 9.16804 18.7986C9.31692 18.6831 9.45137 18.5486 9.72028 18.2797L21 7C22.1046 5.89543 22.1046 4.10457 21 3C19.8955 1.89543 18.1046 1.89543 17 2.99999L5.72028 14.2797C5.45138 14.5486 5.31692 14.6831 5.20139 14.832C5.09877 14.9642 5.0074 15.1048 4.92823 15.2523C4.83911 15.4183 4.77085 15.5958 4.63433 15.9507L2.5 21.5ZM2.5 21.5L4.55812 16.149C4.7054 15.766 4.77903 15.5746 4.90534 15.4869C5.01572 15.4102 5.1523 15.3813 5.2843 15.4065C5.43533 15.4353 5.58038 15.5804 5.87048 15.8705L8.12957 18.1295C8.41967 18.4196 8.56472 18.5647 8.59356 18.7157C8.61877 18.8477 8.58979 18.9843 8.51314 19.0947C8.42545 19.221 8.23399 19.2946 7.85107 19.4419L2.5 21.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Tv03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 3L12 7L7 3M6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V11.8C22 10.1198 22 9.27976 21.673 8.63803C21.3854 8.07354 20.9265 7.6146 20.362 7.32698C19.7202 7 18.8802 7 17.2 7H6.8C5.11984 7 4.27976 7 3.63803 7.32698C3.07354 7.6146 2.6146 8.07354 2.32698 8.63803C2 9.27976 2 10.1198 2 11.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Contrast02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2C12.5917 2 13.1713 2.05139 13.7348 2.14994M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22M12 2V22M17.738 3.809C18.6922 4.47869 19.5241 5.31089 20.1934 6.26541M21.8501 10.2656C21.9486 10.8289 22 11.4085 22 12C22 12.5915 21.9486 13.1711 21.8501 13.7344M20.1892 17.7406C19.5203 18.693 18.6896 19.5233 17.7369 20.1917M13.7328 21.8504C13.17 21.9487 12.591 22 12 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DotsVerticalIcon({ strokeWidth, ...props }: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke="currentColor"
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke="currentColor"
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PositionIndicatorUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="7"
      {...props}
      viewBox="0 0 24 7"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8284 1.82842L17.6569 4.65685C19.1571 6.15714 21.192 7 23.3137 7L0.686291 7C2.80802 7 4.84285 6.15715 6.34314 4.65686L9.17157 1.82843C10.7337 0.266329 13.2663 0.266326 14.8284 1.82842Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LightBulb05Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M10 13.5H14M12 13.5V18.5M15.5 16.874C17.0141 15.7848 18 14.0075 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 14.0075 6.98593 15.7848 8.5 16.874V18.8C8.5 19.9201 8.5 20.4802 8.71799 20.908C8.90973 21.2843 9.21569 21.5903 9.59202 21.782C10.0198 22 10.5799 22 11.7 22H12.3C13.4201 22 13.9802 22 14.408 21.782C14.7843 21.5903 15.0903 21.2843 15.282 20.908C15.5 20.4802 15.5 19.9201 15.5 18.8V16.874Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlertTriangleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="22"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 9.00023V13.0002M11.9998 17.0002H12.0098M10.6151 3.89195L2.39019 18.0986C1.93398 18.8866 1.70588 19.2806 1.73959 19.6039C1.769 19.886 1.91677 20.1423 2.14613 20.309C2.40908 20.5002 2.86435 20.5002 3.77487 20.5002H20.2246C21.1352 20.5002 21.5904 20.5002 21.8534 20.309C22.0827 20.1423 22.2305 19.886 22.2599 19.6039C22.2936 19.2806 22.0655 18.8866 21.6093 18.0986L13.3844 3.89195C12.9299 3.10679 12.7026 2.71421 12.4061 2.58235C12.1474 2.46734 11.8521 2.46734 11.5935 2.58235C11.2969 2.71421 11.0696 3.10679 10.6151 3.89195Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SearchMissingIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function GenieChatIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="24"
      {...props}
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.17552 14.167C7.57856 13.7957 7.14903 13.2861 6.86511 12.6746C6.68311 12.2888 6.54478 11.8811 6.47926 11.4297C6.45742 11.204 6.45014 11.0075 6.45742 10.8109C6.50839 9.54417 6.68311 8.39392 7.21455 7.35287C7.64408 6.49382 8.19736 5.7367 8.93265 5.12517C9.36217 4.75389 9.83538 4.46996 10.3887 4.3098C10.9201 4.14964 11.4734 4.10596 11.983 4.3098C12.5581 4.53548 12.9876 5.11061 12.8639 5.86774C12.8056 6.39918 12.5144 6.79231 12.1286 7.15631C12.0048 7.28007 11.7428 7.28007 11.619 7.15631C11.4952 7.03255 11.5171 6.82871 11.6627 6.66855C11.8447 6.42102 12.0121 6.18078 12.0121 5.85318C12.034 5.46733 11.6627 5.17613 11.2768 5.25621C10.5779 5.41637 10.0465 5.8095 9.59513 6.34094C9.16561 6.81415 8.89625 7.38199 8.63417 7.95712C8.45217 8.3284 8.38664 8.73609 8.30656 9.12193C8.26288 9.36945 8.22648 9.59514 8.20464 9.82082C8.16096 10.2067 8.20464 10.5998 8.24832 10.9856C8.292 11.255 8.3284 11.4952 8.40848 11.7428C8.53224 12.114 8.73609 12.398 9.00545 12.6673C9.23113 12.893 9.51505 12.9949 9.84266 12.9949C10.112 12.9949 10.3304 12.893 10.5561 12.7911C11.5171 12.3179 12.1941 11.5826 12.5654 10.5779C12.6236 10.3741 12.6673 10.1703 12.6673 9.94458C12.6673 9.67522 12.398 9.49321 12.0704 9.55873C11.8447 9.60242 11.6408 9.6825 11.437 9.76258C11.1094 9.92274 10.7599 10.0319 10.3959 10.0319C10.0902 10.0101 9.88634 9.84994 9.79898 9.60242C9.74074 9.37673 9.84266 9.07097 10.0683 8.90353C10.4979 8.59776 10.9929 8.41576 11.5244 8.3284C11.932 8.28472 12.3616 8.28472 12.7547 8.43032C13.126 8.55408 13.4317 8.80161 13.6137 9.16561C13.8394 9.59514 13.8176 10.0465 13.7593 10.5197C13.6574 11.073 13.4099 11.5608 13.1478 12.0776C12.7401 12.8566 12.1068 13.4317 11.4079 13.9413C10.9201 14.2908 10.3668 14.5383 9.74802 14.5529C9.17289 14.5601 8.64145 14.4582 8.17552 14.167ZM17.5959 0H2.75915C1.5725 0 0.00728052 1.54338 0.00728052 3.43619V14.7713C0.00728052 15.077 0.254804 15.3318 0.567847 15.3318C0.88089 15.3318 1.12841 15.0843 1.12841 14.7713V3.43619C1.12841 2.1549 2.18402 1.11385 2.75915 1.11385H17.5959C18.8991 1.11385 19.9547 2.46794 19.9547 3.74924V14.7785C19.9547 16.0598 18.8991 17.1009 17.5959 17.1009H13.075C12.9513 17.1009 12.8493 17.181 12.8202 17.2101C12.7838 17.2538 12.7547 17.3047 12.7547 17.3047C12.7328 17.3411 12.711 17.3848 12.6964 17.4285C12.6892 17.4358 12.296 18.4113 11.8956 18.9719C11.5098 19.5179 11.2259 19.8528 10.3013 19.9547C9.72618 20.0129 8.99817 19.8528 8.46672 19.729C8.1828 19.6635 7.93528 19.6125 7.73872 19.5907C7.72416 19.5907 7.71688 19.5907 7.70232 19.5907C7.65863 19.5907 7.62224 19.5907 7.57856 19.5907C5.75126 19.5907 5.32901 20.7773 5.23437 21.4981C5.21253 21.6946 5.24165 21.9276 5.30717 22.1897C4.65197 21.6873 4.3462 21.1122 4.49181 20.5808L4.51364 20.4934C4.65197 19.9838 4.73933 19.678 5.75854 19.0956C6.12254 18.9427 6.52294 18.7462 6.86511 18.5715C7.21455 18.3967 7.54216 18.2366 7.7096 18.1783C8.0008 18.0764 8.16096 17.7634 8.05904 17.4722C8.00808 17.3193 7.928 17.2028 7.78968 17.1446C7.72416 17.1154 7.70232 17.1082 7.62951 17.1082C7.59311 17.1082 7.54215 17.1082 7.48391 17.1082H7.12719H6.67583H2.75187C1.47058 17.1082 1.12113 16.0453 1.12113 14.7858C1.12113 14.4801 0.87361 14.2253 0.560566 14.2253C0.247523 14.2253 0 14.4728 0 14.7858C0 16.6786 0.82993 18.222 2.75187 18.222H5.03781C3.86572 18.9282 3.64004 19.4669 3.44348 20.1949L3.42163 20.2823C3.01395 21.7237 4.10596 23.1361 6.26086 23.966C6.32638 23.9951 6.72679 24.0752 6.88695 23.8058C7.01071 23.602 7.06167 23.369 6.94519 23.1579C6.50111 22.4081 6.33366 21.7893 6.34822 21.6437C6.40646 21.1704 6.60303 20.6972 7.65136 20.7191C7.7824 20.7336 7.99352 20.7846 8.22648 20.8356C8.83801 20.9739 9.66794 21.1559 10.4251 21.0831C11.7937 20.9375 12.3179 20.3405 12.8202 19.6344C13.1187 19.2121 13.4026 18.6224 13.5846 18.2293H17.6032C19.5179 18.2293 21.0831 16.6859 21.0831 14.7931V3.75652C21.0758 1.85642 19.5179 0 17.5959 0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function GenieIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="24"
      {...props}
      viewBox="0 0 21.1 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="clippath">
          <rect className="cls-1" width="21.1" height="24" fill="none" />
        </clipPath>
      </defs>
      <g className="cls-2" clipPath="url(#clippath)">
        <g>
          <path
            className="cls-4"
            d="M17.61,0H2.76C1.57,0,0,1.54,0,3.44V14.79c0,1.89,.83,3.44,2.75,3.44h2.29c-1.17,.71-1.4,1.24-1.59,1.97l-.02,.09c-.41,1.44,.68,2.85,2.84,3.68,.07,.03,.47,.11,.63-.16,.12-.2,.17-.44,.06-.65-.44-.75-.61-1.37-.6-1.51,.06-.47,.25-.95,1.3-.92,.13,.01,.34,.07,.58,.12,.61,.14,1.44,.32,2.2,.25,1.37-.15,1.89-.74,2.4-1.45,.3-.42,.58-1.01,.76-1.41h4.02c1.91,0,3.48-1.54,3.48-3.44V3.76c0-1.9-1.57-3.76-3.49-3.76Z"
            fill="#8559f9"
          />
          <path
            className="cls-3"
            d="M12.75,8.41c-.39-.14-.82-.14-1.23-.1-.54,.09-1.03,.27-1.46,.58-.23,.17-.33,.47-.27,.7,.09,.25,.29,.41,.6,.43,.36,0,.71-.11,1.04-.27,.2-.08,.4-.16,.63-.2,.33-.06,.6,.12,.6,.39,0,.22-.04,.43-.1,.63-.37,1-1.05,1.74-2.01,2.21-.22,.1-.44,.2-.71,.2-.33,0-.61-.1-.84-.33-.27-.26-.48-.55-.6-.92-.08-.25-.12-.49-.16-.76-.04-.38-.08-.77-.04-1.16,.02-.23,.06-.45,.1-.7,.08-.38,.15-.79,.33-1.16,.26-.58,.53-1.15,.96-1.62,.45-.53,.98-.92,1.68-1.08,.39-.08,.76,.21,.74,.6,0,.33-.17,.57-.35,.82-.14,.16-.16,.37-.04,.49,.12,.12,.39,.12,.51,0,.39-.37,.68-.76,.74-1.29,.12-.76-.3-1.33-.88-1.56-.51-.2-1.06-.16-1.59,0-.56,.16-1.03,.45-1.46,.82-.74,.61-1.29,1.37-1.72,2.23-.53,1.04-.71,2.19-.76,3.46-.01,.2,0,.39,.02,.62,.07,.45,.21,.85,.39,1.24,.28,.61,.71,1.12,1.31,1.49,.46,.3,.99,.36,1.57,.36,.62-.01,1.17-.26,1.66-.61,.7-.51,1.33-1.08,1.74-1.86,.26-.52,.51-1.01,.61-1.56,.05-.47,.08-.92-.15-1.35-.18-.37-.49-.62-.86-.74h0Z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  )
}

export function Globe01Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66602 10.0001H18.3327M1.66602 10.0001C1.66602 14.6025 5.39698 18.3334 9.99935 18.3334M1.66602 10.0001C1.66602 5.39771 5.39698 1.66675 9.99935 1.66675M18.3327 10.0001C18.3327 14.6025 14.6017 18.3334 9.99935 18.3334M18.3327 10.0001C18.3327 5.39771 14.6017 1.66675 9.99935 1.66675M9.99935 1.66675C12.0837 3.94871 13.2683 6.91011 13.3327 10.0001C13.2683 13.0901 12.0837 16.0515 9.99935 18.3334M9.99935 1.66675C7.91495 3.94871 6.73039 6.91011 6.66602 10.0001C6.73039 13.0901 7.91495 16.0515 9.99935 18.3334"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ThumbsUpIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66659 14.6663V7.33301M1.33325 8.66634V13.333C1.33325 14.0694 1.93021 14.6663 2.66659 14.6663H11.6174C12.6046 14.6663 13.4441 13.9461 13.5942 12.9705L14.3121 8.30379C14.4985 7.09227 13.5611 5.99967 12.3354 5.99967H9.99992C9.63173 5.99967 9.33325 5.7012 9.33325 5.33301V2.9769C9.33325 2.069 8.59726 1.33301 7.68936 1.33301C7.47281 1.33301 7.27657 1.46054 7.18862 1.65842L4.84254 6.9371C4.73554 7.17785 4.4968 7.33301 4.23334 7.33301H2.66659C1.93021 7.33301 1.33325 7.92996 1.33325 8.66634Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ThumbsUpFilledIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0977 2.18352C10.35 1.61585 10.913 1.25 11.5342 1.25C13.3103 1.25 14.75 2.68978 14.75 4.46584V8C14.75 8.13807 14.862 8.25 15.0001 8.25H18.5032C20.8015 8.25 22.5591 10.2986 22.2096 12.5702L21.1327 19.5702C20.8512 21.3996 19.2772 22.75 17.4263 22.75H8.5C8.30109 22.75 8.11032 22.671 7.96967 22.5303C7.82902 22.3897 7.75 22.1989 7.75 22V8.00002C7.75 7.90152 7.7694 7.80399 7.80709 7.71299L10.0902 2.20111L10.0977 2.18352Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.16957 10.25L5.5 10.25C5.91421 10.25 6.25 10.5858 6.25 11V22C6.25 22.4142 5.91421 22.75 5.5 22.75H5.16955C4.6354 22.75 4.18956 22.75 3.82533 22.7203C3.44545 22.6892 3.08879 22.6221 2.75153 22.4503C2.23408 22.1866 1.81338 21.7659 1.54973 21.2485C1.37789 20.9112 1.31078 20.5546 1.27974 20.1747C1.24998 19.8104 1.24999 19.3646 1.25 18.8304V14.1696C1.24999 13.6354 1.24998 13.1896 1.27974 12.8253C1.31078 12.4454 1.37789 12.0888 1.54973 11.7515C1.81338 11.2341 2.23408 10.8134 2.75153 10.5497C3.08879 10.3779 3.44545 10.3108 3.82533 10.2797C4.18956 10.25 4.63541 10.25 5.16957 10.25Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ThumbsUpFilledIconTwo(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5939 12.9705C13.4438 13.9461 12.6043 14.6663 11.6172 14.6663H2.66634C1.92996 14.6663 1.33301 14.0694 1.33301 13.333V8.66634C1.33301 7.92996 1.92996 7.33301 2.66634 7.33301H4.23309C4.49655 7.33301 4.7353 7.17785 4.8423 6.9371L7.18838 1.65842C7.27633 1.46054 7.47257 1.33301 7.68912 1.33301C8.59701 1.33301 9.33301 2.069 9.33301 2.9769V5.33301C9.33301 5.7012 9.63148 5.99967 9.99967 5.99967H12.3351C13.5609 5.99967 14.4982 7.09227 14.3119 8.30379L13.5939 12.9705Z"
        fill="currentColor"
      />
      <path
        d="M4.66634 14.6663V7.33301M1.33301 8.66634V13.333C1.33301 14.0694 1.92996 14.6663 2.66634 14.6663H11.6172C12.6043 14.6663 13.4438 13.9461 13.5939 12.9705L14.3119 8.30379C14.4982 7.09227 13.5609 5.99967 12.3351 5.99967H9.99967C9.63148 5.99967 9.33301 5.7012 9.33301 5.33301V2.9769C9.33301 2.069 8.59701 1.33301 7.68912 1.33301C7.47257 1.33301 7.27633 1.46054 7.18838 1.65842L4.8423 6.9371C4.7353 7.17785 4.49655 7.33301 4.23309 7.33301H2.66634C1.92996 7.33301 1.33301 7.92996 1.33301 8.66634Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ThumbsDownIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 1.33301V8.66634M14.6666 6.53301V3.46634C14.6666 2.7196 14.6666 2.34624 14.5213 2.06102C14.3935 1.81014 14.1895 1.60616 13.9386 1.47833C13.6534 1.33301 13.28 1.33301 12.5333 1.33301H5.41196C4.43764 1.33301 3.95048 1.33301 3.55701 1.5113C3.21022 1.66843 2.91549 1.92129 2.70745 2.24015C2.4714 2.60194 2.39732 3.08343 2.24917 4.04642L1.90045 6.31309C1.70505 7.58322 1.60735 8.21828 1.79582 8.71242C1.96125 9.14614 2.27239 9.5088 2.6759 9.73825C3.13564 9.99968 3.77818 9.99967 5.06324 9.99967H5.59995C5.97332 9.99967 6.16001 9.99967 6.30261 10.0723C6.42806 10.1363 6.53004 10.2382 6.59396 10.3637C6.66662 10.5063 6.66662 10.693 6.66662 11.0663V13.0224C6.66662 13.9303 7.40262 14.6663 8.31051 14.6663C8.52706 14.6663 8.7233 14.5388 8.81125 14.3409L11.0518 9.29979C11.1537 9.07051 11.2046 8.95586 11.2852 8.8718C11.3563 8.79749 11.4438 8.74068 11.5406 8.7058C11.6501 8.66634 11.7756 8.66634 12.0265 8.66634H12.5333C13.28 8.66634 13.6534 8.66634 13.9386 8.52102C14.1895 8.39319 14.3935 8.18921 14.5213 7.93833C14.6666 7.65311 14.6666 7.27974 14.6666 6.53301Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ThumbsDownFilledIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8522 21.8665C13.5999 22.4342 13.037 22.8 12.4157 22.8C10.6397 22.8 9.1999 21.3603 9.1999 19.5842V16.05C9.1999 15.912 9.08797 15.8 8.9499 15.8H5.44673C3.14841 15.8 1.39087 13.7514 1.74034 11.4798L2.81726 4.47983C3.09871 2.65046 4.67277 1.30005 6.52366 1.30005H15.45C15.6489 1.30005 15.8396 1.37907 15.9803 1.51972C16.1209 1.66037 16.2 1.85114 16.2 2.05005V16.05C16.2 16.1485 16.1806 16.2461 16.1429 16.3371L13.8598 21.8489L13.8522 21.8665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7804 13.8L18.45 13.8C18.0357 13.8 17.7 13.4643 17.7 13.05V2.05005C17.7 1.63584 18.0357 1.30005 18.45 1.30005H18.7804C19.3145 1.30004 19.7604 1.30003 20.1246 1.32979C20.5045 1.36082 20.8612 1.42794 21.1984 1.59978C21.7159 1.86343 22.1366 2.28413 22.4002 2.80157C22.5721 3.13884 22.6392 3.49549 22.6702 3.87538C22.7 4.23961 22.7 4.68546 22.7 5.21961V9.88048C22.7 10.4146 22.7 10.8605 22.6702 11.2247C22.6392 11.6046 22.5721 11.9613 22.4002 12.2985C22.1366 12.816 21.7159 13.2367 21.1984 13.5003C20.8612 13.6722 20.5045 13.7393 20.1246 13.7703C19.7604 13.8001 19.3145 13.8001 18.7804 13.8Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ThumbsDownFilledIconTwo(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.24893 4.04642C2.39708 3.08343 2.47116 2.60194 2.7072 2.24015C2.91524 1.92129 3.20998 1.66843 3.55676 1.5113C3.95023 1.33301 4.4374 1.33301 5.41172 1.33301H12.533C13.2798 1.33301 13.6531 1.33301 13.9384 1.47833C14.1892 1.60616 14.3932 1.81014 14.5211 2.06102C14.6664 2.34624 14.6664 2.7196 14.6664 3.46634V6.53301C14.6664 7.27974 14.6664 7.65311 14.5211 7.93833C14.3932 8.18921 14.1892 8.39319 13.9384 8.52102C13.6531 8.66634 13.2798 8.66634 12.533 8.66634H12.0262C11.7753 8.66634 11.6499 8.66634 11.5403 8.7058C11.4435 8.74068 11.3561 8.79749 11.2849 8.8718C11.2044 8.95586 11.1534 9.07051 11.0515 9.29979L8.81101 14.3409C8.72306 14.5388 8.52682 14.6663 8.31027 14.6663C7.40237 14.6663 6.66638 13.9303 6.66638 13.0224V11.0663C6.66638 10.693 6.66638 10.5063 6.59371 10.3637C6.5298 10.2382 6.42781 10.1363 6.30237 10.0723C6.15976 9.99967 5.97308 9.99967 5.59971 9.99967H5.063C3.77793 9.99967 3.1354 9.99967 2.67566 9.73825C2.27214 9.5088 1.961 9.14614 1.79558 8.71242C1.6071 8.21828 1.70481 7.58322 1.90021 6.31309L2.24893 4.04642Z"
        fill="currentColor"
      />
      <path
        d="M11.333 1.33301V8.66634M14.6664 6.53301V3.46634C14.6664 2.7196 14.6664 2.34624 14.5211 2.06102C14.3932 1.81014 14.1892 1.60616 13.9384 1.47833C13.6531 1.33301 13.2798 1.33301 12.533 1.33301H5.41172C4.4374 1.33301 3.95023 1.33301 3.55676 1.5113C3.20998 1.66843 2.91524 1.92129 2.7072 2.24015C2.47116 2.60194 2.39708 3.08343 2.24893 4.04642L1.90021 6.31309C1.70481 7.58322 1.6071 8.21828 1.79558 8.71242C1.961 9.14614 2.27214 9.5088 2.67566 9.73825C3.1354 9.99968 3.77793 9.99967 5.063 9.99967H5.59971C5.97308 9.99967 6.15976 9.99967 6.30237 10.0723C6.42781 10.1363 6.5298 10.2382 6.59371 10.3637C6.66638 10.5063 6.66638 10.693 6.66638 11.0663V13.0224C6.66638 13.9303 7.40237 14.6663 8.31027 14.6663C8.52682 14.6663 8.72306 14.5388 8.81101 14.3409L11.0515 9.29979C11.1534 9.07051 11.2044 8.95586 11.2849 8.8718C11.3561 8.79749 11.4435 8.74068 11.5403 8.7058C11.6499 8.66634 11.7753 8.66634 12.0262 8.66634H12.533C13.2798 8.66634 13.6531 8.66634 13.9384 8.52102C14.1892 8.39319 14.3932 8.18921 14.5211 7.93833C14.6664 7.65311 14.6664 7.27974 14.6664 6.53301Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function DotsHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HomeIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16.9997H16M11.0177 2.76375L4.23539 8.03888C3.78202 8.3915 3.55534 8.56781 3.39203 8.78861C3.24737 8.9842 3.1396 9.20454 3.07403 9.43881C3 9.70327 3 9.99045 3 10.5648V17.7997C3 18.9198 3 19.4799 3.21799 19.9077C3.40973 20.284 3.71569 20.59 4.09202 20.7818C4.51984 20.9997 5.07989 20.9997 6.2 20.9997H17.8C18.9201 20.9997 19.4802 20.9997 19.908 20.7818C20.2843 20.59 20.5903 20.284 20.782 19.9077C21 19.4799 21 18.9198 21 17.7997V10.5648C21 9.99045 21 9.70327 20.926 9.43881C20.8604 9.20454 20.7526 8.9842 20.608 8.78861C20.4447 8.56781 20.218 8.3915 19.7646 8.03888L12.9823 2.76376C12.631 2.4905 12.4553 2.35388 12.2613 2.30136C12.0902 2.25502 11.9098 2.25502 11.7387 2.30136C11.5447 2.35388 11.369 2.4905 11.0177 2.76375Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HamburgerIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12H21M3 6H21M3 18H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HeartRoundedIcon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9253 2.5C16.8605 2.5 18.8327 5.29375 18.8327 7.9C18.8327 13.1781 10.6475 17.5 10.4993 17.5C10.3512 17.5 2.16602 13.1781 2.16602 7.9C2.16602 5.29375 4.13824 2.5 7.07342 2.5C8.75861 2.5 9.86046 3.35312 10.4993 4.10312C11.1382 3.35312 12.2401 2.5 13.9253 2.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FilePlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M12 18V12M9 15H15M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileSettingsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 8.5C13 9.88071 11.8807 11 10.5 11C9.11929 11 8 9.88071 8 8.5C8 7.11929 9.11929 6 10.5 6C11.8807 6 13 7.11929 13 8.5ZM13 8.5H16M11 15.5C11 16.8807 12.1193 18 13.5 18C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13C12.1193 13 11 14.1193 11 15.5ZM11 15.5H8M8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileSettingsAlertIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 11.4185V17.2V17.2413C21 18.0463 21 18.7106 20.9558 19.2518C20.9099 19.8139 20.8113 20.3306 20.564 20.816C20.1805 21.5686 19.5686 22.1805 18.816 22.564C18.3306 22.8113 17.8139 22.9099 17.2518 22.9558C16.7106 23 16.0463 23 15.2413 23H15.2H8.8H8.75868C7.95372 23 7.28936 23 6.74817 22.9558C6.18608 22.9099 5.66937 22.8113 5.18404 22.564C4.43139 22.1805 3.81947 21.5686 3.43597 20.816C3.18868 20.3306 3.09012 19.8139 3.04419 19.2518C2.99998 18.7106 2.99999 18.0463 3 17.2413V17.2413V17.2V6.8V6.7587V6.75868C2.99999 5.95372 2.99998 5.28937 3.04419 4.74818C3.09012 4.18608 3.18868 3.66937 3.43597 3.18404C3.81947 2.43139 4.43139 1.81947 5.18404 1.43598C5.66937 1.18868 6.18608 1.09012 6.74817 1.04419C7.28937 0.999978 7.95372 0.999988 8.75868 1H8.7587H8.8H10.5815C10.3262 1.6307 10.149 2.30136 10.0619 3H8.8C7.94342 3 7.36113 3.00078 6.91104 3.03755C6.47262 3.07337 6.24842 3.1383 6.09202 3.21799C5.7157 3.40974 5.40973 3.7157 5.21799 4.09202C5.1383 4.24842 5.07337 4.47262 5.03755 4.91104C5.00078 5.36113 5 5.94342 5 6.8V17.2C5 18.0566 5.00078 18.6389 5.03755 19.089C5.07337 19.5274 5.1383 19.7516 5.21799 19.908C5.40973 20.2843 5.7157 20.5903 6.09202 20.782C6.24842 20.8617 6.47262 20.9266 6.91104 20.9624C7.36113 20.9992 7.94342 21 8.8 21H15.2C16.0566 21 16.6389 20.9992 17.089 20.9624C17.5274 20.9266 17.7516 20.8617 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C18.8617 19.7516 18.9266 19.5274 18.9624 19.089C18.9992 18.6389 19 18.0566 19 17.2V11.9381C19.6986 11.851 20.3693 11.6738 21 11.4185ZM13.3601 10.5178C12.7264 11.4145 11.6816 12 10.5 12C8.567 12 7 10.433 7 8.5C7 6.71421 8.33742 5.2408 10.0653 5.02674C10.1537 5.71657 10.3299 6.37893 10.5824 7.00223C10.5551 7.00075 10.5277 7 10.5 7C9.67157 7 9 7.67157 9 8.5C9 9.32843 9.67157 10 10.5 10C11.1032 10 11.6233 9.6439 11.8615 9.13045C12.2995 9.65402 12.8033 10.1207 13.3601 10.5178ZM12 15.5C12 14.6716 12.6716 14 13.5 14C14.3284 14 15 14.6716 15 15.5C15 16.3284 14.3284 17 13.5 17C12.6716 17 12 16.3284 12 15.5ZM13.5 12C11.9145 12 10.5752 13.0543 10.1449 14.5H8C7.44772 14.5 7 14.9477 7 15.5C7 16.0523 7.44772 16.5 8 16.5H10.1449C10.5752 17.9457 11.9145 19 13.5 19C15.433 19 17 17.433 17 15.5C17 13.567 15.433 12 13.5 12Z"
        fill="currentColor"
      />
      <circle cx="18" cy="4" r="4" fill="#FA5A84" />
    </svg>
  )
}

export function ImportFileIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function InfoCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 16.0001V12.0001M12 8.00012H12.01M22 12.0001C22 17.523 17.5228 22.0001 12 22.0001C6.47715 22.0001 2 17.523 2 12.0001C2 6.47727 6.47715 2.00012 12 2.00012C17.5228 2.00012 22 6.47727 22 12.0001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Download01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Download02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21H3M18 11L12 17M12 17L6 11M12 17V3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ClockIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ClockRewindIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ClockRefreshIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6358 8.59526C13.4506 10.3352 12.4648 11.9657 10.8334 12.9075C8.12311 14.4723 4.65743 13.5437 3.09263 10.8334L2.92596 10.5447M2.36444 7.40479C2.54964 5.66486 3.5355 4.03438 5.16682 3.09253C7.87715 1.52773 11.3428 2.45635 12.9076 5.16668L13.0743 5.45535M2.3291 12.044L2.81714 10.2226L4.6385 10.7107M11.3618 5.28936L13.1832 5.77739L13.6712 3.95603M8.00015 5.00001V8.00001L9.66682 9.00001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MessageChatSquare(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15L6.92474 18.1137C6.49579 18.548 6.28131 18.7652 6.09695 18.7805C5.93701 18.7938 5.78042 18.7295 5.67596 18.6076C5.55556 18.4672 5.55556 18.162 5.55556 17.5515V15.9916C5.55556 15.444 5.10707 15.0477 4.5652 14.9683V14.9683C3.25374 14.7762 2.22378 13.7463 2.03168 12.4348C2 12.2186 2 11.9605 2 11.4444V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H14.2C15.8802 2 16.7202 2 17.362 2.32698C17.9265 2.6146 18.3854 3.07354 18.673 3.63803C19 4.27976 19 5.11984 19 6.8V11M19 22L16.8236 20.4869C16.5177 20.2742 16.3647 20.1678 16.1982 20.0924C16.0504 20.0255 15.8951 19.9768 15.7356 19.9474C15.5558 19.9143 15.3695 19.9143 14.9969 19.9143H13.2C12.0799 19.9143 11.5198 19.9143 11.092 19.6963C10.7157 19.5046 10.4097 19.1986 10.218 18.8223C10 18.3944 10 17.8344 10 16.7143V14.2C10 13.0799 10 12.5198 10.218 12.092C10.4097 11.7157 10.7157 11.4097 11.092 11.218C11.5198 11 12.0799 11 13.2 11H18.8C19.9201 11 20.4802 11 20.908 11.218C21.2843 11.4097 21.5903 11.7157 21.782 12.092C22 12.5198 22 13.0799 22 14.2V16.9143C22 17.8462 22 18.3121 21.8478 18.6797C21.6448 19.1697 21.2554 19.5591 20.7654 19.762C20.3978 19.9143 19.9319 19.9143 19 19.9143V22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MessageDotsSquare(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 10.5H7.51M12 10.5H12.01M16.5 10.5H16.51M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18ZM8 10.5C8 10.7761 7.77614 11 7.5 11C7.22386 11 7 10.7761 7 10.5C7 10.2239 7.22386 10 7.5 10C7.77614 10 8 10.2239 8 10.5ZM12.5 10.5C12.5 10.7761 12.2761 11 12 11C11.7239 11 11.5 10.7761 11.5 10.5C11.5 10.2239 11.7239 10 12 10C12.2761 10 12.5 10.2239 12.5 10.5ZM17 10.5C17 10.7761 16.7761 11 16.5 11C16.2239 11 16 10.7761 16 10.5C16 10.2239 16.2239 10 16.5 10C16.7761 10 17 10.2239 17 10.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MessageTextSquared02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8.5H12M7 12H15M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HelpCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CopyIcon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34994 1.66883C8.78739 1.67646 8.44968 1.70903 8.17662 1.84816C7.86301 2.00795 7.60805 2.26292 7.44826 2.57652C7.30912 2.84959 7.27656 3.1873 7.26893 3.74984M16.8499 1.66883C17.4125 1.67646 17.7502 1.70903 18.0233 1.84816C18.3369 2.00795 18.5918 2.26292 18.7516 2.57652C18.8907 2.84958 18.9233 3.18729 18.9309 3.74983M18.9309 11.2498C18.9233 11.8124 18.8907 12.1501 18.7516 12.4232C18.5918 12.7368 18.3369 12.9917 18.0233 13.1515C17.7502 13.2906 17.4125 13.3232 16.8499 13.3308M18.9333 6.6665V8.33317M12.2666 1.6665H13.9332M4.93327 18.3332H11.2666C12.2 18.3332 12.6667 18.3332 13.0233 18.1515C13.3369 17.9917 13.5918 17.7368 13.7516 17.4232C13.9333 17.0666 13.9333 16.5999 13.9333 15.6665V9.33317C13.9333 8.39975 13.9333 7.93304 13.7516 7.57652C13.5918 7.26292 13.3369 7.00795 13.0233 6.84816C12.6667 6.6665 12.2 6.6665 11.2666 6.6665H4.93327C3.99985 6.6665 3.53314 6.6665 3.17662 6.84816C2.86301 7.00795 2.60805 7.26292 2.44826 7.57652C2.2666 7.93304 2.2666 8.39975 2.2666 9.33317V15.6665C2.2666 16.5999 2.2666 17.0666 2.44826 17.4232C2.60805 17.7368 2.86301 17.9917 3.17662 18.1515C3.53314 18.3332 3.99985 18.3332 4.93327 18.3332Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SaveIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M12.2267 2.39333C11.9733 2.14 11.6333 2 11.28 2H3.83333C3.09333 2 2.5 2.6 2.5 3.33333V12.6667C2.5 13.4 3.1 14 3.83333 14H13.1667C13.9 14 14.5 13.4 14.5 12.6667V5.22C14.5 4.86667 14.36 4.52667 14.1067 4.28L12.2267 2.39333ZM8.5 12.6667C7.39333 12.6667 6.5 11.7733 6.5 10.6667C6.5 9.56 7.39333 8.66667 8.5 8.66667C9.60667 8.66667 10.5 9.56 10.5 10.6667C10.5 11.7733 9.60667 12.6667 8.5 12.6667ZM9.16667 6H5.16667C4.43333 6 3.83333 5.4 3.83333 4.66667C3.83333 3.93333 4.43333 3.33333 5.16667 3.33333H9.16667C9.9 3.33333 10.5 3.93333 10.5 4.66667C10.5 5.4 9.9 6 9.16667 6Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Save02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 8H8.6C8.03995 8 7.75992 8 7.54601 7.89101C7.35785 7.79513 7.20487 7.64215 7.10899 7.45399C7 7.24008 7 6.96005 7 6.4V3M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Save03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548V17M12.5 10H8.6C8.03995 10 7.75992 10 7.54601 9.89101C7.35785 9.79513 7.20487 9.64215 7.10899 9.45399C7 9.24008 7 8.96005 7 8.4V6.5M13.5 21V16.6C13.5 16.0399 13.5 15.7599 13.391 15.546C13.2951 15.3578 13.1422 15.2049 12.954 15.109C12.7401 15 12.4601 15 11.9 15H8.6C8.03995 15 7.75992 15 7.54601 15.109C7.35785 15.2049 7.20487 15.3578 7.10899 15.546C7 15.7599 7 16.0399 7 16.6V21M17.5 10.1627V17.8C17.5 18.9201 17.5 19.4802 17.282 19.908C17.0903 20.2843 16.7843 20.5903 16.408 20.782C15.9802 21 15.4201 21 14.3 21H6.2C5.0799 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V9.7C3 8.57989 3 8.01984 3.21799 7.59202C3.40973 7.21569 3.71569 6.90973 4.09202 6.71799C4.51984 6.5 5.0799 6.5 6.2 6.5H13.8373C14.0818 6.5 14.2041 6.5 14.3192 6.52763C14.4213 6.55213 14.5188 6.59253 14.6083 6.64736C14.7092 6.7092 14.7957 6.79568 14.9686 6.96863L17.0314 9.03137C17.2043 9.20432 17.2908 9.2908 17.3526 9.39172C17.4075 9.48119 17.4479 9.57873 17.4724 9.68077C17.5 9.79586 17.5 9.91815 17.5 10.1627Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SendIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      {...props}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M2.94701 13.5998L14.5803 8.61318C15.1203 8.37985 15.1203 7.61985 14.5803 7.38652L2.94701 2.39985C2.50701 2.20652 2.02034 2.53318 2.02034 3.00652L2.01367 6.07985C2.01367 6.41318 2.26034 6.69985 2.59367 6.73985L12.0137 7.99985L2.59367 9.25318C2.26034 9.29985 2.01367 9.58652 2.01367 9.91985L2.02034 12.9932C2.02034 13.4665 2.50701 13.7932 2.94701 13.5998Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Send01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4995 13.5002L20.9995 3.00017M10.6271 13.8282L13.2552 20.5862C13.4867 21.1816 13.6025 21.4793 13.7693 21.5662C13.9139 21.6415 14.0862 21.6416 14.2308 21.5664C14.3977 21.4797 14.5139 21.1822 14.7461 20.5871L21.3364 3.69937C21.5461 3.16219 21.6509 2.8936 21.5935 2.72197C21.5437 2.57292 21.4268 2.45596 21.2777 2.40616C21.1061 2.34883 20.8375 2.45364 20.3003 2.66327L3.41258 9.25361C2.8175 9.48584 2.51997 9.60195 2.43326 9.76886C2.35809 9.91354 2.35819 10.0858 2.43353 10.2304C2.52043 10.3972 2.81811 10.513 3.41345 10.7445L10.1715 13.3726C10.2923 13.4196 10.3527 13.4431 10.4036 13.4794C10.4487 13.5115 10.4881 13.551 10.5203 13.5961C10.5566 13.647 10.5801 13.7074 10.6271 13.8282Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileHeart03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2ZM11.9973 11.8306C11.1975 10.9216 9.8639 10.6771 8.86188 11.5094C7.85986 12.3418 7.71879 13.7335 8.50568 14.7179C9.29257 15.7024 11.9973 18 11.9973 18C11.9973 18 14.7019 15.7024 15.4888 14.7179C16.2757 13.7335 16.1519 12.3331 15.1326 11.5094C14.1134 10.6858 12.797 10.9216 11.9973 11.8306Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function GridIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ListIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LogIn03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 17.0001C6 17.3514 6 17.527 6.01567 17.6797C6.14575 18.9475 7.0626 19.9947 8.30206 20.2912C8.45134 20.3269 8.6255 20.3501 8.97368 20.3966L15.5656 21.2755C17.442 21.5257 18.3803 21.6508 19.1084 21.3612C19.7478 21.107 20.2803 20.6408 20.6168 20.0407C21 19.3572 21 18.4106 21 16.5176V7.48256C21 5.58952 21 4.643 20.6168 3.95947C20.2803 3.35936 19.7478 2.89313 19.1084 2.63892C18.3803 2.34938 17.442 2.47448 15.5656 2.72467L8.97368 3.60359C8.62546 3.65002 8.45135 3.67324 8.30206 3.70895C7.0626 4.00544 6.14575 5.05266 6.01567 6.32043C6 6.47313 6 6.64878 6 7.00008M12 8.00008L16 12.0001M16 12.0001L12 16.0001M16 12.0001H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BankNote01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11V15M18 9V13M17 4C19.4487 4 20.7731 4.37476 21.4321 4.66544C21.5199 4.70415 21.5638 4.72351 21.6904 4.84437C21.7663 4.91682 21.9049 5.12939 21.9405 5.22809C22 5.39274 22 5.48274 22 5.66274V16.4111C22 17.3199 22 17.7743 21.8637 18.0079C21.7251 18.2454 21.5914 18.3559 21.3319 18.4472C21.0769 18.5369 20.562 18.438 19.5322 18.2401C18.8114 18.1017 17.9565 18 17 18C14 18 11 20 7 20C4.55129 20 3.22687 19.6252 2.56788 19.3346C2.48012 19.2958 2.43624 19.2765 2.3096 19.1556C2.23369 19.0832 2.09512 18.8706 2.05947 18.7719C2 18.6073 2 18.5173 2 18.3373L2 7.58885C2 6.68009 2 6.2257 2.13628 5.99214C2.2749 5.75456 2.40859 5.64412 2.66806 5.55281C2.92314 5.46305 3.43803 5.56198 4.46783 5.75985C5.18862 5.89834 6.04348 6 7 6C10 6 13 4 17 4ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UploadCloud02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16L12 12M12 12L16 16M12 12V21M20 16.7428C21.2215 15.734 22 14.2079 22 12.5C22 9.46243 19.5376 7 16.5 7C16.2815 7 16.0771 6.886 15.9661 6.69774C14.6621 4.48484 12.2544 3 9.5 3C5.35786 3 2 6.35786 2 10.5C2 12.5661 2.83545 14.4371 4.18695 15.7935"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Upload01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PaletteIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UserPlus01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PlusCircleIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      {...props}
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M7.41667 4.75V10.0833M4.75 7.41667H10.0833M14.0833 7.41667C14.0833 11.0986 11.0986 14.0833 7.41667 14.0833C3.73477 14.0833 0.75 11.0986 0.75 7.41667C0.75 3.73477 3.73477 0.75 7.41667 0.75C11.0986 0.75 14.0833 3.73477 14.0833 7.41667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UserMinus01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UserLeft01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 21L16 18M16 18L19 15M16 18H22M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Users01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UsersPlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UsersMinusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 18H22M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UserRight01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 21L22 18M22 18L19 15M22 18H16M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UsersRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19 21L22 18M22 18L19 15M22 18H16M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LayoutMenuIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2V14M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.00065 8C4.36884 8 4.66732 7.70152 4.66732 7.33333C4.66732 6.96514 4.36884 6.66667 4.00065 6.66667C3.63246 6.66667 3.33398 6.96514 3.33398 7.33333C3.33398 7.70152 3.63246 8 4.00065 8Z"
        fill="currentColor"
      />
      <path
        d="M4.00065 5.33333C4.36884 5.33333 4.66732 5.03486 4.66732 4.66667C4.66732 4.29848 4.36884 4 4.00065 4C3.63246 4 3.33398 4.29848 3.33398 4.66667C3.33398 5.03486 3.63246 5.33333 4.00065 5.33333Z"
        fill="currentColor"
      />
      <path
        d="M4.00065 10.6667C4.36884 10.6667 4.66732 10.3682 4.66732 10C4.66732 9.63181 4.36884 9.33333 4.00065 9.33333C3.63246 9.33333 3.33398 9.63181 3.33398 10C3.33398 10.3682 3.63246 10.6667 4.00065 10.6667Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LayoutAlt02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 11H12.5M17.5 15H12.5M17.5 7H12.5M9 3L9 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LayoutAlt04Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      {...props}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M12 12.5L21 12.5M12 3.5L12 21.5M7.8 3.5H16.2C17.8802 3.5 18.7202 3.5 19.362 3.82698C19.9265 4.1146 20.3854 4.57354 20.673 5.13803C21 5.77976 21 6.61984 21 8.3V16.7C21 18.3802 21 19.2202 20.673 19.862C20.3854 20.4265 19.9265 20.8854 19.362 21.173C18.7202 21.5 17.8802 21.5 16.2 21.5H7.8C6.11984 21.5 5.27976 21.5 4.63803 21.173C4.07354 20.8854 3.6146 20.4265 3.32698 19.862C3 19.2202 3 18.3802 3 16.7V8.3C3 6.61984 3 5.77976 3.32698 5.13803C3.6146 4.57354 4.07354 4.1146 4.63803 3.82698C5.27976 3.5 6.11984 3.5 7.8 3.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function File06Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Image01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2 21H6.93137C6.32555 21 6.02265 21 5.88238 20.8802C5.76068 20.7763 5.69609 20.6203 5.70865 20.4608C5.72312 20.2769 5.93731 20.0627 6.36569 19.6343L14.8686 11.1314C15.2646 10.7354 15.4627 10.5373 15.691 10.4632C15.8918 10.3979 16.1082 10.3979 16.309 10.4632C16.5373 10.5373 16.7354 10.7354 17.1314 11.1314L21 15V16.2M16.2 21C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2M16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StandIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 17L4 22M15 17L20 22M12 2V4M12 22V17M5.2 17H18.8C19.9201 17 20.4802 17 20.908 16.782C21.2843 16.5903 21.5903 16.2843 21.782 15.908C22 15.4802 22 14.9201 22 13.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H5.2C4.07989 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.07989 2 7.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.0799 17 5.2 17Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CertificateIcon(props: IconProps) {
  return (
    <svg {...props} width="24" height="24" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 20H5C3.89543 20 3 19.1046 3 18V4C3 2.89543 3.89543 2 5 2H19C20.1046 2 21 2.89543 21 4V18C21 19.1046 20.1046 20 19 20H17.5M12 19C13.6569 19 15 17.6569 15 16C15 14.3431 13.6569 13 12 13C10.3431 13 9 14.3431 9 16C9 17.6569 10.3431 19 12 19ZM12 19L12.0214 18.9998L8.82867 22.1926L6.00024 19.3641L9.01965 16.3447M12 19L15.1928 22.1926L18.0212 19.3641L15.0018 16.3447M9 6H15M7 9.5H17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PresentationChartIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16V21M12 16L18 21M12 16L6 21M21 3V11.2C21 12.8802 21 13.7202 20.673 14.362C20.3854 14.9265 19.9265 15.3854 19.362 15.673C18.7202 16 17.8802 16 16.2 16H7.8C6.11984 16 5.27976 16 4.63803 15.673C4.07354 15.3854 3.6146 14.9265 3.32698 14.362C3 13.7202 3 12.8802 3 11.2V3M8 9V12M12 7V12M16 11V12M22 3H2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PlaySquareIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 6.96533C7.5 6.48805 7.5 6.24941 7.59974 6.11618C7.68666 6.00007 7.81971 5.92744 7.96438 5.9171C8.13038 5.90525 8.33112 6.03429 8.73261 6.29239L13.4532 9.32706C13.8016 9.55102 13.9758 9.663 14.0359 9.80539C14.0885 9.9298 14.0885 10.0702 14.0359 10.1946C13.9758 10.337 13.8016 10.449 13.4532 10.6729L8.73261 13.7076C8.33112 13.9657 8.13038 14.0948 7.96438 14.0829C7.81971 14.0726 7.68666 13.9999 7.59974 13.8838C7.5 13.7506 7.5 13.512 7.5 13.0347V6.96533Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Star01Icon(props: IconProps) {
  return (
    <svg
      width="22"
      height="21"
      {...props}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2827 2.45332C10.5131 1.98638 10.6284 1.75291 10.7848 1.67831C10.9209 1.61341 11.0791 1.61341 11.2152 1.67831C11.3717 1.75291 11.4869 1.98638 11.7174 2.45332L13.9041 6.88328C13.9721 7.02113 14.0061 7.09006 14.0558 7.14358C14.0999 7.19096 14.1527 7.22935 14.2113 7.25662C14.2776 7.28742 14.3536 7.29854 14.5057 7.32077L19.397 8.03571C19.9121 8.11099 20.1696 8.14863 20.2888 8.27444C20.3925 8.38389 20.4412 8.5343 20.4215 8.68377C20.3988 8.85558 20.2124 9.03718 19.8395 9.40038L16.3014 12.8464C16.1912 12.9538 16.136 13.0076 16.1004 13.0715C16.0689 13.128 16.0487 13.1902 16.0409 13.2545C16.0321 13.3271 16.0451 13.403 16.0711 13.5547L16.906 18.4221C16.994 18.9355 17.038 19.1922 16.9553 19.3445C16.8833 19.477 16.7554 19.57 16.6071 19.5975C16.4366 19.6291 16.2061 19.5078 15.7451 19.2654L11.3724 16.9658C11.2361 16.8942 11.168 16.8584 11.0962 16.8443C11.0327 16.8318 10.9673 16.8318 10.9038 16.8443C10.832 16.8584 10.7639 16.8942 10.6277 16.9658L6.25492 19.2654C5.79392 19.5078 5.56341 19.6291 5.39297 19.5975C5.24468 19.57 5.11672 19.477 5.04474 19.3445C4.962 19.1922 5.00603 18.9355 5.09407 18.4221L5.92889 13.5547C5.95491 13.403 5.96793 13.3271 5.95912 13.2545C5.95132 13.1902 5.93111 13.128 5.89961 13.0715C5.86402 13.0076 5.80888 12.9538 5.69859 12.8464L2.16056 9.40038C1.78766 9.03718 1.60121 8.85558 1.57853 8.68377C1.55879 8.5343 1.60755 8.38389 1.71125 8.27444C1.83044 8.14863 2.08797 8.11099 2.60304 8.03571L7.49431 7.32077C7.64642 7.29854 7.72248 7.28742 7.78872 7.25662C7.84736 7.22935 7.90016 7.19096 7.94419 7.14358C7.99391 7.09006 8.02793 7.02113 8.09597 6.88328L10.2827 2.45332Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Star01FilledIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Star06Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.84281 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Pin02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3767 15.6164L2.71985 21.2733M11.6944 6.64194L10.1335 8.20282C10.0062 8.33015 9.94252 8.39381 9.86999 8.4444C9.80561 8.4893 9.73616 8.52646 9.66309 8.55512C9.58077 8.58741 9.49249 8.60507 9.31592 8.64038L5.65145 9.37327C4.69915 9.56373 4.223 9.65897 4.00024 9.91002C3.80617 10.1287 3.71755 10.4214 3.75771 10.711C3.8038 11.0435 4.14715 11.3869 4.83387 12.0736L11.9196 19.1593C12.6063 19.846 12.9497 20.1894 13.2821 20.2355C13.5718 20.2756 13.8645 20.187 14.0832 19.9929C14.3342 19.7702 14.4294 19.294 14.6199 18.3417L15.3528 14.6773C15.3881 14.5007 15.4058 14.4124 15.4381 14.3301C15.4667 14.257 15.5039 14.1876 15.5488 14.1232C15.5994 14.0507 15.663 13.987 15.7904 13.8597L17.3512 12.2988C17.4326 12.2174 17.4734 12.1767 17.5181 12.1411C17.5578 12.1096 17.5999 12.0811 17.644 12.0559C17.6936 12.0276 17.7465 12.0049 17.8523 11.9595L20.3467 10.8905C21.0744 10.5786 21.4383 10.4227 21.6035 10.1707C21.7481 9.95037 21.7998 9.68187 21.7474 9.4236C21.6875 9.12826 21.4076 8.84834 20.8478 8.28852L15.7047 3.14538C15.1448 2.58555 14.8649 2.30564 14.5696 2.24577C14.3113 2.19341 14.0428 2.24512 13.8225 2.38965C13.5705 2.55493 13.4145 2.91878 13.1027 3.64648L12.0337 6.14084C11.9883 6.24665 11.9656 6.29956 11.9373 6.34917C11.9121 6.39325 11.8836 6.43534 11.852 6.47509C11.8165 6.51983 11.7758 6.56053 11.6944 6.64194Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Pin02FilledIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.73535 2.43099C8.94327 1.94585 9.04722 1.70329 9.21521 1.5931C9.36212 1.49675 9.54112 1.46227 9.7133 1.49718C9.91019 1.53709 10.0968 1.7237 10.47 2.09692L13.8988 5.52568C14.272 5.89889 14.4586 6.0855 14.4985 6.2824C14.5334 6.45458 14.499 6.63358 14.4026 6.78049C14.2924 6.94847 14.0498 7.05243 13.5647 7.26035L11.9018 7.97302C11.8313 8.00325 11.796 8.01837 11.7629 8.03727C11.7335 8.05405 11.7055 8.07305 11.679 8.0941C11.6491 8.11779 11.622 8.14492 11.5677 8.19919L10.5271 9.23979C10.4423 9.32467 10.3998 9.36711 10.3661 9.41546C10.3362 9.45838 10.3114 9.50468 10.2923 9.55339C10.2708 9.60828 10.259 9.66713 10.2354 9.78484L9.74685 12.2278C9.61987 12.8627 9.55639 13.1801 9.38902 13.3286C9.24321 13.458 9.04808 13.5171 8.855 13.4903C8.63336 13.4596 8.40446 13.2307 7.94665 12.7729L3.22282 8.04905C2.76501 7.59124 2.53611 7.36233 2.50538 7.1407C2.47861 6.94761 2.53769 6.75249 2.66707 6.60668C2.81558 6.43931 3.13301 6.37582 3.76788 6.24885L6.21086 5.76025C6.32857 5.73671 6.38742 5.72494 6.44231 5.70341C6.49102 5.68431 6.53731 5.65953 6.58023 5.6296C6.62859 5.59587 6.67103 5.55343 6.75591 5.46855L7.7965 4.42796C7.85077 4.37369 7.87791 4.34655 7.9016 4.31672C7.92265 4.29023 7.94165 4.26217 7.95843 4.23278C7.97733 4.19971 7.99244 4.16444 8.02268 4.09389L8.73535 2.43099Z"
        fill="currentColor"
      />
      <path
        d="M5.58471 10.411L1.81348 14.1822M7.7965 4.42796L6.75591 5.46855C6.67103 5.55343 6.62859 5.59587 6.58023 5.6296C6.53731 5.65953 6.49102 5.68431 6.44231 5.70341C6.38742 5.72494 6.32857 5.73671 6.21086 5.76025L3.76788 6.24885C3.13301 6.37582 2.81558 6.43931 2.66707 6.60668C2.53769 6.75249 2.47861 6.94761 2.50538 7.1407C2.53611 7.36233 2.76501 7.59124 3.22282 8.04905L7.94665 12.7729C8.40446 13.2307 8.63336 13.4596 8.855 13.4903C9.04808 13.5171 9.24321 13.458 9.38902 13.3286C9.55639 13.1801 9.61987 12.8627 9.74685 12.2278L10.2354 9.78484C10.259 9.66713 10.2708 9.60828 10.2923 9.55339C10.3114 9.50468 10.3362 9.45838 10.3661 9.41546C10.3998 9.36711 10.4423 9.32467 10.5271 9.23979L11.5677 8.19919C11.622 8.14492 11.6491 8.11779 11.679 8.0941C11.7055 8.07305 11.7335 8.05405 11.7629 8.03727C11.796 8.01837 11.8313 8.00325 11.9018 7.97302L13.5647 7.26035C14.0498 7.05243 14.2924 6.94848 14.4026 6.78049C14.499 6.63358 14.5334 6.45458 14.4985 6.2824C14.4586 6.0855 14.272 5.89889 13.8988 5.52568L10.47 2.09692C10.0968 1.7237 9.91019 1.53709 9.7133 1.49718C9.54112 1.46227 9.36212 1.49675 9.21521 1.5931C9.04722 1.70329 8.94327 1.94585 8.73535 2.43099L8.02268 4.09389C7.99244 4.16444 7.97733 4.19971 7.95843 4.23278C7.94165 4.26217 7.92265 4.29023 7.9016 4.31672C7.87791 4.34655 7.85077 4.37369 7.7965 4.42796Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SkipBackIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16663 15.8333V4.16666M13.667 5.06633L8.80141 8.95883C8.35654 9.31473 8.1341 9.49268 8.05357 9.70766C7.98296 9.89615 7.98296 10.1038 8.05357 10.2923C8.1341 10.5073 8.35654 10.6853 8.80141 11.0411L13.667 14.9336C14.3605 15.4884 14.7072 15.7658 14.9991 15.7661C15.2528 15.7664 15.4929 15.651 15.6512 15.4527C15.8333 15.2246 15.8333 14.7806 15.8333 13.8925V6.10749C15.8333 5.21941 15.8333 4.77536 15.6512 4.5473C15.4929 4.34896 15.2528 4.23357 14.9991 4.23384C14.7072 4.23416 14.3605 4.51155 13.667 5.06633Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SkipForwardIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 4.16666V15.8333M6.33289 14.9336L11.1985 11.0411C11.6434 10.6853 11.8658 10.5073 11.9464 10.2923C12.017 10.1038 12.017 9.89615 11.9464 9.70766C11.8658 9.49268 11.6434 9.31473 11.1985 8.95883L6.33289 5.06633C5.63941 4.51155 5.29267 4.23416 5.00086 4.23384C4.74708 4.23357 4.507 4.34896 4.34867 4.5473C4.16663 4.77536 4.16663 5.21941 4.16663 6.10749V13.8925C4.16663 14.7806 4.16663 15.2246 4.34867 15.4527C4.507 15.651 4.74708 15.7664 5.00086 15.7661C5.29267 15.7658 5.63941 15.4884 6.33289 14.9336Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StorefrontIcon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7549 7.12045L18.7827 3.07416C18.579 2.24082 17.8568 1.66675 17.0142 1.66675H4.15309C3.31976 1.66675 2.58828 2.25008 2.39383 3.07416L1.42161 7.12045C1.19939 8.0649 1.40309 9.02786 1.99568 9.78712C2.06976 9.88897 2.17161 9.96305 2.25494 10.0556V16.4816C2.25494 17.5001 3.08828 18.3334 4.1068 18.3334H17.0698C18.0883 18.3334 18.9216 17.5001 18.9216 16.4816V10.0556C19.0049 9.9723 19.1068 9.88897 19.1809 9.79638C19.7735 9.03712 19.9864 8.0649 19.7549 7.12045ZM16.9864 3.50934L17.9586 7.55564C18.0512 7.94453 17.9679 8.33341 17.7272 8.63897C17.5975 8.80564 17.3198 9.07416 16.8568 9.07416C16.292 9.07416 15.8012 8.62045 15.7364 8.0186L15.1994 3.5186L16.9864 3.50934ZM11.5142 3.5186H13.329L13.829 7.70379C13.8753 8.0649 13.7642 8.42601 13.5235 8.69453C13.3198 8.93527 13.0235 9.07416 12.6438 9.07416C12.0235 9.07416 11.5142 8.52786 11.5142 7.86119V3.5186ZM7.33828 7.70379L7.84754 3.5186H9.66235V7.86119C9.66235 8.52786 9.15309 9.07416 8.46791 9.07416C8.15309 9.07416 7.86605 8.93527 7.64383 8.69453C7.41235 8.42601 7.30124 8.0649 7.33828 7.70379ZM3.21791 7.55564L4.15309 3.5186H5.97717L5.44013 8.0186C5.36605 8.62045 4.88457 9.07416 4.31976 9.07416C3.86605 9.07416 3.57902 8.80564 3.45865 8.63897C3.20865 8.34267 3.12531 7.94453 3.21791 7.55564ZM4.1068 16.4816V10.8982C4.18087 10.9075 4.24568 10.926 4.31976 10.926C5.12531 10.926 5.85679 10.5927 6.39383 10.0464C6.94939 10.6019 7.69013 10.926 8.53272 10.926C9.33828 10.926 10.0605 10.5927 10.5975 10.0649C11.1438 10.5927 11.8846 10.926 12.7179 10.926C13.4957 10.926 14.2364 10.6019 14.792 10.0464C15.329 10.5927 16.0605 10.926 16.8661 10.926C16.9401 10.926 17.0049 10.9075 17.079 10.8982V16.4816H4.1068Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function BarChart12Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 12H4.6C4.03995 12 3.75992 12 3.54601 12.109C3.35785 12.2049 3.20487 12.3578 3.10899 12.546C3 12.7599 3 13.0399 3 13.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 8.6C9 8.03995 9 7.75992 9.10899 7.54601C9.20487 7.35785 9.35785 7.20487 9.54601 7.10899C9.75992 7 10.0399 7 10.6 7H13.4C13.9601 7 14.2401 7 14.454 7.10899C14.6422 7.20487 14.7951 7.35785 14.891 7.54601C15 7.75992 15 8.03995 15 8.6V21M15 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H16.6C16.0399 3 15.7599 3 15.546 3.10899C15.3578 3.20487 15.2049 3.35785 15.109 3.54601C15 3.75992 15 4.03995 15 4.6V8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Bell01Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.79545 17.5C8.38306 18.0186 9.15493 18.3333 10.0003 18.3333C10.8457 18.3333 11.6175 18.0186 12.2052 17.5M15.0003 6.66663C15.0003 5.34054 14.4735 4.06877 13.5358 3.13109C12.5982 2.19341 11.3264 1.66663 10.0003 1.66663C8.67422 1.66663 7.40245 2.19341 6.46477 3.13109C5.52708 4.06877 5.0003 5.34054 5.0003 6.66663C5.0003 9.24178 4.35069 11.0049 3.62502 12.1711C3.01291 13.1549 2.70685 13.6467 2.71807 13.7839C2.7305 13.9359 2.76268 13.9938 2.88511 14.0846C2.99568 14.1666 3.49413 14.1666 4.49101 14.1666H15.5096C16.5065 14.1666 17.0049 14.1666 17.1155 14.0846C17.2379 13.9938 17.2701 13.9359 17.2825 13.7839C17.2938 13.6467 16.9877 13.1549 16.3756 12.1711C15.6499 11.0049 15.0003 9.24178 15.0003 6.66663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Bell03Icon(props: IconProps) {
  return (
    <svg
      width="21"
      height="20"
      {...props}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9998 15.8333C12.9998 17.214 11.8805 18.3333 10.4998 18.3333C9.11906 18.3333 7.99977 17.214 7.99977 15.8333M11.9969 5.1988C12.3598 4.82387 12.5831 4.31301 12.5831 3.75C12.5831 2.5994 11.6504 1.66666 10.4998 1.66666C9.34917 1.66666 8.41643 2.5994 8.41643 3.75C8.41643 4.31301 8.63977 4.82387 9.00268 5.1988M15.4998 9.33333C15.4998 8.18406 14.973 7.08186 14.0353 6.2692C13.0976 5.45654 11.8258 5 10.4998 5C9.17368 5 7.90192 5.45654 6.96423 6.2692C6.02655 7.08186 5.49977 8.18406 5.49977 9.33333C5.49977 11.2348 5.02821 12.6255 4.43982 13.6206C3.76922 14.7547 3.43391 15.3217 3.44715 15.4572C3.4623 15.6122 3.4902 15.6611 3.61588 15.753C3.72574 15.8333 4.27769 15.8333 5.38159 15.8333H15.6179C16.7218 15.8333 17.2738 15.8333 17.3837 15.753C17.5093 15.6611 17.5372 15.6122 17.5524 15.4572C17.5656 15.3217 17.2303 14.7547 16.5597 13.6206C15.9713 12.6255 15.4998 11.2348 15.4998 9.33333Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RatioHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33325 14.6667L1.33325 18C1.33325 19.1046 2.22868 20 3.33325 20L9.33325 20"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M9.33325 4L3.33325 4C2.22868 4 1.33325 4.89543 1.33325 6L1.33325 9.33333"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M22.6667 9.33333L22.6667 6C22.6667 4.89543 21.7713 4 20.6667 4L14.6667 4"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M14.6667 20L20.6667 20C21.7713 20 22.6667 19.1046 22.6667 18L22.6667 14.6667"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
}

export function RatioVerticalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 1.33331H6C4.89543 1.33331 4 2.22874 4 3.33331V9.33331"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M20 9.33331L20 3.33331C20 2.22874 19.1046 1.33331 18 1.33331L14.6667 1.33331"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M14.6667 22.6667L18 22.6667C19.1046 22.6667 20 21.7713 20 20.6667L20 14.6667"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M4 14.6667L4 20.6667C4 21.7713 4.89543 22.6667 6 22.6667L9.33333 22.6667"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
}

export function WidthIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.0799 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 9.33366L12.0001 8.00033L10.6667 6.66699"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 6.66634L3.99992 7.99967L5.33325 9.33301"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8H6.66667"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33325 8L11.9999 8"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HeightIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.0799 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2Z"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66659 10.667L7.99992 12.0003L9.33325 10.667"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33341 5.33301L8.00008 3.99967L6.66675 5.33301"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 4L8 6.66667"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 9.33301L8 11.9997"
        stroke="currentColor"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowStepsUpAndDownIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.9434 5.99967H7.05643C6.28861 5.99967 5.80724 5.17019 6.18819 4.50353L7.13168 2.85243C7.51557 2.18062 8.48427 2.18062 8.86816 2.85243L9.81165 4.50354C10.1926 5.17019 9.71123 5.99967 8.9434 5.99967Z"
        fill="currentColor"
      />
      <path
        d="M7.0566 10.0003L8.94357 10.0003C9.71139 10.0003 10.1928 10.8298 9.81181 11.4965L8.86832 13.1476C8.48443 13.8194 7.51573 13.8194 7.13184 13.1476L6.18835 11.4965C5.8074 10.8298 6.28877 10.0003 7.0566 10.0003Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function User01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 21.5C20 20.1044 20 19.4067 19.8278 18.8389C19.44 17.5605 18.4395 16.56 17.1611 16.1722C16.5933 16 15.8956 16 14.5 16H9.5C8.10444 16 7.40665 16 6.83886 16.1722C5.56045 16.56 4.56004 17.5605 4.17224 18.8389C4 19.4067 4 20.1044 4 21.5M16.5 8C16.5 10.4853 14.4853 12.5 12 12.5C9.51472 12.5 7.5 10.4853 7.5 8C7.5 5.51472 9.51472 3.5 12 3.5C14.4853 3.5 16.5 5.51472 16.5 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

User01Icon.src = getSrcFromImport(User01Image)

export function MagicWand01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14L9.99997 11M15.0103 3.5V2M18.9497 5.06066L20.0103 4M18.9497 13L20.0103 14.0607M11.0103 5.06066L9.94966 4M20.5103 9H22.0103M6.13134 20.8686L15.3686 11.6314C15.7646 11.2354 15.9626 11.0373 16.0368 10.809C16.1021 10.6082 16.1021 10.3918 16.0368 10.191C15.9626 9.96265 15.7646 9.76465 15.3686 9.36863L14.6313 8.63137C14.2353 8.23535 14.0373 8.03735 13.809 7.96316C13.6081 7.8979 13.3918 7.8979 13.191 7.96316C12.9626 8.03735 12.7646 8.23535 12.3686 8.63137L3.13134 17.8686C2.73532 18.2646 2.53732 18.4627 2.46313 18.691C2.39787 18.8918 2.39787 19.1082 2.46313 19.309C2.53732 19.5373 2.73533 19.7354 3.13134 20.1314L3.8686 20.8686C4.26462 21.2646 4.46263 21.4627 4.69095 21.5368C4.8918 21.6021 5.10814 21.6021 5.30899 21.5368C5.53732 21.4627 5.73533 21.2646 6.13134 20.8686Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CrownIcon(props: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      {...props}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Icon - Crown" clipPath="url(#clip0_6838_148580)">
        <path
          id="Vector"
          d="M10.7709 10.5686L2.32132 10.4829C2.14258 10.4811 1.99485 10.6259 1.99304 10.8046L1.98645 11.4546C1.98464 11.6333 2.1294 11.7811 2.30814 11.7829L10.7577 11.8685C10.9364 11.8703 11.0842 11.7256 11.086 11.5468L11.0926 10.8969C11.0944 10.7181 10.9496 10.5704 10.7709 10.5686ZM12.1367 4.0821C11.5984 4.07664 11.1573 4.50891 11.1519 5.04717C11.1504 5.19138 11.1815 5.32576 11.2372 5.45024L9.75768 6.31685C9.44299 6.50055 9.03986 6.39083 8.8623 6.07214L7.23627 3.15895C7.45542 2.98241 7.60032 2.71574 7.60341 2.41107C7.60886 1.87281 7.17659 1.43169 6.63834 1.42623C6.10008 1.42078 5.65896 1.85305 5.65351 2.3913C5.65042 2.69597 5.78988 2.96553 6.0054 3.14647L4.32066 6.0261C4.13667 6.34113 3.72937 6.44263 3.4205 6.25262L1.96092 5.35621C2.017 5.2349 2.05291 5.09916 2.05437 4.95495C2.05982 4.4167 1.62755 3.97558 1.0893 3.97012C0.551046 3.96467 0.107892 4.39691 0.102436 4.93517C0.0969806 5.47342 0.52925 5.91454 1.0675 5.92C1.12031 5.92054 1.17321 5.91295 1.22407 5.90534L2.65289 9.83627L10.4525 9.91533L11.9607 6.01417C12.0114 6.02281 12.0641 6.03147 12.1169 6.032C12.6552 6.03746 13.0963 5.60519 13.1018 5.06693C13.1072 4.52868 12.675 4.08756 12.1367 4.0821Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6838_148580">
          <rect
            width="13"
            height="13"
            fill="white"
            transform="translate(0.151855 0.0605469) rotate(0.580747)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function DarkModeIcon(props: IconProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd" transform="translate(-442 -200)">
        <g fill="currentColor" transform="translate(356 144)">
          <path
            fillRule="nonzero"
            d="M108.5 24C108.5 27.5902136 105.590214 30.5 102 30.5 98.4097864 30.5 95.5 27.5902136 95.5 24 95.5 20.4097864 98.4097864 17.5 102 17.5 105.590214 17.5 108.5 20.4097864 108.5 24zM107 24C107 21.2382136 104.761786 19 102 19 99.2382136 19 97 21.2382136 97 24 97 26.7617864 99.2382136 29 102 29 104.761786 29 107 26.7617864 107 24zM101 12.75L101 14.75C101 15.1642136 101.335786 15.5 101.75 15.5 102.164214 15.5 102.5 15.1642136 102.5 14.75L102.5 12.75C102.5 12.3357864 102.164214 12 101.75 12 101.335786 12 101 12.3357864 101 12.75zM95.7255165 14.6323616L96.7485165 16.4038616C96.9556573 16.7625614 97.4143618 16.8854243 97.7730616 16.6782835 98.1317614 16.4711427 98.2546243 16.0124382 98.0474835 15.6537384L97.0244835 13.8822384C96.8173427 13.5235386 96.3586382 13.4006757 95.9999384 13.6078165 95.6412386 13.8149573 95.5183757 14.2736618 95.7255165 14.6323616zM91.8822384 19.0244835L93.6537384 20.0474835C94.0124382 20.2546243 94.4711427 20.1317614 94.6782835 19.7730616 94.8854243 19.4143618 94.7625614 18.9556573 94.4038616 18.7485165L92.6323616 17.7255165C92.2736618 17.5183757 91.8149573 17.6412386 91.6078165 17.9999384 91.4006757 18.3586382 91.5235386 18.8173427 91.8822384 19.0244835zM90.75 25L92.75 25C93.1642136 25 93.5 24.6642136 93.5 24.25 93.5 23.8357864 93.1642136 23.5 92.75 23.5L90.75 23.5C90.3357864 23.5 90 23.8357864 90 24.25 90 24.6642136 90.3357864 25 90.75 25zM92.6323616 30.2744835L94.4038616 29.2514835C94.7625614 29.0443427 94.8854243 28.5856382 94.6782835 28.2269384 94.4711427 27.8682386 94.0124382 27.7453757 93.6537384 27.9525165L91.8822384 28.9755165C91.5235386 29.1826573 91.4006757 29.6413618 91.6078165 30.0000616 91.8149573 30.3587614 92.2736618 30.4816243 92.6323616 30.2744835zM97.0244835 34.1177616L98.0474835 32.3462616C98.2546243 31.9875618 98.1317614 31.5288573 97.7730616 31.3217165 97.4143618 31.1145757 96.9556573 31.2374386 96.7485165 31.5961384L95.7255165 33.3676384C95.5183757 33.7263382 95.6412386 34.1850427 95.9999384 34.3921835 96.3586382 34.5993243 96.8173427 34.4764614 97.0244835 34.1177616zM103 35.25L103 33.25C103 32.8357864 102.664214 32.5 102.25 32.5 101.835786 32.5 101.5 32.8357864 101.5 33.25L101.5 35.25C101.5 35.6642136 101.835786 36 102.25 36 102.664214 36 103 35.6642136 103 35.25zM108.274483 33.3676384L107.251483 31.5961384C107.044343 31.2374386 106.585638 31.1145757 106.226938 31.3217165 105.868239 31.5288573 105.745376 31.9875618 105.952517 32.3462616L106.975517 34.1177616C107.182657 34.4764614 107.641362 34.5993243 108.000062 34.3921835 108.358761 34.1850427 108.481624 33.7263382 108.274483 33.3676384zM112.117762 28.9755165L110.346262 27.9525165C109.987562 27.7453757 109.528857 27.8682386 109.321717 28.2269384 109.114576 28.5856382 109.237439 29.0443427 109.596138 29.2514835L111.367638 30.2744835C111.726338 30.4816243 112.185043 30.3587614 112.392183 30.0000616 112.599324 29.6413618 112.476461 29.1826573 112.117762 28.9755165zM113.25 23L111.25 23C110.835786 23 110.5 23.3357864 110.5 23.75 110.5 24.1642136 110.835786 24.5 111.25 24.5L113.25 24.5C113.664214 24.5 114 24.1642136 114 23.75 114 23.3357864 113.664214 23 113.25 23zM111.367638 17.7255165L109.596138 18.7485165C109.237439 18.9556573 109.114576 19.4143618 109.321717 19.7730616 109.528857 20.1317614 109.987562 20.2546243 110.346262 20.0474835L112.117762 19.0244835C112.476461 18.8173427 112.599324 18.3586382 112.392183 17.9999384 112.185043 17.6412386 111.726338 17.5183757 111.367638 17.7255165zM106.975517 13.8822384L105.952517 15.6537384C105.745376 16.0124382 105.868239 16.4711427 106.226938 16.6782835 106.585638 16.8854243 107.044343 16.7625614 107.251483 16.4038616L108.274483 14.6323616C108.481624 14.2736618 108.358761 13.8149573 108.000062 13.6078165 107.641362 13.4006757 107.182657 13.5235386 106.975517 13.8822384z"
            transform="translate(0 48)"
            stroke="currentColor"
            strokeWidth="0.25"
          />
          <path
            d="M98.6123,60.1372 C98.6123,59.3552 98.8753,58.6427 99.3368,58.0942 C99.5293,57.8657 99.3933,57.5092 99.0943,57.5017 C99.0793,57.5012 99.0633,57.5007 99.0483,57.5007 C97.1578,57.4747 95.5418,59.0312 95.5008,60.9217 C95.4578,62.8907 97.0408,64.5002 98.9998,64.5002 C99.7793,64.5002 100.4983,64.2452 101.0798,63.8142 C101.3183,63.6372 101.2358,63.2627 100.9478,63.1897 C99.5923,62.8457 98.6123,61.6072 98.6123,60.1372"
            transform="translate(3 11)"
          />
        </g>
        <polygon points="444 228 468 228 468 204 444 204" />
      </g>
    </svg>
  )
}

export function DesignReviewerIcon(props: IconProps) {
  return (
    <svg
      width="33"
      height="32"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 32"
      fill="none"
    >
      <path
        d="M15.9739 7.3841C15.6924 7.3841 15.4109 7.53566 15.2702 7.82795L13.7546 11.0756L10.2147 11.671C9.58685 11.7792 9.34869 12.5695 9.81419 13.0133L12.4339 15.4599L11.9035 18.9998C11.8277 19.4978 12.2283 19.8983 12.6721 19.8983C12.802 19.8983 12.9211 19.8658 13.0402 19.8009L16.1687 18.058L19.373 19.6602C19.4813 19.7143 19.6004 19.7468 19.7195 19.7468C20.185 19.7468 20.5855 19.3354 20.4881 18.8158L19.8061 15.2975L22.3176 12.7427C22.7722 12.2772 22.5016 11.5086 21.8521 11.422L18.3013 10.9781L16.645 7.80629C16.5043 7.52483 16.2337 7.39493 15.9522 7.39493L15.9739 7.3841ZM30.3067 0.867188H1.83584C0.872372 0.867188 0.0712891 1.7657 0.0712891 2.85907V24.4125C0.0712891 25.5059 0.872372 26.4044 1.83584 26.4044H2.60444H6.62068C6.73976 26.4044 6.83719 26.5018 6.83719 26.6209V29.1432C6.83719 30.2366 7.63827 31.1351 8.60174 31.1351H8.77494C9.59768 31.1351 10.2797 30.6588 10.2797 30.6588L16.2228 26.4477C16.2228 26.4477 16.3094 26.4044 16.3528 26.4044H30.3067C31.2702 26.4044 32.0713 25.5059 32.0713 24.4125V2.85907C32.0713 1.7657 31.2702 0.867188 30.3067 0.867188ZM28.5747 22.2366C28.5747 22.3557 28.4772 22.4531 28.3582 22.4531H17.0781C16.3852 22.4531 15.3135 22.9727 14.7398 23.4491L10.7127 26.4585C10.572 26.5668 10.3663 26.4694 10.3663 26.2853V24.445C10.3663 23.3516 9.5652 22.4531 8.60174 22.4531H3.77359C3.65451 22.4531 3.55708 22.3557 3.55708 22.2366V5.03498C3.55708 4.9159 3.65451 4.81847 3.77359 4.81847H28.369C28.4881 4.81847 28.5855 4.9159 28.5855 5.03498V22.2474L28.5747 22.2366Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LightModeIcon(props: IconProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fillRule="evenodd" transform="translate(-440 -200)">
        <path
          fill="currentColor"
          fillRule="nonzero"
          stroke="currentColor"
          strokeWidth="0.5"
          d="M102,21 C102,18.1017141 103.307179,15.4198295 105.51735,13.6246624 C106.001939,13.2310647 105.821611,12.4522936 105.21334,12.3117518 C104.322006,12.1058078 103.414758,12 102.5,12 C95.8722864,12 90.5,17.3722864 90.5,24 C90.5,30.6277136 95.8722864,36 102.5,36 C106.090868,36 109.423902,34.4109093 111.690274,31.7128995 C112.091837,31.2348572 111.767653,30.5041211 111.143759,30.4810139 C106.047479,30.2922628 102,26.1097349 102,21 Z M102.5,34.5 C96.7007136,34.5 92,29.7992864 92,24 C92,18.2007136 96.7007136,13.5 102.5,13.5 C102.807386,13.5 103.113925,13.5136793 103.419249,13.5407785 C101.566047,15.5446378 100.5,18.185162 100.5,21 C100.5,26.3198526 104.287549,30.7714322 109.339814,31.7756638 L109.516565,31.8092927 C107.615276,33.5209452 105.138081,34.5 102.5,34.5 Z"
          transform="translate(354.5 192)"
        />
        <polygon points="444 228 468 228 468 204 444 204" />
      </g>
    </svg>
  )
}

export function Expand05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 9L21 3M21 3H15M21 3V9M9 9L3 3M3 3L3 9M3 3L9 3M9 15L3 21M3 21H9M3 21L3 15M15 15L21 21M21 21V15M21 21H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Cursor04Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.40707 1.41379C1.94882 1.27901 1.7197 1.21162 1.56369 1.26977C1.42774 1.32045 1.32051 1.42768 1.26983 1.56363C1.21168 1.71963 1.27907 1.94876 1.41385 2.40701L5.61975 16.7071C5.74499 17.1329 5.80762 17.3458 5.93401 17.4447C6.0443 17.5309 6.1857 17.567 6.32383 17.5441C6.48212 17.5178 6.63906 17.3609 6.95292 17.047L10 13.9999L14.4343 18.4343C14.6323 18.6323 14.7313 18.7313 14.8455 18.7684C14.9459 18.801 15.0541 18.801 15.1545 18.7684C15.2687 18.7313 15.3677 18.6323 15.5657 18.4343L18.4343 15.5656C18.6323 15.3676 18.7313 15.2686 18.7684 15.1545C18.8011 15.054 18.8011 14.9459 18.7684 14.8454C18.7313 14.7313 18.6323 14.6323 18.4343 14.4343L14 9.99994L17.0471 6.95286C17.3609 6.63899 17.5179 6.48206 17.5441 6.32377C17.567 6.18564 17.531 6.04424 17.4447 5.93395C17.3459 5.80756 17.133 5.74493 16.7071 5.61969L2.40707 1.41379Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowStepUpIcon(props: IconProps) {
  return (
    <svg
      width="8"
      height="6"
      {...props}
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.27682 6H1.72318C0.955357 6 0.47399 5.17052 0.854937 4.50386L3.13176 0.519426C3.51565 -0.152389 4.48435 -0.152389 4.86824 0.519426L7.14506 4.50386C7.52601 5.17052 7.04464 6 6.27682 6Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ArrowStepDownIcon(props: IconProps) {
  return (
    <svg
      width="8"
      height="6"
      {...props}
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72318 5.48737e-07L6.27682 1.50645e-07C7.04464 8.352e-08 7.52601 0.829483 7.14506 1.49614L4.86824 5.48057C4.48435 6.15239 3.51565 6.15239 3.13176 5.48057L0.854936 1.49614C0.473989 0.829483 0.955356 6.15862e-07 1.72318 5.48737e-07Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FileHeart02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 9V5.8C17 4.11984 17 3.27976 16.673 2.63803C16.3854 2.07354 15.9265 1.6146 15.362 1.32698C14.7202 1 13.8802 1 12.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H9M9.5 10H5M6 14H5M13 6H5M13.9973 13.8306C13.1975 12.9216 11.8639 12.6771 10.8619 13.5094C9.85986 14.3418 9.71879 15.7335 10.5057 16.7179C11.2926 17.7024 13.9973 20 13.9973 20C13.9973 20 16.7019 17.7024 17.4888 16.7179C18.2757 15.7335 18.1519 14.3331 17.1326 13.5094C16.1134 12.6858 14.797 12.9216 13.9973 13.8306Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CloudCheckmarkIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 17.7428C21.2215 16.734 22 15.2079 22 13.5C22 10.4624 19.5376 8 16.5 8C16.2815 8 16.0771 7.886 15.9661 7.69774C14.6621 5.48484 12.2544 4 9.5 4C5.35786 4 2 7.35786 2 11.5C2 13.5661 2.83545 15.4371 4.18695 16.7935"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 17L11 20L17 14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CloudLoadingIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 17.7428C21.2215 16.734 22 15.2079 22 13.5C22 10.4624 19.5376 8 16.5 8C16.2815 8 16.0771 7.886 15.9661 7.69774C14.6621 5.48484 12.2544 4 9.5 4C5.35786 4 2 7.35786 2 11.5C2 13.5661 2.83545 15.4371 4.18695 16.7935"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StudioOutlineIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      {...props}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 1L13.512 6.23109C13.794 6.96432 13.935 7.33093 14.1542 7.63931C14.3486 7.91262 14.5874 8.15141 14.8607 8.34575C15.1691 8.56503 15.5357 8.70603 16.2689 8.98804L21.5 11L16.2689 13.012C15.5357 13.294 15.1691 13.435 14.8607 13.6542C14.5874 13.8486 14.3486 14.0874 14.1542 14.3607C13.935 14.6691 13.794 15.0357 13.512 15.7689L11.5 21L9.48804 15.7689C9.20603 15.0357 9.06503 14.6691 8.84575 14.3607C8.65141 14.0874 8.41262 13.8486 8.13931 13.6542C7.83093 13.435 7.46432 13.294 6.73109 13.012L1.5 11L6.73108 8.98804C7.46431 8.70603 7.83093 8.56503 8.13931 8.34575C8.41262 8.15141 8.65141 7.91262 8.84575 7.63931C9.06503 7.33093 9.20603 6.96431 9.48804 6.23108L11.5 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UploadCloud01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RefreshCW01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10C21 10 18.995 7.26822 17.3662 5.63824C15.7373 4.00827 13.4864 3 11 3C6.02944 3 2 7.02944 2 12C2 16.9706 6.02944 21 11 21C15.1031 21 18.5649 18.2543 19.6482 14.5M21 10V4M21 10H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function RefreshCW04Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.166 4.27182C15.9338 5.55976 17.0827 7.64604 17.0827 10.0007C17.0827 13.9127 13.9114 17.084 9.99935 17.084H9.58268M5.83268 15.7295C4.0649 14.4415 2.91602 12.3553 2.91602 10.0007C2.91602 6.08863 6.08733 2.91732 9.99935 2.91732H10.416M10.8327 18.6673L9.16602 17.0007L10.8327 15.334M9.16602 4.66732L10.8327 3.00065L9.16602 1.33398"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CrossIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4L4 12M4 4L12 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PackageIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 7.27777L12 12M12 12L3.49997 7.27777M12 12L12 21.5M21 16.0586V7.94147C21 7.59883 21 7.4275 20.9495 7.27471C20.9049 7.13953 20.8318 7.01545 20.7354 6.91076C20.6263 6.79242 20.4766 6.70922 20.177 6.54282L12.777 2.43171C12.4934 2.27415 12.3516 2.19537 12.2015 2.16448C12.0685 2.13715 11.9315 2.13715 11.7986 2.16448C11.6484 2.19537 11.5066 2.27415 11.223 2.43171L3.82297 6.54282C3.52345 6.70922 3.37369 6.79242 3.26463 6.91076C3.16816 7.01545 3.09515 7.13953 3.05048 7.27471C3 7.42751 3 7.59883 3 7.94147V16.0586C3 16.4012 3 16.5725 3.05048 16.7253C3.09515 16.8605 3.16816 16.9846 3.26463 17.0893C3.37369 17.2076 3.52345 17.2908 3.82297 17.4572L11.223 21.5683C11.5066 21.7259 11.6484 21.8047 11.7986 21.8356C11.9315 21.8629 12.0685 21.8629 12.2015 21.8356C12.3516 21.8047 12.4934 21.7259 12.777 21.5683L20.177 17.4572C20.4766 17.2908 20.6263 17.2076 20.7354 17.0893C20.8318 16.9846 20.9049 16.8605 20.9495 16.7253C21 16.5725 21 16.4012 21 16.0586Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 9.5L7.5 4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileCheck02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M14.5 19L16.5 21L21 16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileX02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 11H8M10 15H8M16 7H8M20 12V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M16 16L21 21M21 16L16 21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function File02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Copy06Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        id="Icon"
        d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Repeat03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon_2"
        d="M13 22L10 19M10 19L13 16M10 19H15C18.866 19 22 15.866 22 12C22 9.2076 20.3649 6.7971 18 5.67363M6 18.3264C3.63505 17.2029 2 14.7924 2 12C2 8.13401 5.13401 5 9 5H14M14 5L11 2M14 5L11 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Loading01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon"
        d="M12 2.25V4.75M12 18V22M5.75 12H2.25M21.25 12H19.75M18.4571 18.4571L17.75 17.75M18.6642 5.41579L17.25 6.83M4.92157 19.0784L7.75 16.25M5.12868 5.20868L7.25 7.33"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V19M12 19L19 12M12 19L5 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19V5M12 5L5 12M12 5L19 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowUpRightIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 6.66667C5.3731 6.66667 5 6.29357 5 5.83333C5 5.3731 5.3731 5 5.83333 5H14.1667C14.6269 5 15 5.3731 15 5.83333V14.1667C15 14.6269 14.6269 15 14.1667 15C13.7064 15 13.3333 14.6269 13.3333 14.1667V7.84518L6.42259 14.7559C6.09715 15.0814 5.56951 15.0814 5.24408 14.7559C4.91864 14.4305 4.91864 13.9028 5.24408 13.5774L12.1548 6.66667H5.83333Z"
        fill="currentcolor"
      />
    </svg>
  )
}

export function Speedometer03Icon(props: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      {...props}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 11C4 7.13401 7.13401 4 11 4M15.4999 6.5L10.9999 11M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11ZM12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10C11.5523 10 12 10.4477 12 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FingerPrint01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.91822 3.38565C8.40742 2.50524 10.1447 2 12 2C17.5228 2 22 6.47715 22 12C22 12.0331 21.9998 12.0662 21.9995 12.0993M3.38114 6.92585C2.50352 8.41335 2 10.1479 2 12C2 16.6596 5.18693 20.5748 9.5 21.685M20.7076 16.9206C19.3872 19.2522 17.1574 21.001 14.5 21.685M14.0893 6.37378C13.4387 6.13207 12.7348 6 12 6C8.68629 6 6 8.68629 6 12C6 12.7387 6.13351 13.4463 6.37772 14.0999M17.6251 9.90767C17.8675 10.5591 18 11.2641 18 12C18 15.3137 15.3137 18 12 18C11.2701 18 10.5707 17.8697 9.92373 17.631M12 10V14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CreditCardEditIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2 10H22V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.0799 19 5.2 19H11M14.5 21L16.525 20.595C16.7015 20.5597 16.7898 20.542 16.8721 20.5097C16.9452 20.4811 17.0147 20.4439 17.079 20.399C17.1516 20.3484 17.2152 20.2848 17.3426 20.1574L21.5 16C22.0523 15.4477 22.0523 14.5523 21.5 14C20.9477 13.4477 20.0523 13.4477 19.5 14L15.3426 18.1574C15.2152 18.2848 15.1516 18.3484 15.101 18.421C15.0561 18.4853 15.0189 18.5548 14.9903 18.6279C14.958 18.7102 14.9403 18.7985 14.905 18.975L14.5 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CreditCard01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 10H2M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CreditCard02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 10H2M11 14H6M2 8.2L2 15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19L18.8 19C19.9201 19 20.4802 19 20.908 18.782C21.2843 18.5903 21.5903 18.2843 21.782 17.908C22 17.4802 22 16.9201 22 15.8V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5L5.2 5C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.07989 2 8.2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LogOut01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CodeBrowserIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 9H2M14 17.5L16.5 15L14 12.5M10 12.5L7.5 15L10 17.5M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function BarLineChartIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 20V13M12 20V10M4 20L4 16M13.4067 5.0275L18.5751 6.96567M10.7988 5.40092L5.20023 9.59983M21.0607 6.43934C21.6464 7.02513 21.6464 7.97487 21.0607 8.56066C20.4749 9.14645 19.5251 9.14645 18.9393 8.56066C18.3536 7.97487 18.3536 7.02513 18.9393 6.43934C19.5251 5.85355 20.4749 5.85355 21.0607 6.43934ZM5.06066 9.43934C5.64645 10.0251 5.64645 10.9749 5.06066 11.5607C4.47487 12.1464 3.52513 12.1464 2.93934 11.5607C2.35355 10.9749 2.35355 10.0251 2.93934 9.43934C3.52513 8.85355 4.47487 8.85355 5.06066 9.43934ZM13.0607 3.43934C13.6464 4.02513 13.6464 4.97487 13.0607 5.56066C12.4749 6.14645 11.5251 6.14645 10.9393 5.56066C10.3536 4.97487 10.3536 4.02513 10.9393 3.43934C11.5251 2.85355 12.4749 2.85355 13.0607 3.43934Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Link05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H9M8 12L18 12M15.7778 17H17C19.7614 17 22 14.7614 22 12C22 9.23858 19.7614 7 17 7H15.7778C15.3482 7 15 7.34822 15 7.77778V16.2222C15 16.6518 15.3482 17 15.7778 17Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function LineChartUp04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 9L14.5515 13.6061C14.3555 13.746 14.2576 13.816 14.1527 13.8371C14.0602 13.8557 13.9643 13.8478 13.8762 13.8142C13.7762 13.7762 13.691 13.691 13.5208 13.5208L10.4792 10.4792C10.309 10.309 10.2238 10.2238 10.1238 10.1858C10.0357 10.1522 9.9398 10.1443 9.84732 10.1629C9.74241 10.184 9.64445 10.254 9.44853 10.3939L3 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Lightning01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.0008 2L4.09429 12.6879C3.74549 13.1064 3.57108 13.3157 3.56842 13.4925C3.5661 13.6461 3.63457 13.7923 3.7541 13.8889C3.89159 14 4.16402 14 4.70887 14H12.0008L11.0008 22L19.9074 11.3121C20.2562 10.8936 20.4306 10.6843 20.4333 10.5075C20.4356 10.3539 20.3671 10.2077 20.2476 10.1111C20.1101 10 19.8377 10 19.2928 10H12.0008L13.0008 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Settings01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      id="id"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FaceHappyIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM12 17.5C14.5005 17.5 16.5 15.667 16.5 14H7.5C7.5 15.667 9.4995 17.5 12 17.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FaceIdSquare(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17245 1.33325L10.8275 1.33325C11.3642 1.33324 11.8071 1.33324 12.1679 1.36272C12.5426 1.39333 12.8871 1.45904 13.2106 1.6239C13.7124 1.87957 14.1203 2.28751 14.376 2.78928C14.5409 3.11284 14.6066 3.4573 14.6372 3.83204C14.6667 4.19283 14.6667 4.63573 14.6666 5.17237V10.8275C14.6667 11.3641 14.6667 11.807 14.6372 12.1678C14.6066 12.5425 14.5409 12.887 14.376 13.2106C14.1203 13.7123 13.7124 14.1203 13.2106 14.3759C12.8871 14.5408 12.5426 14.6065 12.1679 14.6371C11.8071 14.6666 11.3642 14.6666 10.8275 14.6666H5.1725C4.63583 14.6666 4.1929 14.6666 3.8321 14.6371C3.45736 14.6065 3.1129 14.5408 2.78934 14.3759C2.28757 14.1203 1.87963 13.7123 1.62396 13.2106C1.4591 12.887 1.39339 12.5425 1.36278 12.1678C1.3333 11.807 1.3333 11.3641 1.33331 10.8274L1.33331 5.17239C1.3333 4.63574 1.3333 4.19283 1.36278 3.83204C1.39339 3.4573 1.4591 3.11283 1.62396 2.78928C1.87963 2.28751 2.28757 1.87956 2.78934 1.6239C3.1129 1.45904 3.45737 1.39333 3.8321 1.36271C4.19289 1.33324 4.6358 1.33324 5.17245 1.33325ZM3.94067 2.69162C3.6484 2.7155 3.49893 2.75878 3.39466 2.81191C3.14378 2.93974 2.9398 3.14372 2.81197 3.3946C2.75885 3.49886 2.71556 3.64833 2.69168 3.94061C2.66717 4.24067 2.66665 4.62887 2.66665 5.19992V10.7999C2.66665 11.371 2.66717 11.7592 2.69168 12.0592C2.71556 12.3515 2.75885 12.501 2.81197 12.6052C2.9398 12.8561 3.14378 13.0601 3.39466 13.1879C3.49893 13.241 3.6484 13.2843 3.94067 13.3082C4.24073 13.3327 4.62893 13.3333 5.19998 13.3333H10.8C11.371 13.3333 11.7592 13.3327 12.0593 13.3082C12.3516 13.2843 12.501 13.2411 12.6053 13.1879C12.8562 13.0601 13.0602 12.8561 13.188 12.6052C13.2411 12.501 13.2844 12.3515 13.3083 12.0592C13.3328 11.7592 13.3333 11.371 13.3333 10.7999V5.19992C13.3333 4.62887 13.3328 4.24067 13.3083 3.94061C13.2844 3.64834 13.2411 3.49887 13.188 3.3946C13.0602 3.14372 12.8562 2.93974 12.6053 2.81191C12.501 2.75878 12.3516 2.7155 12.0593 2.69162C11.7592 2.66711 11.371 2.66659 10.8 2.66659L5.19998 2.66659C4.62893 2.66659 4.24073 2.6671 3.94067 2.69162ZM4.99998 4.66659C5.36817 4.66659 5.66665 4.96506 5.66665 5.33325V6.33325C5.66665 6.70144 5.36817 6.99992 4.99998 6.99992C4.63179 6.99992 4.33331 6.70144 4.33331 6.33325V5.33325C4.33331 4.96506 4.63179 4.66659 4.99998 4.66659ZM8.33331 4.66659C8.7015 4.66659 8.99998 4.96506 8.99998 5.33325V7.39998C8.99998 8.30151 8.23484 9.06665 7.33331 9.06665C6.96512 9.06665 6.66665 8.76817 6.66665 8.39998C6.66665 8.03179 6.96512 7.73332 7.33331 7.73332C7.49846 7.73332 7.66665 7.56513 7.66665 7.39998V5.33325C7.66665 4.96506 7.96512 4.66659 8.33331 4.66659ZM11 4.66659C11.3682 4.66659 11.6666 4.96506 11.6666 5.33325V6.33325C11.6666 6.70144 11.3682 6.99992 11 6.99992C10.6318 6.99992 10.3333 6.70144 10.3333 6.33325V5.33325C10.3333 4.96506 10.6318 4.66659 11 4.66659ZM5.32871 9.66181C5.58906 9.40146 6.01117 9.40146 6.27151 9.66181C7.21117 10.6015 8.72239 10.6015 9.66204 9.66181C9.92239 9.40146 10.3445 9.40146 10.6048 9.66181C10.8652 9.92216 10.8652 10.3443 10.6048 10.6046C9.1445 12.065 6.78906 12.065 5.32871 10.6046C5.06836 10.3443 5.06836 9.92216 5.32871 9.66181Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Flag01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3L4 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Flag04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 7H19.6404C20.0877 7 20.3113 7 20.4421 7.09404C20.5562 7.17609 20.6306 7.30239 20.6469 7.442C20.6656 7.602 20.5569 7.79751 20.3397 8.18851L18.9936 10.6115C18.9148 10.7533 18.8755 10.8242 18.86 10.8993C18.8463 10.9657 18.8463 11.0343 18.86 11.1007C18.8755 11.1758 18.9148 11.2467 18.9936 11.3885L20.3397 13.8115C20.5569 14.2025 20.6656 14.398 20.6469 14.558C20.6306 14.6976 20.5562 14.8239 20.4421 14.906C20.3113 15 20.0877 15 19.6404 15H12.6C12.0399 15 11.7599 15 11.546 14.891C11.3578 14.7951 11.2049 14.6422 11.109 14.454C11 14.2401 11 13.9601 11 13.4V11M4 21L4 4M4 11H12.4C12.9601 11 13.2401 11 13.454 10.891C13.6422 10.7951 13.7951 10.6422 13.891 10.454C14 10.2401 14 9.96005 14 9.4V4.6C14 4.03995 14 3.75992 13.891 3.54601C13.7951 3.35785 13.6422 3.20487 13.454 3.10899C13.2401 3 12.9601 3 12.4 3H5.6C5.03995 3 4.75992 3 4.54601 3.10899C4.35785 3.20487 4.20487 3.35785 4.10899 3.54601C4 3.75992 4 4.03995 4 4.6V11Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Flag05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.0904 6.72222H20.0442C20.5163 6.72222 20.7524 6.72222 20.8904 6.82149C21.0109 6.9081 21.0893 7.04141 21.1065 7.18877C21.1263 7.35767 21.0116 7.56403 20.7823 7.97677L19.3615 10.5343C19.2783 10.684 19.2367 10.7589 19.2204 10.8381C19.206 10.9083 19.206 10.9806 19.2204 11.0508C19.2367 11.13 19.2783 11.2049 19.3615 11.3545L20.7823 13.9121C21.0116 14.3248 21.1263 14.5312 21.1065 14.7001C21.0893 14.8475 21.0109 14.9808 20.8904 15.0674C20.7524 15.1667 20.5163 15.1667 20.0442 15.1667H12.6126C12.0215 15.1667 11.7259 15.1667 11.5001 15.0516C11.3015 14.9504 11.14 14.7889 11.0388 14.5903C10.9237 14.3645 10.9237 14.0689 10.9237 13.4778V10.9444M7.2293 21.5L3.00708 4.61111M4.59045 10.9444H12.4015C12.9927 10.9444 13.2883 10.9444 13.5141 10.8294C13.7127 10.7282 13.8742 10.5667 13.9754 10.3681C14.0904 10.1423 14.0904 9.84672 14.0904 9.25556V4.18889C14.0904 3.59772 14.0904 3.30214 13.9754 3.07634C13.8742 2.87773 13.7127 2.71625 13.5141 2.61505C13.2883 2.5 12.9927 2.5 12.4015 2.5H4.64237C3.90504 2.5 3.53638 2.5 3.28422 2.65278C3.06322 2.78668 2.89901 2.99699 2.82271 3.24387C2.73566 3.52555 2.82508 3.88321 3.00391 4.59852L4.59045 10.9444Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function GraduationHat01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 10V16.0111C5 16.3701 5 16.5496 5.05465 16.708C5.10299 16.8482 5.18187 16.9758 5.28558 17.0817C5.40287 17.2014 5.5634 17.2817 5.88446 17.4422L11.2845 20.1422C11.5468 20.2734 11.678 20.339 11.8156 20.3648C11.9375 20.3877 12.0625 20.3877 12.1844 20.3648C12.322 20.339 12.4532 20.2734 12.7155 20.1422L18.1155 17.4422C18.4366 17.2817 18.5971 17.2014 18.7144 17.0817C18.8181 16.9758 18.897 16.8482 18.9453 16.708C19 16.5496 19 16.3701 19 16.0111V10M2 8.5L11.6422 3.67888C11.7734 3.61329 11.839 3.5805 11.9078 3.56759C11.9687 3.55616 12.0313 3.55616 12.0922 3.56759C12.161 3.5805 12.2266 3.61329 12.3578 3.67888L22 8.5L12.3578 13.3211C12.2266 13.3867 12.161 13.4195 12.0922 13.4324C12.0313 13.4438 11.9687 13.4438 11.9078 13.4324C11.839 13.4195 11.7734 13.3867 11.6422 13.3211L2 8.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CodeSquare02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 17L17 14L14 11M10 7L7 10L10 13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AtSignIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 7.99999V13C16 13.7956 16.3161 14.5587 16.8787 15.1213C17.4413 15.6839 18.2044 16 19 16C19.7957 16 20.5587 15.6839 21.1213 15.1213C21.6839 14.5587 22 13.7956 22 13V12C21.9999 9.74302 21.2362 7.55247 19.8333 5.78452C18.4303 4.01658 16.4706 2.77521 14.2726 2.26229C12.0747 1.74936 9.76794 1.99503 7.72736 2.95936C5.68677 3.92368 4.03241 5.54995 3.03327 7.57371C2.03413 9.59748 1.74898 11.8997 2.22418 14.1061C2.69938 16.3125 3.90699 18.2932 5.65064 19.7263C7.39429 21.1593 9.57144 21.9603 11.8281 21.9991C14.0847 22.0379 16.2881 21.3122 18.08 19.94M16 12C16 14.2091 14.2092 16 12 16C9.79087 16 8.00001 14.2091 8.00001 12C8.00001 9.79085 9.79087 7.99999 12 7.99999C14.2092 7.99999 16 9.79085 16 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ReceiptIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 7.8C4 6.11984 4 5.27976 4.32698 4.63803C4.6146 4.07354 5.07354 3.6146 5.63803 3.32698C6.27976 3 7.11984 3 8.8 3H15.2C16.8802 3 17.7202 3 18.362 3.32698C18.9265 3.6146 19.3854 4.07354 19.673 4.63803C20 5.27976 20 6.11984 20 7.8V21L17.25 19L14.75 21L12 19L9.25 21L6.75 19L4 21V7.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Wallet03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.5 14H16.51M3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7L5 7C3.89543 7 3 6.10457 3 5ZM3 5C3 3.89543 3.89543 3 5 3H17M17 14C17 14.2761 16.7761 14.5 16.5 14.5C16.2239 14.5 16 14.2761 16 14C16 13.7239 16.2239 13.5 16.5 13.5C16.7761 13.5 17 13.7239 17 14Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function NotificationTextIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M13 17H7M15 13H7M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AlignBottom01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21H21M12 3V17M12 17L19 10M12 17L5 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CondenseIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Icon_2"
        d="M3 21L10 14M10 14H4M10 14V20M21 3L14 10M14 10H20M14 10V4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HeartIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      {...props}
      viewBox="0 0 24 25"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9932 5.63581C9.9938 3.2984 6.65975 2.66964 4.15469 4.81001C1.64964 6.95038 1.29697 10.529 3.2642 13.0604C4.89982 15.1651 9.84977 19.6041 11.4721 21.0408C11.6536 21.2016 11.7444 21.2819 11.8502 21.3135C11.9426 21.3411 12.0437 21.3411 12.1361 21.3135C12.2419 21.2819 12.3327 21.2016 12.5142 21.0408C14.1365 19.6041 19.0865 15.1651 20.7221 13.0604C22.6893 10.529 22.3797 6.92787 19.8316 4.81001C17.2835 2.69216 13.9925 3.2984 11.9932 5.63581Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HeartsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5455 9.92543C15.9195 9.26103 16.2313 8.66151 16.4236 8.20521C17.3573 5.98947 16.434 3.44077 14.1769 2.40112C11.9199 1.36148 9.65341 2.4395 8.65871 4.52093C6.75657 3.2157 4.21918 3.40739 2.81989 5.44424C1.42059 7.48108 1.85975 10.142 3.77629 11.594C4.6461 12.253 6.36636 13.2242 7.98596 14.0884M16.2972 11.7499C15.8751 9.482 13.9454 7.82334 11.5156 8.27415C9.08592 8.72497 7.51488 10.9171 7.84335 13.299C8.10725 15.2127 9.56392 19.7027 10.1264 21.394C10.2032 21.6248 10.2415 21.7402 10.3175 21.8206C10.3837 21.8907 10.4717 21.9416 10.5655 21.9638C10.6732 21.9894 10.7923 21.9649 11.0306 21.916C12.7765 21.5575 17.3933 20.574 19.1826 19.8457C21.4096 18.9392 22.5589 16.4841 21.6981 14.153C20.8372 11.8219 18.4723 10.9815 16.2972 11.7499Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function HeartFilledIcon(props: IconProps) {
  return (
    <svg
      width={props.width || '24'}
      height={props.height || '24'}
      {...props}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9932 5.13581C9.9938 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.029 3.2642 12.5604C4.89982 14.6651 9.84977 19.1041 11.4721 20.5408C11.6536 20.7016 11.7444 20.7819 11.8502 20.8135C11.9426 20.8411 12.0437 20.8411 12.1361 20.8135C12.2419 20.7819 12.3327 20.7016 12.5142 20.5408C14.1365 19.1041 19.0865 14.6651 20.7221 12.5604C22.6893 10.029 22.3797 6.42787 19.8316 4.31001C17.2835 2.19216 13.9925 2.7984 11.9932 5.13581Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FlowCoinIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#FA7B13" d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Z" />
      <path fill="#FFB200" d="M12 21.01a9.01 9.01 0 1 0 0-18.03 9.01 9.01 0 0 0 0 18.04Z" />
      <path
        fill="#FFB200"
        d="M21.3 8.5c-.04.02.08-.12.17.02-.02 0-.13.06-.17-.02Zm-.86-1.2-.23-.12.17.13h.06Zm-.41-.49-.02.07.22-.03c-.2-.22-.51-.47-.6-.67-.12.24.31.39.4.63ZM19.6 5.4l-.08-.12c-.04.1-.16-.06.1.14-.01 0-.02 0-.02-.02Zm0 0c0-.12.1.13 0 0Zm-.3-.37c0-.06-.1-.2-.05-.18-.18-.1-.18-.04-.16.1l.2.08Zm-.46-.08.1.04c-.01-.04-.01-.06-.1-.04Zm.19.08c-.06.04.02.02.12.04l-.2-.1c-.02.06-.07.12.08.06Zm.1.31c.15.12.23.15.25.1.02-.04-.02-.14-.17-.26.04.12.1.24-.08.16Zm.41 1.15c-.04-.02-.06-.08-.08-.12-.02-.06-.06-.1-.08-.06l.04.14.12.04Zm-1.31-2.45c-.05.05-.02.15-.07.21l.15.04c-.02-.06-.13-.18-.08-.25Zm-.07.21-.2-.06c.14.12.18.12.2.06Zm.85.97-.43-.15.04.05.39.1Zm-1.3-1.69-.29.04h.13l.16-.04Zm-.66-.25c.13-.04-.04-.2.08-.2a.78.78 0 0 0-.43-.02c.13.02.23.08.35.22Zm-.37-.22c-.06 0-.14-.02-.22 0 .08.02.14 0 .22 0Zm.93.7v.16l.06.04c0-.04.02-.12-.06-.2Zm-.02.16c-.08-.06-.13-.1-.15-.1.02 0 .07.04.15.1Zm.1.04c-.02 0-.02 0 0 0-.02.02-.02.02 0 0Zm.33.83c.12-.02.06-.17.29-.15-.15 0-.41-.1-.29.15Zm-.1-.56-.25-.06c.06.04.1.1.16.16.02-.04.02-.1.09-.1Zm-.37-.08.12.02-.06-.06-.06.04Zm-.79-.78c-.12 0-.2-.05-.33-.09.1.09.23.17.33.2.04-.01.13-.05 0-.11Zm.42.26c-.02 0-.02.02 0 0Zm-1.86-.82v.04l.02-.02-.02-.02Zm1.44.72a.3.3 0 0 0 .21.06 1 1 0 0 1-.23-.08l.02.02Zm-.63-.56.12.15c-.02-.06-.08-.17-.12-.15Zm1 .6c0-.04 0-.02 0 0Zm0 0H17c.06.02.1.04.17.04-.03 0-.03-.02-.03-.04Zm-2.61-.1.25-.02c0 .04-.1.06-.06.12.04-.12.32-.18.47.04.23-.02.25-.47.14-.76-.02.06-.04.1-.26.1.06.09.4.31.18.37-.14-.02-.18-.04-.23-.08a.47.47 0 0 0-.1-.14c.08.18-.39.12-.39.37ZM15.74 3l.09.02a1.21 1.21 0 0 1-.25-.3c-.16 0-.2.05-.25.09l.41.19Zm.19.43c.25.1.2-.02.4-.02-.4-.17.14-.02-.11-.23.08.02.16.04.22.08l-.18-.16v.02c0 .02.02.04 0 .02l-.04.04c-.1-.08 0-.04.04-.04l.02-.02-.43-.1c.08.06.18.08.39.16-.15.08-.37.06-.31.25Zm1.75 1.44v-.04c-.04 0-.04.02 0 .04Zm.12-.15h-.04a.83.83 0 0 1-.14-.39c-.02.13-.04.23-.02.37.04 0 .08-.02.16.05.04.08-.04.06-.06.1.04 0 .2.04.1-.13Zm-1.1-.72.01-.06c.17.13.17.02.2-.02a1.74 1.74 0 0 0-.34-.1l.12.18ZM15.41 2.6c-.09.05-.19.09-.27.15l.18-.02.09-.13Zm-.52-.1-.14.04.08.08.06-.12ZM7.06 18.53l.1.02-.1-.02Zm-.5-.44-.06.04c.04-.02.09-.02.07-.04ZM4.37 6.11c-.18.04-.45.09-.33.15l.15.04a.4.4 0 0 1 .18-.19Zm-1.05 7.45c.02-.02.02-.04.04-.04-.06-.02-.1-.06-.14-.08l.1.13Zm.56.19.06-.19-.06.19Zm6.42 6.18.12-.13c-.16-.02-.1.06-.12.13ZM10 2.53c-.14-.02-.24-.02-.35-.02.19.04.35.15.35.02ZM5.87 19.51c.06.02.1.02.12 0-.06-.04-.1-.04-.12 0ZM9.28 2.64h.08c.09-.05.19-.1.3-.13-.13-.02-.28-.02-.38.13Zm10.9 11.3c0-.05 0-.03 0 0Zm1.41-3.9c0-.04 0-.08-.04-.18.02.04.02.12.04.19ZM12.97 2.2c.02-.02.1 0 0 0Zm.4.6-.03.06c.02-.02.04-.04.04-.06Zm-4.7.99c.04.02.04.02 0 0Zm4.44-1.5L13 2.22c.03.03.08.05.12.07Zm-.02-.09.08.02c.02-.02.02-.02-.08-.02Zm-.12 0h-.15l.17.02c-.02 0-.02-.02-.02-.02Zm3.29 17.42c.04-.07.06-.1 0 0ZM4.42 9.28c-.12-.18-.06-.24 0-.33l-.4-.06c.12.15.26.27.4.4Zm17 4.8c0 .08.09.06.15.04-.23.19.04.25.04.4-.12.07-.25.18-.37.26.04.16.17.08.2.1-.06.33-.24.62-.38.9a.96.96 0 0 0-.1.21c-.05.07-.09.13-.11.21a1.4 1.4 0 0 0-.14.41c-.17.1-.19-.14-.33.04.2-.06.16.1.08.27-.08.16-.17.33-.02.3-.19.03-.31.17-.43.3-.13.12-.23.18-.4.02-.18.18.03.29.1.24l-.26.33a.73.73 0 0 0-.08.19l-.08.18c-.1.02-.31.31-.58.58-.29.25-.6.47-.8.43.28.06.06.1-.04.27l.24.06-.35.23c-.06.06-.08.06-.1.06-.06.04-.04-.1-.23-.04-.12.08-.16.14-.2.18-.04.07-.04.13-.09.21h.07l-.17.1c-.12.07.35-.4-.1-.26.02.04-.1.39-.27.35.2-.1.12-.21.02-.21-.1.04-.18.1-.29.14.07.07.15.1.21.17-.87.41-1.85.6-2.84.78-.02-.2-.7.08-.66-.25l.04.02c.23-.06-.1-.22-.29-.18.2.08-.35.35.17.33-.13.06-.25.14-.37.18-.1.3-.37.3-.68.23-.17-.02-.33-.08-.5-.12a1 1 0 0 0-.49-.02c.04-.02.06-.05.06-.07a.93.93 0 0 1-.4 0c-.15-.02-.28-.08-.4-.12-.23-.08-.41-.2-.47-.18v-.17c-.5.1-.58.14-1.05-.16.02-.02.08-.04.02-.1a.57.57 0 0 1-.27.05.7.7 0 0 1-.4-.12l.05-.04-.54-.25c.07-.1.02-.18-.06-.22a2.2 2.2 0 0 0-.35-.13c-.27-.08-.55-.18-.47-.45-.17.06-.54-.16-.74-.23.02-.02.02-.04 0-.08-.19.04-.29-.1-.37-.25-.08-.14-.15-.32-.25-.39-.16-.06-.16.05-.18.15-.05-.19-.23-.31-.42-.41-.18-.1-.37-.19-.37-.25-.14-.2.1-.19.15-.3-.25-.26-.33.32-.46-.2.05.05.13.1.13.07-.04-.09.02-.3.06-.46.04-.18.06-.33-.02-.37l-.02.15c-.15-.1-.15-.33-.15-.5 0-.16-.02-.28-.18-.24l-.12.1-.07-.29c-.02-.06-.04-.08-.06-.1-.04-.04-.08-.1-.12-.4h.02c-.12-.2 0-.38-.27-.42v.08c-.1-.29-.1-.31-.18-.62-.04-.02-.13-.17-.09-.2-.2.04-.24-.69-.26-.83.08.23.14.1.2.02-.1-.06-.16-.1-.18-.16-.02-.07 0-.15.04-.25-.27 0-.54 0-.6-.41.04.06.08.16.12.1.05-.04-.02-.14-.04-.16.04-.04.1.08.19.02-.29-.25-.04-.48-.15-.87.09.13.13.02.23-.02-.14-.02-.08-.14-.04-.27.06-.1.1-.18-.08-.12.14-.37.18-.86.27-1.28.04-.2.06-.4.14-.55a.83.83 0 0 1 .2-.33c.13-.04.03-.29.05-.43l.12.06c-.1-.41.02-.29-.04-.78.08.22.16.18.35.06L3.4 8l.2.05c-.02-.15.08-.25.17-.35-.02.06 0 .04.04.04-.1-.1-.1-.25-.06-.41.04-.15.1-.29.08-.37.3.02.14-.35.4-.3 0-.05 0-.11.03-.18-.14-.02-.27-.08-.14-.14 0 0 0-.02.02-.02l.16.04c.04-.12.1-.23.17-.3l-.15.05.17-.08L4.5 6s0 .02-.02.02c.08-.04.14-.08.16-.2.23-.1.33-.31.45-.56l.2-.33a.7.7 0 0 1 .36-.17c-.08.03-.17.09-.14.15.3-.29.74-.37.88-.6l-.1-.1c.2-.23.37-.41.57-.54l-.02-.12c.17-.06.4-.25.62-.39.1-.07.21-.12.33-.14.1-.03.2-.03.29.04.02-.15.45-.17.64-.27l.08.1c.27-.04.39-.12.53-.22.3.04.54 0 .77-.09.22-.08.45-.2.67-.2v.04l.46-.15c-.1.13.08-.08.22-.08.15-.06.4-.04.58.04h.3c-.32.09.03.19.05.33.06-.04.12-.08.19-.1.06.08-.13.1.02.14.12-.06.49-.04.61-.16a.25.25 0 0 0-.1-.1c-.02 0-.02 0 0 0l.06-.07c.23.07.15-.02.15-.08.12.13.22.17.3.2.09.05.19.09.25.23-.22-.35.6.1.5-.2.14.27.12.04.2.27-.25-.15-.57.02-.8.08l.18.18c-.18.23-.45-.18-.6-.12.11-.04.28.04.28.1l-.03-.2a.46.46 0 0 0-.2-.06.7.7 0 0 0-.2.02c-.13.02-.25.08-.38.12.19.08-.24.1-.12.25l.16-.02c.07.08-.08.12-.18.18-.48-.18-1.38-.02-1.57-.14.1.04.3-.02.37-.1l-.24-.07c.1-.02.18.02.29.04.1.02.2.07.35.02-.07-.12.14-.3-.09-.47-.28-.1-.39 0-.51.12a.76.76 0 0 1-.58.27c-.06.04.1-.22-.22-.1-.42.23-.66.58-.58.84.14-.12.45-.35.56-.16-.17.12-.44.22-.42.35-.22-.19.31-.15.02-.27-.12.04-.14.12-.18.17.06-.13-.15-.13-.2-.17-.2.06-.36.08-.52.1l-.25.04-.29.1c-.04-.01-.1-.05-.12-.12-.19.15-.3.58-.17.68-.2.1-.26.02-.4.19.38.02-.09 0 0 .2-.17.13-.13-.06-.23-.06-.02.04-.04.15-.02.2-.2-.07-.02-.49-.25-.59a1.28 1.28 0 0 0-.41-.02l-.31.04c.02.23.5.83.76.97.06.12-.23 0-.3.04-.17 0-.23.08-.28.19-.04.1-.06.22-.16.24l.04-.2c-.06-.02-.25.24-.25.33-.06-.04-.12-.4-.26-.4a.64.64 0 0 0-.19.23.65.65 0 0 0-.06.29c0 .19.04.35.14.43.09-.18.15-.39.25-.57.06.06.02.16-.02.26s-.06.23.02.3l-.41.32c.04-.04.14-.23.02-.25-.14.17-.1.07-.27.13l-.04-.74c-.02-.3-.06-.58-.08-.74l-.15.3h-.06c-.08.21-.06.5 0 .75a3 3 0 0 0 .23.57c-.17.15-.43-.16-.45-.25-.3.35.16.66-.09 1l.17-.09c-.02.1-.29.37-.2.37-.13.02-.4-.04-.4-.16.04.16.08.35.15.51 0-.06-.31-.18-.35-.23-.09.15.2.4.28.33-.33.17-.18.15-.53.25-.02.08.3.12.37.08 0 .2-.08.31-.15.37 0-.35-.61-.35-.82-.51.2.35.4.7.62 1l-.35-.2c.12.08.14.31.1.56-.02.12-.04.27-.08.39-.02.12-.04.25-.08.35v-.06c-.08-.1-.23.22-.15.37-.04-.04-.02-.06-.02-.13-.26.23.37.4.1.62.05-.22-.06-.29-.16-.29.08.2-.06.66.27.58-.08.12-.04.23-.2.23l.2.47c-.04-.04-.12-.06-.15.08.05-.27-.26-.53-.06-.68-.2-.02-.33.08-.47-.06.04.29.16.5.29.68l.2.25.23.22-.1.48h.1l-.23.12c.07.04.13.08.1.1-.01.02-.06 0-.08-.02.02.04.07.08.09.1-.13.05-.27-.02-.42-.08.05-.04.09-.1.1-.14-.12-.08-.24-.12-.3.02l.06.06c-.1-.04-.16-.08-.2-.02.04.12.1.25.18.35l.12-.2c.2.2.44.4.56.18l-.08.29c.29.25.22.2.51.51-.06.04-.16-.04-.2.06.16.09.14.27.12.44-.02.16-.04.3.06.29.14.18.23 0 .35.1-.02 0-.08.02-.06.06l.23.08c-.02.08-.17-.08-.17.1.12.13.23.21.31.31.08.09.14.19.16.33.23.31.21-.3.33-.02-.1.13-.2.23-.1.41.14.05.23-.04.37.07l-.18.12c.1.12.2.2.08.3.16.05.2.13.22.21.25.13.21-.4.23-.49.04.27.2.35.1.62L6 17.4c.06.27.18.3.27.33.1.02.14.02.06.27a.55.55 0 0 0-.2-.12c-.07-.02-.13 0-.15.08.08.04.16.06.25.08-.03.06-.13-.06-.09.06.09.02.27.05.35.02h-.02l.33.27c-.06-.06-.12-.02-.06.04l.29.09c-.1 0-.08.1 0 .2.24.27.5-.2.6.13-.05-.03-.05 0-.09-.05l.06.15c.15-.19.31-.08.5.02.18.1.37.16.47-.02.08.24-.04.1-.35.16l.13.2c-.09-.01-.15-.07-.25-.07.16.28.51.2.7.16.06.1-.23.27.1.33.43.08.04-.33.31-.29l.08.29c.08-.02.17 0 .25.02l.2.06c.13.06.25.15.38.19.06 0 .1-.02.12-.04.27.16.64-.1.84 0-.06.04.1.16.13.2l.4-.1c-.18.04-.18.18-.22.3.12 0 .19-.05.29-.07-.06.04-.1.08-.04.14l.22-.08c.09-.04.15-.09.21-.1-.02-.03-.08-.03-.1-.05"
      />
      <path
        fill="#FA7B13"
        d="m7.22 17.06.1-.65.44-2.45a.62.62 0 0 0-.2-.58l-1.45-1.4-.7-.7a1.08 1.08 0 0 1-.3-1.13c.12-.41.47-.72.9-.76.86-.15 1.75-.27 2.61-.4L9 8.94a.62.62 0 0 0 .52-.37c.43-.88.86-1.79 1.32-2.67.26-.56.92-.78 1.48-.54.2.1.39.27.5.48l.71 1.46c.2.43.41.86.64 1.27a.6.6 0 0 0 .5.35l2.94.44a1.14 1.14 0 0 1 1 .88 1.09 1.09 0 0 1-.32 1.03l-1.11 1.1-1.05 1.02a.54.54 0 0 0-.17.51c.13.7.25 1.4.35 2.1.06.33.13.66.17 1a1.06 1.06 0 0 1-.48 1.04 1 1 0 0 1-1.1.06l-2.73-1.42a.66.66 0 0 0-.61 0l-2.7 1.42a1.14 1.14 0 0 1-1.5-.5 1.2 1.2 0 0 1-.13-.53Z"
      />
    </svg>
  )
}

export function FlowCoinSingleColorIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 0.000101451C16.9808 -0.0203972 21.4476 3.06717 23.2178 7.73936C23.7343 9.10036 23.9995 10.5444 24 12.0001C24 18.6281 18.628 24.0001 12 24.0001C5.372 24.0001 0 18.6281 0 12.0001C0.000165048 5.37274 5.3721 0.000101451 12 0.000101451ZM11.8389 2.08799C11.6534 2.00605 11.4067 1.98506 11.2627 2.04698C11.1187 2.04698 10.9331 2.25251 11.0361 2.12901L10.584 2.27354V2.23155C10.3576 2.23155 10.1307 2.3551 9.9043 2.4376C9.67783 2.52009 9.43052 2.56158 9.14258 2.52061C8.99864 2.62356 8.87481 2.70568 8.60742 2.74717L8.52539 2.64366C8.34048 2.74611 7.90759 2.76741 7.88672 2.91123C7.80427 2.84944 7.70101 2.84925 7.59863 2.87022C7.47924 2.89155 7.36629 2.94065 7.26953 3.01377C7.04317 3.15768 6.81732 3.34326 6.65234 3.40538L6.67285 3.52842C6.46689 3.6519 6.30166 3.83713 6.0957 4.06358L6.19922 4.16709C6.05515 4.39338 5.62335 4.47608 5.31445 4.76377C5.29368 4.70184 5.37609 4.64022 5.45801 4.61924C5.31415 4.64022 5.2113 4.7019 5.1084 4.78428C5.02648 4.88718 4.96379 4.99004 4.90234 5.11338C4.77886 5.36034 4.67612 5.56651 4.4502 5.67002C4.43031 5.78606 4.37315 5.82871 4.29785 5.86729C4.29199 5.87528 4.28526 5.88172 4.28516 5.89561C4.25739 5.91397 4.23308 5.92747 4.20996 5.93955C4.22868 5.9309 4.24732 5.92468 4.26465 5.91612C4.20273 5.99851 4.14061 6.10143 4.09961 6.22471L3.93457 6.1837C3.91565 6.18397 3.91417 6.20301 3.91406 6.20518C3.79148 6.26659 3.91482 6.32826 4.05859 6.34873C4.03816 6.41003 4.03809 6.472 4.03809 6.5333C3.77066 6.47136 3.93496 6.84239 3.62598 6.82139C3.64696 6.90382 3.58495 7.04811 3.54395 7.19248C3.50246 7.35693 3.50257 7.5016 3.60547 7.60459C3.56449 7.6046 3.54396 7.62459 3.56445 7.5626C3.48207 7.66545 3.37978 7.76854 3.40039 7.91221L3.19434 7.87217C3.23527 8.01587 3.27645 8.13951 3.31738 8.2628C3.13251 8.3862 3.05024 8.42755 2.96777 8.20127C3.02973 8.69507 2.90638 8.57226 3.00879 8.9835L2.88477 8.921C2.86427 9.06548 2.96716 9.31256 2.84375 9.35362C2.7614 9.41558 2.6996 9.53899 2.6377 9.68272C2.55576 9.8266 2.53557 10.0326 2.49414 10.2384C2.41165 10.6498 2.37051 11.1448 2.22656 11.5147C2.41179 11.4534 2.37 11.5354 2.30859 11.6378C2.26713 11.7612 2.20611 11.8852 2.34961 11.9064C2.2469 11.9475 2.20544 12.0497 2.12305 11.9259C2.22603 12.3173 1.97974 12.5442 2.26758 12.7911C2.18565 12.8526 2.12303 12.7299 2.08203 12.7706C2.10301 12.7916 2.16434 12.8946 2.12305 12.9356C2.08216 12.9965 2.04138 12.894 2 12.8321C2.06198 13.2435 2.32929 13.2433 2.59668 13.2433C2.55581 13.3459 2.5355 13.4289 2.55566 13.4903C2.57616 13.5523 2.63826 13.5939 2.74121 13.6554C2.67971 13.7379 2.61715 13.8609 2.53516 13.6349C2.55565 13.7788 2.59694 14.4985 2.80273 14.4581C2.76147 14.4992 2.84425 14.6435 2.88574 14.6642C2.96768 14.9724 2.96751 14.9939 3.07031 15.2814V15.1993C3.33775 15.2408 3.21454 15.426 3.33789 15.6319H3.31738C3.35834 15.9195 3.40045 15.9811 3.44141 16.0226C3.46184 16.043 3.48299 16.0644 3.50293 16.1261C3.53225 16.2198 3.55264 16.3167 3.56445 16.4142L3.68848 16.3106C3.85294 16.27 3.87303 16.393 3.87305 16.5577C3.87305 16.7222 3.87318 16.9488 4.01758 17.0519L4.03809 16.9073C4.12006 16.9483 4.09957 17.0935 4.05859 17.2784C4.01762 17.4428 3.95527 17.649 3.99609 17.7315C3.99562 17.7718 3.91449 17.7104 3.87305 17.67C3.99649 18.1834 4.0793 17.6079 4.32617 17.8546C4.28519 17.978 4.03811 17.9575 4.18164 18.1632C4.18164 18.2252 4.36776 18.3073 4.55273 18.4103C4.73753 18.5132 4.92318 18.6367 4.96484 18.8214C4.98473 18.7191 4.98481 18.6165 5.14941 18.6778C5.25233 18.7398 5.31408 18.9245 5.39648 19.0685C5.47843 19.2129 5.58182 19.3568 5.7666 19.3155C5.77918 19.3416 5.78255 19.3594 5.7793 19.3741C5.78167 19.3756 5.78465 19.3764 5.78711 19.378C5.78454 19.3805 5.78057 19.3811 5.77734 19.3829C5.77487 19.3881 5.77134 19.3937 5.7666 19.3985C5.97248 19.46 6.34267 19.6862 6.50781 19.6251C6.42625 19.8928 6.7141 19.9948 6.98145 20.0772C7.10124 20.1085 7.21819 20.1504 7.33105 20.2013C7.41345 20.2423 7.45388 20.3245 7.39258 20.4269L7.92773 20.6739L7.88672 20.7159C8.05122 20.8189 8.17532 20.839 8.27832 20.839C8.38067 20.8389 8.46398 20.8189 8.5459 20.7774C8.60696 20.8388 8.54625 20.8596 8.52539 20.88C8.99863 21.1888 9.08108 21.148 9.57422 21.045V21.2101C9.63626 21.1897 9.82202 21.3122 10.0479 21.3946C10.1713 21.4356 10.295 21.4982 10.4395 21.5187C10.5628 21.5391 10.7068 21.5595 10.8506 21.5187C10.8503 21.539 10.8302 21.5599 10.7891 21.5802C10.954 21.5387 11.1188 21.5592 11.2832 21.6007C11.4481 21.6417 11.6129 21.7032 11.7773 21.7237C12.086 21.7851 12.3529 21.7855 12.4561 21.4981C12.5795 21.4571 12.7037 21.3746 12.8271 21.3126C12.3465 21.3322 12.7993 21.0999 12.6934 21.0021C12.7413 20.9985 12.7892 20.9956 12.8369 20.9913C12.9885 21.0273 13.113 21.1238 12.9502 21.1681L12.9092 21.1476C12.8682 21.4769 13.5474 21.1896 13.5684 21.3946C14.5562 21.2097 15.5434 21.0238 16.4082 20.6124C16.3463 20.5506 16.264 20.5097 16.2021 20.4483C16.305 20.4069 16.3879 20.3453 16.4902 20.3038C16.5932 20.3038 16.6756 20.4069 16.4697 20.5099C16.6347 20.5509 16.7583 20.2008 16.7373 20.1593C17.1902 20.0153 16.7173 20.4889 16.8408 20.4269L17.0059 20.3243H16.9434C16.9842 20.242 16.9849 20.1802 17.0264 20.1183C17.0673 20.0778 17.1082 20.015 17.2314 19.9327C17.4168 19.8713 17.3965 20.0157 17.458 19.9747C17.4785 19.9747 17.4991 19.9742 17.5605 19.9122L17.9111 19.6866L17.6641 19.6251C17.7671 19.4607 17.9933 19.419 17.7051 19.3575C17.911 19.3984 18.2194 19.1718 18.5078 18.9249C18.7753 18.6574 18.9815 18.3688 19.084 18.3478C19.105 18.2865 19.1456 18.2249 19.166 18.1632C19.1848 18.0982 19.2132 18.036 19.249 17.9786C19.3315 17.8757 19.4136 17.772 19.5166 17.6485C19.4341 17.6895 19.2282 17.5864 19.4131 17.4015C19.5776 17.566 19.6812 17.5045 19.8047 17.381C19.9281 17.2575 20.0525 17.1139 20.2373 17.0929C20.0928 17.1139 20.1753 16.9493 20.2578 16.7843C20.3402 16.6199 20.3806 16.4548 20.1748 16.5167C20.3192 16.3314 20.3399 16.5777 20.5049 16.4747C20.5255 16.331 20.587 16.1869 20.6484 16.0636C20.669 15.9812 20.711 15.9195 20.752 15.8575C20.7779 15.7852 20.8121 15.7156 20.8545 15.6515C20.9984 15.3642 21.1836 15.0759 21.2451 14.7472C21.2045 14.7263 21.081 14.808 21.04 14.6437C21.163 14.5612 21.2867 14.458 21.4102 14.3761C21.4098 14.2318 21.1428 14.1693 21.3691 13.9845C21.3071 14.005 21.2246 14.026 21.2246 13.9435C21.4915 13.3265 21.5332 12.6464 21.4717 12.1114C21.4507 11.7616 21.4512 11.4325 21.4307 11.1036C21.4307 10.9388 21.4302 10.7538 21.4512 10.589C21.4716 10.4246 21.4718 10.2592 21.5127 10.0743C21.4303 10.2799 21.4101 10.1567 21.3691 10.0333C21.3691 10.1356 21.2456 10.054 21.1631 10.0948C21.1836 9.88907 21.2246 9.70389 21.2451 9.49815C20.9985 9.45672 21.0394 8.92153 20.834 8.94248L20.916 9.08604C20.7812 9.02336 20.682 9.10633 20.5869 9.22276C19.6706 6.40865 17.4094 4.20333 14.5605 3.36631C14.6574 3.29044 14.8698 3.28266 14.9873 3.4669C15.2138 3.44688 15.2348 2.99367 15.1318 2.70518C15.1118 2.76714 15.0905 2.80769 14.8643 2.80772C14.9263 2.89021 15.2757 3.11729 15.0488 3.17881C14.9055 3.15832 14.8642 3.13729 14.8232 3.0958C14.8028 3.05493 14.7815 3.01406 14.7197 2.95225C14.7998 3.13177 14.3574 3.07942 14.3311 3.30186C13.7668 3.15229 13.1811 3.05579 12.5791 3.01866C12.6498 2.98132 12.7039 2.9465 12.6621 2.89073L12.4971 2.91123C12.3745 2.76751 12.806 2.74661 12.6211 2.66416C12.744 2.6232 12.8678 2.56167 12.9912 2.54112C13.0584 2.52414 13.1281 2.51722 13.1973 2.52061C13.2587 2.52061 13.3214 2.54116 13.4033 2.58213L13.4238 2.78721C13.4227 2.72783 13.2718 2.65093 13.1689 2.68077V2.68174C13.316 2.64744 13.5732 3.02773 13.7529 2.80772L13.5684 2.62315C13.7948 2.56108 14.1233 2.3974 14.3701 2.54112C14.2882 2.315 14.3088 2.54053 14.165 2.27354C14.2673 2.58133 13.445 2.1292 13.6709 2.47862C13.6089 2.33484 13.5058 2.29401 13.4238 2.25303C13.3414 2.21207 13.2386 2.17023 13.1152 2.04698C13.1155 2.10845 13.1969 2.19041 12.9707 2.12901L12.9092 2.19053C12.953 2.21375 12.9885 2.25027 13.0117 2.29405C12.888 2.41715 12.5181 2.39675 12.3945 2.45811C12.2508 2.41716 12.4355 2.39684 12.374 2.31455C12.3127 2.33501 12.2508 2.37621 12.1895 2.41709C12.1681 2.27273 11.8188 2.17044 12.1475 2.08799H11.8389ZM5.7793 19.3741C5.72158 19.3381 5.68374 19.3389 5.66406 19.378C5.71744 19.3958 5.75479 19.3961 5.77734 19.3829C5.77861 19.3802 5.77863 19.3771 5.7793 19.3741ZM10.7734 5.63487C11.041 5.07899 11.6994 4.85224 12.2549 5.09971C12.4608 5.20222 12.6456 5.36742 12.748 5.57334C12.995 6.06722 13.2218 6.5609 13.4688 7.03428C13.6748 7.46628 13.8814 7.89915 14.1074 8.31065C14.19 8.49534 14.3749 8.63963 14.6006 8.66026L17.5449 9.09287C17.7849 9.11472 18.0122 9.21224 18.1934 9.37119C18.3744 9.53014 18.4999 9.74261 18.5527 9.97764C18.5926 10.163 18.5831 10.3557 18.5254 10.5362C18.4677 10.7167 18.3635 10.8791 18.2236 11.0069C17.8532 11.3774 17.4827 11.7268 17.1123 12.0978L16.0625 13.1271C15.9918 13.1905 15.9391 13.2719 15.9102 13.3624C15.8813 13.4528 15.8768 13.5491 15.8975 13.6417C16.0215 14.3412 16.1446 15.0418 16.2471 15.7413C16.309 16.0706 16.3711 16.3998 16.4121 16.7286C16.4423 16.9306 16.414 17.1372 16.3301 17.3233C16.2462 17.5093 16.1106 17.6673 15.9395 17.7784C15.7813 17.8981 15.5906 17.9686 15.3926 17.9796C15.1946 17.9905 14.9975 17.9414 14.8271 17.8399L12.1104 16.42C12.0154 16.3694 11.9093 16.3429 11.8018 16.3429C11.6942 16.3429 11.5881 16.3694 11.4932 16.42C10.5878 16.8934 9.70272 17.3665 8.79688 17.8399C8.53101 17.9668 8.22613 17.9866 7.94629 17.8946C7.66653 17.8027 7.43269 17.6065 7.29395 17.3468C7.21198 17.1819 7.17094 16.9965 7.1709 16.8116C7.1909 16.6466 7.23244 16.3994 7.27344 16.1524L7.70605 13.7032C7.74705 13.4983 7.66444 13.2711 7.5 13.1271L6.05859 11.7267L5.35938 11.0274C5.03042 10.7395 4.92735 10.2866 5.05078 9.89561C5.17424 9.48425 5.52377 9.17556 5.95605 9.13389C6.81997 8.9899 7.70589 8.86675 8.57031 8.74327L8.94043 8.68077C9.16693 8.66076 9.37258 8.51615 9.45508 8.31065C9.88708 7.42565 10.3204 6.51987 10.7734 5.63487ZM3.09961 13.3605C3.06566 13.3405 3.03664 13.3196 3.00879 13.3058C3.02975 13.3466 3.07051 13.388 3.11133 13.4288C3.11275 13.4378 3.11379 13.4471 3.11523 13.4562C3.07566 13.5284 3.02761 13.598 3.00879 13.6349C2.92686 13.5319 2.86422 13.4087 2.82324 13.2853C2.86421 13.2235 2.92651 13.2648 3.0293 13.3058L2.96777 13.2433C2.9937 13.1834 3.03041 13.1564 3.07324 13.1505C3.08205 13.2206 3.08921 13.2909 3.09961 13.3605ZM3.0127 11.5343C3.01104 11.5657 3.01012 11.5975 3.00879 11.629C3.00026 11.5925 2.99396 11.5542 2.98828 11.5147C2.99599 11.5225 3.00508 11.5279 3.0127 11.5343ZM21.3486 9.72373C21.3686 9.76462 21.3688 9.84783 21.3896 9.90928C21.3896 9.86799 21.3894 9.82622 21.3486 9.72373ZM21.2451 8.90147L21.3066 8.96299V8.73643L21.2451 8.90147ZM20.916 8.50987C20.9572 8.55064 20.9967 8.63124 20.957 8.67295L21.1426 8.55088L20.916 8.50987ZM3.4209 8.2833C3.49353 8.34128 3.61721 8.37936 3.74707 8.41905C3.71111 8.50159 3.67709 8.58524 3.64355 8.66905C3.57006 8.54188 3.49677 8.41253 3.4209 8.2833ZM21.2656 8.38584C21.1831 8.24281 21.0601 8.38581 21.1016 8.36534C21.1428 8.44736 21.2443 8.38655 21.2656 8.38584ZM20.1758 7.17198H20.2363L20.0107 7.04795L20.1758 7.17198ZM19.4336 6.04014C19.311 6.28676 19.7431 6.43112 19.8252 6.67784L19.8047 6.73936L20.0312 6.71885C19.8253 6.49249 19.5157 6.24604 19.4336 6.04014ZM4.98535 6.37315C4.97172 6.39011 4.95882 6.40784 4.94531 6.42491C4.95659 6.40664 4.96917 6.38772 4.98438 6.36924C4.98468 6.37042 4.98496 6.37187 4.98535 6.37315ZM19.1865 6.16319C19.2069 6.20451 19.2078 6.26574 19.2285 6.30674L19.3516 6.34873C19.3103 6.32803 19.29 6.26557 19.2695 6.22471C19.249 6.16314 19.207 6.12259 19.1865 6.16319ZM4.16113 5.97764C3.97619 6.01911 3.70881 6.06023 3.83203 6.12217L3.97559 6.16319C4.01502 6.0828 4.08073 6.01803 4.16113 5.97862V5.97764ZM5.41699 4.99034C5.43749 5.15482 5.47802 5.44319 5.49902 5.73155C5.50029 5.74937 5.5007 5.76746 5.50195 5.78526C5.40751 5.88396 5.31551 5.98508 5.22559 6.08799C5.22106 6.07198 5.21497 6.05621 5.21094 6.04014C5.1495 5.79327 5.12906 5.50486 5.21094 5.29893H5.27344C5.3144 5.19602 5.35506 5.09324 5.41699 4.99034ZM19.0225 5.03135C19.0638 5.1543 19.1252 5.2765 18.9424 5.19639C19.0849 5.31821 19.1658 5.33976 19.1865 5.29893C19.2068 5.25785 19.167 5.15456 19.0225 5.03135ZM19.3311 5.13389C19.2911 5.23434 19.1718 5.08141 19.4141 5.26475C19.414 5.26282 19.4131 5.26043 19.4131 5.25791C19.3927 5.23734 19.3724 5.19519 19.3311 5.13389ZM18.4258 4.96983L18.8164 5.07237L18.3848 4.92784L18.4258 4.96983ZM18.6523 4.80479L18.748 4.84288C18.7276 4.89774 18.7069 4.94236 18.8369 4.88682C18.7754 4.92781 18.8585 4.90735 18.9609 4.92784L18.7549 4.8253C18.7535 4.82953 18.7515 4.8338 18.75 4.83799C18.7333 4.80254 18.7285 4.78593 18.6523 4.80479ZM19.0635 4.70225C18.8786 4.59936 18.8785 4.66095 18.8984 4.80479L19.1055 4.88682C19.1048 4.82453 19.0023 4.68144 19.0635 4.70225ZM17.416 4.20811C17.3956 4.33134 17.3761 4.43452 17.3965 4.57823C17.4372 4.57807 17.4783 4.55853 17.5605 4.61924C17.601 4.70113 17.5197 4.68147 17.499 4.72276C17.5401 4.72277 17.7045 4.7632 17.6016 4.59873H17.5605C17.4783 4.49578 17.4162 4.29078 17.416 4.20811ZM6.81641 4.12608C6.95392 4.11051 7.09323 4.11744 7.22852 4.14659C7.2962 4.1775 7.32438 4.23661 7.33984 4.30577C7.15089 4.42061 6.9676 4.54397 6.78809 4.67198C6.63742 4.47957 6.51788 4.27854 6.50781 4.16709C6.52831 4.16709 6.67245 4.14607 6.81641 4.12608ZM18.1172 4.4962C17.9728 4.4962 17.7054 4.39361 17.8281 4.63975C17.9516 4.61923 17.8907 4.47521 18.1172 4.4962ZM7.06348 4.47569L7.10547 4.43467L6.91992 4.16709L7.06348 4.47569ZM17.4785 4.02256C17.5405 4.06354 17.5816 4.12564 17.6436 4.1876C17.6634 4.1461 17.6637 4.08409 17.7256 4.08409L17.4785 4.02256ZM18.0342 3.89952C17.994 3.94136 18.0138 4.04434 17.9727 4.10557L18.1172 4.14659C18.0961 4.08465 17.9939 3.96157 18.0342 3.89952ZM17.3555 4.00205L17.4785 4.02256L17.417 3.96104L17.3555 4.00205ZM9.08691 3.48838C8.74515 3.60574 8.41166 3.7407 8.08984 3.89659C8.12442 3.75385 8.20353 3.6026 8.29883 3.52842C8.31931 3.58988 8.38087 3.63193 8.42188 3.65245C8.52535 3.61145 8.62846 3.56943 8.71094 3.54893C8.79277 3.52856 8.87521 3.52837 8.95703 3.50791C9.00032 3.50253 9.04326 3.49455 9.08691 3.48838ZM16.4902 3.87901L16.5107 3.81651C16.6757 3.93993 16.6758 3.83747 16.7168 3.79698C16.6041 3.75031 16.4862 3.71559 16.3662 3.69346L16.4902 3.87901ZM17.417 3.77549C17.4374 3.79593 17.4581 3.7962 17.4785 3.81651C17.4786 3.77539 17.4991 3.69313 17.417 3.61143V3.77549ZM15.4414 3.54893C15.3181 3.48754 15.2149 3.50816 15.3174 3.58995C15.3584 3.58995 15.3794 3.61143 15.4209 3.61143L15.4414 3.54893ZM16.7988 3.42588C16.8603 3.44637 16.9019 3.46687 16.9639 3.4669C16.9431 3.46681 16.9434 3.44677 16.9434 3.42588H16.7988ZM16.5723 3.38389C16.6306 3.42971 16.7044 3.45234 16.7783 3.44639C16.7001 3.42838 16.6245 3.40044 16.5527 3.36436L16.5723 3.38389ZM17.2314 3.42588H17.3555L17.5195 3.38487L17.2314 3.42588ZM14.5762 3.30284C14.5761 3.32361 14.5481 3.33887 14.5273 3.35752C14.4806 3.34398 14.4338 3.33029 14.3867 3.31748L14.5762 3.30284ZM16.2432 3.1378C16.3455 3.2197 16.4693 3.30232 16.5723 3.34288C16.6133 3.32286 16.6957 3.28179 16.5723 3.21983C16.4489 3.21978 16.3666 3.17877 16.2432 3.1378ZM16.0225 3.06065C15.8784 3.13408 15.6695 3.12317 15.7285 3.30186C15.9755 3.40486 15.9346 3.28135 16.1201 3.28135C15.732 3.11776 16.2549 3.25934 16.0225 3.06065ZM11.0771 2.47862C11.201 2.35523 11.3041 2.25321 11.5918 2.35557C11.818 2.52038 11.6135 2.70474 11.6748 2.82823C11.5303 2.86973 11.4272 2.82822 11.3242 2.80772C11.2209 2.7872 11.139 2.74724 11.0361 2.76768L11.2832 2.82823C11.2012 2.91073 11.0151 2.97274 10.9121 2.93174C11.0596 3.03036 11.6628 2.94855 12.1416 3.00303C12.0997 3.00246 12.0577 3.0001 12.0156 3.0001C11.2119 3.0001 10.433 3.10649 9.69141 3.30381C9.73318 3.07397 9.95249 2.82087 10.2744 2.64366C10.6034 2.52038 10.4401 2.78733 10.501 2.74717C10.8305 2.72617 10.9542 2.60212 11.0771 2.47862ZM13.8154 3.0958L13.9385 3.1583L13.918 2.99327L13.8154 3.0958ZM13.6299 3.1378L13.5684 3.0958L13.4033 3.05479L13.6299 3.1378ZM15.6465 2.89073C15.724 2.94889 15.8204 2.97068 16.0049 3.04307C15.9251 2.97552 16.0183 3.01353 16.0576 3.01377L16.0215 3.04893C16.0267 3.05099 16.0318 3.05362 16.0371 3.05577C16.0349 3.05703 16.0316 3.05654 16.0293 3.05772C16.1071 3.07722 16.1843 3.09847 16.2432 3.1378C16.1813 3.0963 16.1195 3.03466 16.0576 2.97276V2.98838C15.9205 2.95071 15.7836 2.92975 15.6465 2.89073ZM16.9434 2.93174C16.7995 2.87037 16.6351 2.89076 16.5117 2.91123C16.6351 2.93177 16.7374 2.99397 16.8613 3.1378C16.9842 3.09613 16.8202 2.93187 16.9434 2.93174ZM10.1719 3.01377C10.1519 3.07527 10.2339 3.09579 10.3164 3.05479C10.3575 2.9935 10.4399 2.95215 10.3984 2.91123L10.1719 3.01377ZM16.0225 3.06065C16.0247 3.05954 16.0271 3.05888 16.0293 3.05772C16.0253 3.05671 16.0206 3.0558 16.0166 3.05479C16.0186 3.05644 16.0206 3.05901 16.0225 3.06065ZM16.0166 3.05479L16.0215 3.04893C16.016 3.04675 16.0102 3.04517 16.0049 3.04307C16.0087 3.0463 16.012 3.05105 16.0166 3.05479ZM15.9346 2.8292C15.9755 2.87013 16.0167 2.91143 16.0576 2.97276C16.0371 2.9113 15.9755 2.80902 15.9346 2.8292ZM16.2646 2.91123C16.3466 2.93167 16.4088 2.91123 16.4912 2.91123C16.4293 2.91123 16.3466 2.89081 16.2646 2.91123ZM13.1357 2.87022C13.0129 2.84933 12.8495 2.80886 12.8477 2.84873L13.0742 2.91123C13.0744 2.8908 13.0949 2.87022 13.1357 2.87022ZM15.3789 2.60264C15.2271 2.60266 15.1801 2.63734 15.1416 2.67491L15.1318 2.66416V2.70518L15.1455 2.69053L15.5439 2.87022L15.626 2.88975C15.5437 2.82831 15.4812 2.74679 15.3789 2.60264ZM13.1357 2.87022C13.2176 2.87026 13.2798 2.8902 13.3213 2.87022C13.2799 2.87022 13.1972 2.84937 13.1357 2.87022ZM14.2266 2.82823C14.2674 2.82825 14.3088 2.8493 14.3496 2.87022C14.3904 2.78796 14.309 2.82821 14.2266 2.82823ZM14.165 2.80772H14.1855C14.1787 2.80675 14.1718 2.80649 14.165 2.80577V2.80772ZM14.165 2.80577C14.2446 2.64292 14.0817 2.64336 13.918 2.68467C13.8984 2.82184 14.0282 2.79127 14.165 2.80577ZM13.1582 2.6837C13.1454 2.69769 13.1358 2.71169 13.1357 2.72569C13.1499 2.71189 13.1615 2.69598 13.1689 2.68174C13.1654 2.68257 13.1616 2.6824 13.1582 2.6837ZM13.1582 2.6837C13.1616 2.68241 13.1654 2.6818 13.1689 2.68077C13.172 2.67477 13.1768 2.67014 13.1768 2.66416C13.1702 2.67053 13.164 2.67733 13.1582 2.6837ZM15.2129 2.45909C15.1306 2.4999 15.0284 2.54144 14.9463 2.60264L15.1318 2.58213L15.2129 2.45909ZM9.45117 2.37608C9.32772 2.35509 9.18354 2.35575 9.08105 2.5001H9.16309C9.24557 2.4586 9.34821 2.39657 9.45117 2.37608ZM14.5557 2.39659L14.6377 2.47862L14.6992 2.35557L14.5557 2.39659ZM9.45117 2.37608C9.63661 2.4171 9.80078 2.52056 9.80078 2.39659C9.657 2.37613 9.55405 2.37608 9.45117 2.37608ZM13.6094 2.14952C13.712 2.17001 13.753 2.21104 13.7939 2.23155C13.7938 2.20119 13.7721 2.16064 13.7939 2.14952H13.6094ZM12.5176 2.04698C12.5996 1.88236 12.0242 2.2115 12.415 2.14952C12.477 2.19048 12.4767 1.98543 12.5176 2.04698ZM12.6211 2.06748C12.6829 2.0675 12.7234 2.08792 12.7852 2.08799C12.7659 2.08779 12.7647 2.06993 12.7646 2.06748H12.6211ZM12.8887 2.06748C12.9299 2.06754 12.9503 2.0878 12.9707 2.08799C12.9911 2.0681 12.9913 2.06748 12.8887 2.06748Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ScissorsCut02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 8.6L21 17M21 7L4.5 15.4M17.5 12H17.51M22 12H22.01M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function SlashCircleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Upload04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 12L12 8M12 8L8 12M12 8V17.2C12 18.5907 12 19.2861 12.5505 20.0646C12.9163 20.5819 13.9694 21.2203 14.5972 21.3054C15.5421 21.4334 15.9009 21.2462 16.6186 20.8719C19.8167 19.2036 22 15.8568 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.7014 4.01099 18.9331 7 20.6622"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CoinStarIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5434 6.50412C11.6901 6.21834 11.7634 6.07545 11.863 6.02979C11.9497 5.99007 12.0503 5.99007 12.137 6.02979C12.2366 6.07545 12.3099 6.21834 12.4566 6.50412L13.8486 9.21543C13.8919 9.29979 13.9135 9.34198 13.9452 9.37473C13.9732 9.40373 14.0068 9.42723 14.0442 9.44392C14.0863 9.46277 14.1347 9.46958 14.2316 9.48319L17.3451 9.92075C17.673 9.96683 17.8369 9.98987 17.9128 10.0669C17.9788 10.1339 18.0098 10.2259 17.9973 10.3174C17.9828 10.4225 17.8641 10.5337 17.6268 10.756L15.3746 12.8651C15.3044 12.9308 15.2693 12.9637 15.2467 13.0028C15.2266 13.0375 15.2138 13.0755 15.2088 13.1148C15.2032 13.1593 15.2115 13.2057 15.228 13.2986L15.7594 16.2776C15.8155 16.5918 15.8435 16.7489 15.7908 16.8422C15.745 16.9233 15.6636 16.9802 15.5692 16.997C15.4607 17.0163 15.3139 16.9421 15.0205 16.7937L12.237 15.3863C12.1503 15.3425 12.1069 15.3205 12.0613 15.3119C12.0208 15.3043 11.9792 15.3043 11.9387 15.3119C11.8931 15.3205 11.8497 15.3425 11.763 15.3863L8.97951 16.7937C8.68605 16.9421 8.53932 17.0163 8.43083 16.997C8.33644 16.9802 8.25498 16.9233 8.20916 16.8422C8.1565 16.7489 8.18452 16.5918 8.24057 16.2776L8.77197 13.2986C8.78853 13.2057 8.79682 13.1593 8.79121 13.1148C8.78625 13.0755 8.77338 13.0375 8.75333 13.0028C8.73068 12.9637 8.69558 12.9308 8.62537 12.8651L6.37324 10.756C6.13587 10.5337 6.01718 10.4225 6.00274 10.3174C5.99018 10.2259 6.02122 10.1339 6.08723 10.0669C6.16309 9.98987 6.32703 9.96683 6.6549 9.92075L9.76844 9.48319C9.86527 9.46958 9.91368 9.46277 9.95584 9.44392C9.99318 9.42723 10.0268 9.40373 10.0548 9.37473C10.0865 9.34198 10.1081 9.29979 10.1514 9.21543L11.5434 6.50412Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CoinsHandIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1482_27)">
        <path
          d="M11.2744 6.95984C10.7974 7.29992 10.2136 7.49996 9.58317 7.49996C7.97234 7.49996 6.6665 6.19412 6.6665 4.58329C6.6665 2.97246 7.97234 1.66663 9.58317 1.66663C10.6273 1.66663 11.5433 2.21531 12.0586 3.04008M4.99984 16.7393H7.17508C7.45869 16.7393 7.74057 16.773 8.01551 16.8405L10.3139 17.399C10.8126 17.5205 11.3322 17.5323 11.8361 17.4345L14.3773 16.9401C15.0486 16.8093 15.6662 16.4878 16.1501 16.017L17.9481 14.2681C18.4615 13.7694 18.4615 12.9603 17.9481 12.4608C17.4858 12.0112 16.7538 11.9605 16.2308 12.3419L14.1353 13.8707C13.8352 14.09 13.4701 14.2082 13.0945 14.2082H11.0711L12.3591 14.2081C13.085 14.2081 13.6731 13.6361 13.6731 12.9299V12.6742C13.6731 12.0879 13.2628 11.5766 12.6782 11.4349L10.6903 10.9514C10.3668 10.8729 10.0355 10.8333 9.70245 10.8333C8.89845 10.8333 7.44308 11.499 7.44308 11.499L4.99984 12.5207M16.6665 5.41663C16.6665 7.02746 15.3607 8.33329 13.7498 8.33329C12.139 8.33329 10.8332 7.02746 10.8332 5.41663C10.8332 3.8058 12.139 2.49996 13.7498 2.49996C15.3607 2.49996 16.6665 3.8058 16.6665 5.41663ZM1.6665 12.1666L1.6665 17C1.6665 17.4667 1.6665 17.7 1.75733 17.8783C1.83723 18.0351 1.96471 18.1626 2.12151 18.2425C2.29977 18.3333 2.53313 18.3333 2.99984 18.3333H3.6665C4.13321 18.3333 4.36657 18.3333 4.54483 18.2425C4.70163 18.1626 4.82911 18.0351 4.90901 17.8783C4.99984 17.7 4.99984 17.4667 4.99984 17V12.1666C4.99984 11.6999 4.99984 11.4666 4.90901 11.2883C4.82911 11.1315 4.70163 11.004 4.54483 10.9241C4.36657 10.8333 4.13321 10.8333 3.6665 10.8333L2.99984 10.8333C2.53313 10.8333 2.29977 10.8333 2.12151 10.9241C1.96471 11.004 1.83723 11.1315 1.75733 11.2883C1.6665 11.4666 1.6665 11.6999 1.6665 12.1666Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1482_27">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Link03Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        id="Icon"
        d="M10.0002 13C10.4297 13.5741 10.9776 14.0491 11.6067 14.3929C12.2359 14.7367 12.9317 14.9411 13.6468 14.9923C14.362 15.0435 15.0798 14.9403 15.7515 14.6897C16.4233 14.4392 17.0333 14.047 17.5402 13.54L20.5402 10.54C21.451 9.59695 21.955 8.33394 21.9436 7.02296C21.9322 5.71198 21.4063 4.45791 20.4793 3.53087C19.5523 2.60383 18.2982 2.07799 16.9872 2.0666C15.6762 2.0552 14.4132 2.55918 13.4702 3.46997L11.7502 5.17997M14.0002 11C13.5707 10.4258 13.0228 9.95078 12.3936 9.60703C11.7645 9.26327 11.0687 9.05885 10.3535 9.00763C9.63841 8.95641 8.92061 9.0596 8.24885 9.31018C7.5771 9.56077 6.96709 9.9529 6.4602 10.46L3.4602 13.46C2.54941 14.403 2.04544 15.666 2.05683 16.977C2.06822 18.288 2.59407 19.542 3.52111 20.4691C4.44815 21.3961 5.70221 21.9219 7.01319 21.9333C8.32418 21.9447 9.58719 21.4408 10.5302 20.53L12.2402 18.82"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function GroupIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2H14M22 10V14M18 22C18.93 22 19.395 22 19.7765 21.8978C20.8117 21.6204 21.6204 20.8117 21.8978 19.7765C22 19.395 22 18.93 22 18M22 6C22 5.07003 22 4.60504 21.8978 4.22354C21.6204 3.18827 20.8117 2.37962 19.7765 2.10222C19.395 2 18.93 2 18 2M6 2C5.07003 2 4.60504 2 4.22354 2.10222C3.18827 2.37962 2.37962 3.18827 2.10222 4.22354C2 4.60504 2 5.07003 2 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 22L10 22M2 14L2 10M2 18C2 18.93 2 19.395 2.10222 19.7765C2.37962 20.8117 3.18827 21.6204 4.22354 21.8978C4.60504 22 5.07003 22 6 22"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EyeSubtractIcon(props: IconProps) {
  return (
    <svg
      width="12"
      height="10"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.15725C0 5.15725 2.28 0.777252 6 0.777252C9.72 0.777252 12 5.15725 12 5.15725C12 5.15725 9.72 9.53725 6 9.53725C2.28 9.53725 0 5.15725 0 5.15725ZM2.88 5.15725C2.88 6.87725 4.28 8.27725 6 8.27725C7.72 8.27725 9.12 6.87725 9.12 5.15725C9.12 3.43725 7.72 2.03725 6 2.03725C4.28 2.03725 2.88 3.43725 2.88 5.15725ZM6 7.01725C7.02 7.01725 7.86 6.17725 7.86 5.15725C7.86 4.13725 7.02 3.29725 6 3.29725C5.85901 3.29725 5.72147 3.3133 5.5891 3.34366C5.72137 3.51321 5.80018 3.72651 5.80018 3.95822C5.80018 4.51051 5.35246 4.95822 4.80018 4.95822C4.56871 4.95822 4.3556 4.87958 4.18613 4.74755C4.15595 4.87955 4.14 5.01669 4.14 5.15725C4.14 6.17725 4.98 7.01725 6 7.01725Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function CFAskLogo(props: IconProps) {
  return (
    <svg
      width="94"
      height="44"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 94 44"
      fill="none"
    >
      <path
        d="M91.1148 14.1107C91.1148 12.037 91.1148 9.37712 90.4821 7.12303C90.5273 7.21319 90.5724 7.25827 90.6176 7.34844C89.8042 4.77876 88.4484 2.56975 85.1042 2.38942C75.659 2.47958 66.2138 2.4345 56.7686 2.70499C50.2157 2.88532 51.0292 9.87303 51.0292 14.4714C51.0292 17.582 51.0292 20.6927 51.0292 23.8484C50.6676 28.1763 51.6619 34.3976 57.1301 34.5329C59.6609 34.5779 62.2369 34.5329 64.7676 34.5329C64.7225 35.9304 64.6321 37.4181 64.9936 38.6804C65.5359 40.7091 67.0724 42.5575 69.1513 40.9345C71.1398 39.4017 72.9474 37.5534 74.8003 35.9304C76.3369 34.5779 76.4724 34.5329 78.5513 34.5329C80.9013 34.5329 83.3417 34.6681 85.6917 34.5329C89.0811 34.3525 91.0244 31.6025 91.1599 28.4017C91.2955 23.623 91.1148 18.8443 91.1148 14.1107Z"
        fill="#F07E8D"
      />
      <path
        d="M60.9263 16.3648C61.3782 13.4345 62.8696 11.0001 65.4003 11.6763C66.9369 12.082 67.8407 13.8402 69.3321 12.3525C69.8292 11.8116 70.1003 11.2706 69.9648 10.5943C69.8744 10.3689 69.7388 9.9632 69.7388 9.9632C69.0609 8.74598 67.3436 7.97959 66.1234 7.66402C55.5484 4.9591 53.6955 21.8198 59.5253 27.2296C60.7907 28.4017 62.4176 29.1681 64.5417 29.2132C66.3042 29.123 70.3263 28.0861 69.8744 25.7419C69.9196 25.787 69.2417 24.164 68.383 23.7583C67.2984 23.3075 66.9369 24.0739 66.033 24.5698C61.2427 26.8239 60.4744 19.7009 60.9263 16.3648ZM85.7821 9.55746C85.8273 9.55746 85.8273 9.55746 85.7821 9.55746C85.7369 9.33205 85.6917 9.15172 85.6465 8.92631C85.4205 7.97959 84.9234 7.75418 83.884 7.7091C82.0763 7.61893 80.3138 7.61893 78.5061 7.57385C75.433 7.30336 72.4503 7.30336 72.9926 11.2706C72.9926 11.0452 72.7667 22.3607 73.5802 27.1845C73.9417 27.996 74.5744 28.3116 75.7946 28.4017C77.7378 28.1763 77.9186 27.5001 77.8734 25.8771C77.783 24.5247 77.6926 22.5411 77.6926 21.2788C77.6926 21.0984 77.6926 20.9181 77.7378 20.7378C78.009 18.4837 81.0821 19.9714 82.709 19.6107C84.0196 19.2952 84.4715 17.1763 83.6128 16.0042C82.5282 14.5616 78.3705 16.2747 77.5119 14.8771C77.5119 14.2911 77.5119 13.705 77.5119 13.164C77.5571 12.1271 77.4667 11.8116 78.6417 11.7214C80.0426 11.6763 81.4436 11.8116 82.8446 11.8116C84.7427 12.1722 86.234 11.9919 85.7821 9.55746Z"
        fill="white"
      />
      <path
        d="M14.868 13.2993C14.2353 11.5411 14.6421 9.28696 13.5574 7.7091C12.0661 6.40172 9.6709 7.39352 9.49013 9.28696C7.50167 14.9222 5.33244 20.5575 3.34398 26.1927C3.29879 26.4181 3.2084 26.5984 3.2084 26.8239C3.2084 26.8239 3.2084 26.8239 3.2084 26.7788C3.02763 27.7255 4.06706 28.8525 5.10648 28.8075C5.06129 28.8075 5.64879 28.7624 5.64879 28.7624C7.36609 28.4017 7.54686 26.2829 8.17956 25.1107C8.90263 23.9837 10.7103 24.4796 11.7949 24.5247C13.3315 24.5698 13.7382 25.0206 14.3257 26.5083C14.9132 29.3935 17.5796 29.6189 18.9805 27.3198C18.9805 27.3198 19.1161 26.914 19.0709 26.7788C17.7151 22.3607 15.7719 17.9427 14.868 13.2993ZM10.3036 20.2419C10.3036 20.2419 10.0776 20.1066 10.0324 20.0165C10.4844 19.0247 10.394 17.4919 11.1622 16.7706C11.6594 17.7624 11.9305 19.1599 12.2469 20.332C11.6594 20.332 10.9363 20.3771 10.3036 20.2419Z"
        fill="#113CB9"
      />
      <path
        d="M28.019 6.67221H28.0642C28.1546 6.71729 28.2449 6.71729 28.3353 6.76237C28.2449 6.76237 28.1546 6.71729 28.019 6.67221Z"
        fill="#113CB9"
      />
      <path
        d="M43.7009 11.4058C42.6615 11.7665 38.8653 18.3034 38.1874 16.6354C38.0067 13.7501 38.3682 10.6394 37.6451 7.84437C37.0124 6.94273 34.4365 7.03289 33.7134 7.79928C32.8096 14.2911 33.9394 21.5042 34.0749 28.0862V28.0411C34.4817 28.7624 35.024 29.078 36.1538 29.2132C37.5999 29.1231 38.1422 28.6722 38.3682 27.996C38.549 27.8157 38.4134 25.1558 38.4586 24.8854C39.2269 19.746 42.7519 33.8116 45.599 26.5534C45.599 26.5985 45.599 26.2378 45.5538 26.0124C45.5538 26.0124 45.5538 26.0124 45.5538 26.0575C42.4807 20.4673 39.8596 20.4222 45.6442 15.2829C46.0961 14.7419 46.5028 14.4263 46.548 13.8403C46.548 13.7952 46.548 13.8853 46.548 13.8403C46.6836 12.3976 45.1922 10.6394 43.7009 11.4058Z"
        fill="#113CB9"
      />
      <path
        d="M31.5442 9.51237C31.6346 8.11483 28.5615 6.85254 28.6067 6.89762C28.4259 6.85254 28.2903 6.76237 28.1096 6.71729C19.1615 3.78696 14.2807 13.3443 23.0932 18.0329C28.6519 20.3771 26.6182 24.8402 22.6413 21.9099L22.099 21.6845C20.9692 21.4591 19.3875 22.2706 19.4778 23.5779C19.6586 25.5616 23.8163 26.5984 25.8048 26.7337C32.8548 26.5534 33.2615 18.8443 27.5221 15.9591C26.0307 15.0124 21.4211 12.3075 24.4038 10.2337C25.9403 9.1968 28.4711 11.0001 28.4711 11.0001C28.6971 11.0902 29.0586 11.2255 29.0134 11.1804C30.1884 11.5411 31.4538 10.7747 31.5442 9.51237Z"
        fill="#113CB9"
      />
    </svg>
  )
}

export function CircleSpiralIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      {...props}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4155 14.3411C17.5924 16.3495 13.8895 16.5726 10.877 15M1.58445 7.65889C4.41439 5.64566 8.12844 5.42638 11.1448 7.01149M14.3737 13.1243C17.2604 11.305 18.9319 7.97413 18.601 4.51222M7.58184 8.90371C4.72231 10.7291 3.06959 14.0436 3.39878 17.4878M14.5269 9.13704C14.3939 5.72851 12.345 2.61684 9.1821 1.17222M7.47562 12.9256C7.63112 16.3096 9.67429 19.392 12.8177 20.8278M18.071 3.92893C21.9763 7.83418 21.9763 14.1658 18.071 18.071C14.1658 21.9763 7.83416 21.9763 3.92893 18.071C0.0236888 14.1658 0.0236888 7.83416 3.92893 3.92893C7.83418 0.0236888 14.1658 0.0236888 18.071 3.92893ZM13.8284 8.17157C15.3905 9.73367 15.3905 12.2663 13.8284 13.8284C12.2663 15.3905 9.73367 15.3905 8.17157 13.8284C6.60948 12.2663 6.60948 9.73367 8.17157 8.17157C9.73367 6.60948 12.2663 6.60948 13.8284 8.17157Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function File01Icon(props: IconProps) {
  return (
    <svg
      width="18"
      height="22"
      {...props}
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 13V17M13 11V17M9 7V17M17 5.8V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1H12.2C13.8802 1 14.7202 1 15.362 1.32698C15.9265 1.6146 16.3854 2.07354 16.673 2.63803C17 3.27976 17 4.11984 17 5.8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Film01Icon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33398 7.99992H14.6673M1.33398 4.66659H4.66732M11.334 4.66659H14.6673M1.33398 11.3333H4.66732M11.334 11.3333H14.6673M4.66732 14.6666V1.33325M11.334 14.6666V1.33325M4.53398 14.6666H11.4673C12.5874 14.6666 13.1475 14.6666 13.5753 14.4486C13.9516 14.2569 14.2576 13.9509 14.4493 13.5746C14.6673 13.1467 14.6673 12.5867 14.6673 11.4666V4.53325C14.6673 3.41315 14.6673 2.85309 14.4493 2.42527C14.2576 2.04895 13.9516 1.74299 13.5753 1.55124C13.1475 1.33325 12.5874 1.33325 11.4673 1.33325H4.53398C3.41388 1.33325 2.85383 1.33325 2.426 1.55124C2.04968 1.74299 1.74372 2.04895 1.55197 2.42527C1.33398 2.85309 1.33398 3.41315 1.33398 4.53325V11.4666C1.33398 12.5867 1.33398 13.1467 1.55197 13.5746C1.74372 13.9509 2.04968 14.2569 2.426 14.4486C2.85383 14.6666 3.41388 14.6666 4.53398 14.6666Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Film02Icon(props: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      {...props}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21V1M6 21V16M6 6V1M16 21V16M16 6V1M1 6H21M1 16H21M21 16.2V5.8C21 4.11984 21 3.27976 20.673 2.63803C20.3854 2.07354 19.9265 1.6146 19.362 1.32698C18.7202 1 17.8802 1 16.2 1L5.8 1C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8L1 16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MusicNote01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18V6.3554C9 5.87386 9 5.63309 9.0876 5.43781C9.16482 5.26568 9.28917 5.1189 9.44627 5.01443C9.62449 4.89591 9.86198 4.85633 10.337 4.77717L19.137 3.3105C19.7779 3.20367 20.0984 3.15026 20.3482 3.24303C20.5674 3.32444 20.7511 3.48008 20.8674 3.68289C21 3.91401 21 4.23892 21 4.88873V16M9 18C9 19.6568 7.65685 21 6 21C4.34315 21 3 19.6568 3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18ZM21 16C21 17.6568 19.6569 19 18 19C16.3431 19 15 17.6568 15 16C15 14.3431 16.3431 13 18 13C19.6569 13 21 14.3431 21 16Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MusicNotePlusIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 18V5.58888C14.5 4.73166 14.5 4.30306 14.6805 4.04492C14.8382 3.81952 15.0817 3.669 15.3538 3.6288C15.6655 3.58276 16.0488 3.77444 16.8155 4.1578L20.5 6.00003M14.5 18C14.5 19.6569 13.1569 21 11.5 21C9.84315 21 8.5 19.6569 8.5 18C8.5 16.3432 9.84315 15 11.5 15C13.1569 15 14.5 16.3432 14.5 18ZM6.5 10V4.00003M3.5 7.00003H9.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Share03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 7.00001L19 1.00001M19 1.00001H13M19 1.00001L10 10M8 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ArrowNarrowUpRightIcon(props: IconProps) {
  return (
    <svg
      width="22"
      height="22"
      {...props}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.65082 7.52233C6.17057 7.52233 5.78125 7.13302 5.78125 6.65277C5.78125 6.17252 6.17057 5.7832 6.65082 5.7832H15.3465C15.8267 5.7832 16.216 6.17252 16.216 6.65277V15.3484C16.216 15.8287 15.8267 16.218 15.3465 16.218C14.8662 16.218 14.4769 15.8287 14.4769 15.3484V8.75208L7.26569 15.9633C6.9261 16.3029 6.37553 16.3029 6.03594 15.9633C5.69635 15.6237 5.69635 15.0731 6.03594 14.7335L13.2472 7.52233H6.65082Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PauseIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 13V7M12.5 13V7M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MuteIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 8.99993L16 14.9999M16 8.99993L22 14.9999M9.63432 5.36561L6.46863 8.5313C6.29568 8.70425 6.2092 8.79073 6.10828 8.85257C6.01881 8.9074 5.92127 8.9478 5.81923 8.9723C5.70414 8.99993 5.58185 8.99993 5.33726 8.99993H3.6C3.03995 8.99993 2.75992 8.99993 2.54601 9.10892C2.35785 9.20479 2.20487 9.35777 2.10899 9.54594C2 9.75985 2 10.0399 2 10.5999V13.3999C2 13.96 2 14.24 2.10899 14.4539C2.20487 14.6421 2.35785 14.7951 2.54601 14.8909C2.75992 14.9999 3.03995 14.9999 3.6 14.9999H5.33726C5.58185 14.9999 5.70414 14.9999 5.81923 15.0276C5.92127 15.0521 6.01881 15.0925 6.10828 15.1473C6.2092 15.2091 6.29568 15.2956 6.46863 15.4686L9.63431 18.6342C10.0627 19.0626 10.2769 19.2768 10.4608 19.2913C10.6203 19.3038 10.7763 19.2392 10.8802 19.1175C11 18.9773 11 18.6744 11 18.0686V5.9313C11 5.32548 11 5.02257 10.8802 4.88231C10.7763 4.76061 10.6203 4.69602 10.4608 4.70858C10.2769 4.72305 10.0627 4.93724 9.63432 5.36561Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function VolumeMaxIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7479 4.99999C21.1652 6.97023 22 9.38762 22 12C22 14.6124 21.1652 17.0298 19.7479 19M15.7453 7.99999C16.5362 9.13382 17 10.5127 17 12C17 13.4872 16.5362 14.8662 15.7453 16M9.63432 5.36567L6.46863 8.53136C6.29568 8.70431 6.2092 8.79079 6.10828 8.85263C6.01881 8.90746 5.92127 8.94786 5.81923 8.97236C5.70414 8.99999 5.58185 8.99999 5.33726 8.99999H3.6C3.03995 8.99999 2.75992 8.99999 2.54601 9.10898C2.35785 9.20485 2.20487 9.35784 2.10899 9.546C2 9.75991 2 10.0399 2 10.6V13.4C2 13.96 2 14.2401 2.10899 14.454C2.20487 14.6421 2.35785 14.7951 2.54601 14.891C2.75992 15 3.03995 15 3.6 15H5.33726C5.58185 15 5.70414 15 5.81923 15.0276C5.92127 15.0521 6.01881 15.0925 6.10828 15.1473C6.2092 15.2092 6.29568 15.2957 6.46863 15.4686L9.63431 18.6343C10.0627 19.0627 10.2769 19.2769 10.4608 19.2913C10.6203 19.3039 10.7763 19.2393 10.8802 19.1176C11 18.9773 11 18.6744 11 18.0686V5.93136C11 5.32554 11 5.02264 10.8802 4.88237C10.7763 4.76067 10.6203 4.69608 10.4608 4.70864C10.2769 4.72311 10.0627 4.9373 9.63432 5.36567Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Stars01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PaperclipIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1527 10.8995L12.1371 19.9151C10.0869 21.9653 6.76275 21.9653 4.71249 19.9151C2.66224 17.8648 2.66224 14.5407 4.71249 12.4904L13.7281 3.47483C15.0949 2.108 17.311 2.108 18.6779 3.47483C20.0447 4.84167 20.0447 7.05775 18.6779 8.42458L10.0158 17.0866C9.33238 17.7701 8.22434 17.7701 7.54092 17.0866C6.8575 16.4032 6.8575 15.2952 7.54092 14.6118L15.1423 7.01037"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Edit03Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 16.6667H17.5M2.5 16.6667H3.89545C4.3031 16.6667 4.50693 16.6667 4.69874 16.6206C4.8688 16.5798 5.03138 16.5125 5.1805 16.4211C5.34869 16.318 5.49282 16.1739 5.78107 15.8856L16.25 5.41669C16.9404 4.72634 16.9404 3.60705 16.25 2.91669C15.5597 2.22634 14.4404 2.22634 13.75 2.91669L3.28105 13.3856C2.9928 13.6739 2.84867 13.818 2.7456 13.9862C2.65422 14.1353 2.58688 14.2979 2.54605 14.468C2.5 14.6598 2.5 14.8636 2.5 15.2713V16.6667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CoinSwap01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6L8 4M8 4L6 2M8 4H6C3.79086 4 2 5.79086 2 8M18 18L16 20M16 20L18 22M16 20H18C20.2091 20 22 18.2091 22 16M13.4172 13.4172C14.1994 13.7908 15.0753 14 16 14C19.3137 14 22 11.3137 22 8C22 4.68629 19.3137 2 16 2C12.6863 2 10 4.68629 10 8C10 8.92472 10.2092 9.80057 10.5828 10.5828M14 16C14 19.3137 11.3137 22 8 22C4.68629 22 2 19.3137 2 16C2 12.6863 4.68629 10 8 10C11.3137 10 14 12.6863 14 16Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Coins01Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2827 13.2808C16.1349 12.8989 18.3346 10.456 18.3346 7.49935C18.3346 4.27769 15.723 1.66602 12.5013 1.66602C9.54462 1.66602 7.10171 3.86574 6.71986 6.71791M13.3346 12.4993C13.3346 15.721 10.723 18.3327 7.5013 18.3327C4.27964 18.3327 1.66797 15.721 1.66797 12.4993C1.66797 9.27769 4.27964 6.66602 7.5013 6.66602C10.723 6.66602 13.3346 9.27769 13.3346 12.4993Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function UpscalerIcon(props: IconProps) {
  return (
    <svg
      width="26"
      height="26"
      {...props}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5855 14.2855V19.459C15.5855 19.8457 15.4288 20.2011 15.1779 20.4519C14.9271 20.7028 14.5717 20.8595 14.185 20.8595C13.4116 20.8595 12.7845 20.2324 12.7845 19.459V15.0276L7.20342 20.6087C6.65995 21.1522 5.76112 21.1522 5.21764 20.6087C4.67416 20.0652 4.67416 19.1664 5.21764 18.6229L10.7883 13.0523H6.35685C5.58344 13.0523 4.95635 12.4252 4.95635 11.6518C4.95635 10.8783 5.58344 10.2513 6.35685 10.2513H11.5303C13.767 10.2513 15.5855 12.0698 15.5855 14.3064V14.2855ZM12.2097 22.166C11.823 22.5213 11.3213 22.7199 10.7987 22.7199H5.32215C4.18294 22.7199 3.2423 21.7897 3.2423 20.6401V15.0171C3.2423 14.5155 3.43043 14.0242 3.76488 13.648C4.26655 13.0732 4.21429 12.1952 3.63946 11.6936C3.06463 11.1919 2.1867 11.2441 1.68503 11.819C0.901168 12.7074 0.472656 13.8466 0.472656 15.0276V20.6505C0.472656 23.3261 2.64657 25.5 5.32215 25.5H10.7987C12.032 25.5 13.2026 25.0401 14.1014 24.204C14.6658 23.6814 14.6972 22.8035 14.1746 22.2496C13.652 21.6957 12.7741 21.6538 12.2201 22.1764L12.2097 22.166ZM18.9718 0.5H10.5479C6.94214 0.5 4.00526 3.43687 4.00526 7.04264V7.75334C4.00526 8.5163 4.6219 9.1434 5.39531 9.1434C6.16873 9.1434 6.78536 8.52676 6.78536 7.75334V7.04264C6.78536 4.96279 8.47851 3.26965 10.5584 3.26965H18.9823C21.0621 3.26965 22.7553 4.96279 22.7553 7.04264V15.4666C22.7553 17.5464 21.0621 19.2395 18.9823 19.2395H18.2298C17.4668 19.2395 16.8397 19.8562 16.8397 20.6296C16.8397 21.403 17.4564 22.0196 18.2298 22.0196H18.9823C22.588 22.0196 25.5249 19.0828 25.5249 15.477V7.04264C25.5249 3.43687 22.588 0.5 18.9823 0.5H18.9718Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function FontcloudIcon(props: IconProps) {
  return (
    <svg
      width="30"
      height="28"
      {...props}
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22158_85010)">
        <path
          d="M23.3272 6.17962C20.4605 -1.28705 9.80218 -1.34538 6.78551 5.97128L6.13551 6.13795C0.427175 7.64628 -1.09782 15.038 3.55218 18.6796C4.32718 19.288 5.43551 19.1463 6.04384 18.3796C6.65218 17.6046 6.51051 16.4963 5.74384 15.888C3.40218 14.0546 4.16884 10.338 7.04384 9.57962L9.56884 8.91295L9.85218 7.95462C11.3605 2.80462 18.6522 2.79628 20.1772 7.93795L20.6105 9.39629L22.4355 9.62962C25.4605 10.0213 26.7188 13.7046 24.5605 15.863C23.8688 16.5546 23.8688 17.6796 24.5605 18.3713C25.2522 19.063 26.3772 19.063 27.0688 18.3713C31.2022 14.238 28.9522 7.23795 23.3272 6.17962Z"
          fill="white"
        />
        <path
          d="M23.3064 24.7382L19.1731 15.6216C17.6064 12.1632 12.7231 12.0882 11.0481 15.4882L6.40643 24.9049C5.9731 25.7799 6.33143 26.8466 7.21477 27.2799C8.08977 27.7132 9.15643 27.3549 9.58977 26.4716L11.4981 22.6049H18.4481L19.4648 24.8466L20.1981 26.4716C20.6314 27.3466 21.7064 27.7132 22.5814 27.2716C23.4564 26.8382 23.8231 25.7716 23.3898 24.8966L23.3064 24.7216V24.7382ZM13.2481 19.0632L14.2314 17.0632C14.5814 16.3466 15.6064 16.3632 15.9398 17.0882L16.8314 19.0632H13.2398H13.2481Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22158_85010">
          <rect
            width="28.3833"
            height="26.9417"
            fill="white"
            transform="translate(0.808594 0.529297)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ShapecloudIcon(props: IconProps) {
  return (
    <svg
      width="28"
      height="28"
      {...props}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22158_25863)">
        <path
          d="M17.7765 5.63063H21.2673C19.8533 2.6333 16.7971 0.666992 13.4536 0.666992C10.7214 0.666992 8.21012 1.93368 6.57521 4.0841C3.40113 4.49651 0.941406 7.21399 0.941406 10.4912C0.941406 14.0482 3.83563 16.9498 7.40003 16.9498C8.21012 16.9498 8.87292 16.287 8.87292 15.4769C8.87292 14.6668 8.21012 14.004 7.40003 14.004C5.46318 14.004 3.88719 12.428 3.88719 10.4912C3.88719 8.55432 5.45581 6.98569 7.3853 6.97832H8.19539L8.62989 6.28607C9.68301 4.60697 11.4873 3.61277 13.4536 3.61277C15.1401 3.61277 16.7087 4.38604 17.7765 5.63063Z"
          fill="white"
        />
        <path
          d="M23.4416 27.3328H14.862C12.8663 27.3328 11.2461 25.7126 11.2461 23.7169V10.6081C11.2461 8.61237 12.8663 6.99219 14.862 6.99219H21.328L27.0502 12.7144V23.7169C27.0502 25.7126 25.43 27.3328 23.4343 27.3328H23.4416ZM14.862 9.93797C14.4938 9.93797 14.1919 10.2399 14.1919 10.6081V23.7242C14.1919 24.0924 14.4938 24.3944 14.862 24.3944H23.4416C23.8098 24.3944 24.1118 24.0924 24.1118 23.7242V13.9369L20.1129 9.93797H14.862Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22158_25863">
          <rect
            width="26.1143"
            height="26.6667"
            fill="white"
            transform="translate(0.941406 0.666992)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function WebfontConverterIcon(props: IconProps) {
  return (
    <svg
      width="28"
      height="28"
      {...props}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22158_86945)">
        <path
          d="M27.2667 7.89999V10.236C27.2667 11.057 26.595 11.7287 25.774 11.7287C24.9531 11.7287 24.2813 11.057 24.2813 10.236V7.89999C24.2813 5.55648 22.3782 3.65332 20.0347 3.65332H17.8031C16.9822 3.65332 16.3105 2.98162 16.3105 2.16065C16.3105 1.33967 16.9822 0.667969 17.8031 0.667969H20.0347C24.0201 0.667969 27.2667 3.91454 27.2667 7.89999ZM10.1979 24.3493H7.96639C5.62289 24.3493 3.71973 22.4461 3.71973 20.1026V17.7666C3.71973 16.9456 3.04802 16.2739 2.22705 16.2739C1.40608 16.2739 0.734375 16.9456 0.734375 17.7666V20.1026C0.734375 24.0881 3.98095 27.3346 7.96639 27.3346H10.1979C11.0189 27.3346 11.6906 26.6629 11.6906 25.842C11.6906 25.021 11.0189 24.3493 10.1979 24.3493ZM13.2803 5.39975L9.3919 1.51133C8.80976 0.929187 7.86191 0.929187 7.27976 1.51133C6.69762 2.09347 6.69762 3.04132 7.27976 3.62347L10.6084 6.95214H2.22705C1.40608 6.95214 0.734375 7.62384 0.734375 8.44481C0.734375 9.26579 1.40608 9.93749 2.22705 9.93749H10.6159L7.28723 13.2662C6.70508 13.8483 6.70508 14.7962 7.28723 15.3783C7.5783 15.6694 7.95893 15.8186 8.33956 15.8186C8.7202 15.8186 9.10083 15.6694 9.3919 15.3783L13.2803 11.4899C14.9596 9.81061 14.9596 7.07901 13.2803 5.39975ZM25.774 17.9308H17.3852L20.7139 14.6021C21.296 14.02 21.296 13.0721 20.7139 12.49C20.1317 11.9078 19.1839 11.9078 18.6017 12.49L14.7133 16.3784C13.034 18.0577 13.034 20.7892 14.7133 22.4685L18.6017 26.3569C18.8928 26.648 19.2734 26.7973 19.6541 26.7973C20.0347 26.7973 20.4153 26.648 20.7064 26.3569C21.2885 25.7748 21.2885 24.8269 20.7064 24.2448L17.3777 20.9161H25.7666C26.5875 20.9161 27.2592 20.2444 27.2592 19.4235C27.2592 18.6025 26.5875 17.9308 25.7666 17.9308H25.774Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22158_86945">
          <rect
            width="26.5323"
            height="26.6667"
            fill="white"
            transform="translate(0.734375 0.666992)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export function Mail02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 18L14.8571 12M9.14286 12L2.50003 18M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Type02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M8 20H16M10.25 4V20M13.75 4V20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function TypeSquareIcon(props: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 7H16.5M12.5 7V17M8.3 21H16.7C18.3802 21 19.2202 21 19.862 20.673C20.4265 20.3854 20.8854 19.9265 21.173 19.362C21.5 18.7202 21.5 17.8802 21.5 16.2V7.8C21.5 6.11984 21.5 5.27976 21.173 4.63803C20.8854 4.07354 20.4265 3.6146 19.862 3.32698C19.2202 3 18.3802 3 16.7 3H8.3C6.61984 3 5.77976 3 5.13803 3.32698C4.57354 3.6146 4.1146 4.07354 3.82698 4.63803C3.5 5.27976 3.5 6.11984 3.5 7.8V16.2C3.5 17.8802 3.5 18.7202 3.82698 19.362C4.1146 19.9265 4.57354 20.3854 5.13803 20.673C5.77976 21 6.61984 21 8.3 21Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function GlyphGridIcon(props: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 9H12.5M12.5 9H15.5M12.5 9V15M2.5 5H22.5M2.5 19H22.5M19.5 2V22M5.5 2L5.5 22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function MoreHorizontal(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4"
      {...props}
    >
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
      <circle cx="5" cy="12" r="1" />
    </svg>
  )
}

export function InfinityIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.1777 8C23.2737 8 23.2737 16 18.1777 16C13.0827 16 11.0447 8 5.43875 8C0.85375 8 0.85375 16 5.43875 16C11.0447 16 13.0828 8 18.1788 8H18.1777Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Repeat04Icon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99984 17.0834C13.9119 17.0834 17.0832 13.9121 17.0832 10C17.0832 7.64543 15.9343 5.55915 14.1665 4.27121M10.8332 18.6667L9.1665 17L10.8332 15.3334M9.99984 2.91671C6.08782 2.91671 2.9165 6.08802 2.9165 10C2.9165 12.3547 4.06539 14.4409 5.83317 15.7289M9.1665 4.66671L10.8332 3.00004L9.1665 1.33337"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function FileShieldIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 10V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function PrintItemIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.96283 15.8932L4.9954 8.90874C4.99737 8.48621 4.52667 8.23289 4.1751 8.46726C3.93815 8.62523 3.6186 8.56666 3.45308 8.33493L2.57529 7.10603C2.25654 6.65978 2.09716 6.43665 2.06044 6.20313C2.02813 5.99765 2.06069 5.78721 2.1536 5.60111C2.25918 5.38961 2.47854 5.22509 2.91727 4.89605L4.57335 3.65398C4.73166 3.53525 4.81081 3.47589 4.89798 3.43373C4.97533 3.39633 5.05718 3.36904 5.1415 3.35256C5.23653 3.33398 5.33547 3.33398 5.53335 3.33398H6.58236C6.89343 3.33398 7.04897 3.33398 7.15866 3.35898C7.34056 3.40043 7.27413 3.3744 7.43578 3.46756C7.53325 3.52373 7.87697 3.84192 8.5644 4.4783C8.87836 4.76893 9.33667 5.00065 10 5.00065C10.6634 5.00065 11.1217 4.76893 11.4356 4.4783C12.1231 3.84192 12.4668 3.52373 12.5643 3.46756C12.7259 3.3744 12.6595 3.40043 12.8414 3.35898C12.9511 3.33398 13.1066 3.33398 13.4177 3.33398H14.4667C14.6646 3.33398 14.7635 3.33398 14.8585 3.35256C14.9429 3.36904 15.0247 3.39633 15.1021 3.43373C15.1892 3.47589 15.2684 3.53525 15.4267 3.65398L15.4267 3.65398L17.0828 4.89605L17.0828 4.89606C17.5215 5.22509 17.7409 5.38961 17.8464 5.60111C17.9394 5.78721 17.9719 5.99765 17.9396 6.20313C17.9029 6.43665 17.7435 6.65978 17.4247 7.10603L16.5481 8.33339C16.3819 8.56598 16.0612 8.62477 15.8234 8.46621C15.4714 8.23159 15 8.48388 15 8.90685V15.9007C15 16.4607 15 16.7407 14.891 16.9546C14.7952 17.1428 14.6422 17.2958 14.454 17.3917C14.2401 17.5007 13.9601 17.5007 13.4 17.5007H6.56281C6.0004 17.5007 5.71919 17.5007 5.50477 17.391C5.31618 17.2946 5.16307 17.1408 5.06753 16.9517C4.9589 16.7368 4.96021 16.4556 4.96283 15.8932Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="7.5"
        y="7.5"
        width="5"
        height="5"
        rx="1"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function ShoppingCartAdd03Icon(props: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.50014 14H18.6359C19.6487 14 20.1551 14 20.5582 13.8112C20.9134 13.6448 21.2118 13.3777 21.4163 13.0432C21.6485 12.6633 21.7044 12.16 21.8163 11.1534L22 10M5.00014 5H11.3032M2.5 2H3.74844C4.01306 2 4.14537 2 4.24889 2.05032C4.34002 2.09463 4.41554 2.16557 4.46544 2.25376C4.52212 2.35394 4.53037 2.48599 4.54688 2.7501L5.45312 17.2499C5.46963 17.514 5.47788 17.6461 5.53456 17.7462C5.58446 17.8344 5.65998 17.9054 5.75111 17.9497C5.85463 18 5.98694 18 6.25156 18H19.5M8 21.5H8.01M17 21.5H17.01M8.5 21.5C8.5 21.7761 8.27614 22 8 22C7.72386 22 7.5 21.7761 7.5 21.5C7.5 21.2239 7.72386 21 8 21C8.27614 21 8.5 21.2239 8.5 21.5ZM17.5 21.5C17.5 21.7761 17.2761 22 17 22C16.7239 22 16.5 21.7761 16.5 21.5C16.5 21.2239 16.7239 21 17 21C17.2761 21 17.5 21.2239 17.5 21.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 8V2M16.5 5H22.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Truck01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 7H16.3373C16.5818 7 16.7041 7 16.8192 7.02763C16.9213 7.05213 17.0188 7.09253 17.1083 7.14736C17.2092 7.2092 17.2957 7.29568 17.4686 7.46863L21.5314 11.5314C21.7043 11.7043 21.7908 11.7908 21.8526 11.8917C21.9075 11.9812 21.9479 12.0787 21.9724 12.1808C22 12.2959 22 12.4182 22 12.6627V15.5C22 15.9659 22 16.1989 21.9239 16.3827C21.8224 16.6277 21.6277 16.8224 21.3827 16.9239C21.1989 17 20.9659 17 20.5 17M15.5 17H14M14 17V7.2C14 6.0799 14 5.51984 13.782 5.09202C13.5903 4.71569 13.2843 4.40973 12.908 4.21799C12.4802 4 11.9201 4 10.8 4H5.2C4.0799 4 3.51984 4 3.09202 4.21799C2.71569 4.40973 2.40973 4.71569 2.21799 5.09202C2 5.51984 2 6.0799 2 7.2V15C2 16.1046 2.89543 17 4 17M14 17H10M10 17C10 18.6569 8.65685 20 7 20C5.34315 20 4 18.6569 4 17M10 17C10 15.3431 8.65685 14 7 14C5.34315 14 4 15.3431 4 17M20.5 17.5C20.5 18.8807 19.3807 20 18 20C16.6193 20 15.5 18.8807 15.5 17.5C15.5 16.1193 16.6193 15 18 15C19.3807 15 20.5 16.1193 20.5 17.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function StarPromoIcon(props: IconProps) {
  return (
    <svg
      width="139"
      height="138"
      viewBox="0 0 139 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M55.5147 1.2398L67.6848 6.68897L79.4648 0.441169L89.0372 9.72413L102.244 7.88213L108.064 19.8792L121.104 22.6652L122.47 35.9294L133.771 43.0073L130.518 55.9387L138.716 66.4549L131.236 77.4939L135.344 90.1799L124.539 97.9949L124.06 111.321L111.235 114.969L106.227 127.327L92.9268 126.369L83.9941 136.269L71.824 130.82L60.0439 137.068L50.4715 127.785L37.265 129.627L31.4448 117.63L18.4048 114.844L17.0389 101.58L5.73809 94.5016L8.99116 81.5702L0.792696 71.054L8.2724 60.0151L4.1651 47.3291L14.9693 39.5141L15.4485 26.1883L28.274 22.5399L33.2821 10.1817L46.5819 11.1398L55.5147 1.2398Z"
        fill="#7F58E1"
      />
    </svg>
  )
}

export function AIChip2Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 17C15.5217 17 15.9493 16.6163 16.0217 16.0733C16.7391 11.2371 17.3986 10.5638 22.0507 10.0353C22.587 9.97014 23 9.52127 23 9C23 8.47149 22.5942 8.0371 22.058 7.95747C17.4348 7.31312 16.8623 6.74842 16.0217 1.91946C15.9275 1.38371 15.5145 1 15 1C14.471 1 14.0507 1.38371 13.9638 1.9267C13.2609 6.75566 12.6014 7.42896 7.95652 7.95747C7.4058 8.02986 7 8.46425 7 9C7 9.52127 7.3913 9.95566 7.94203 10.0353C12.5725 10.6941 13.1377 11.2516 13.9638 16.0805C14.0725 16.6235 14.4928 17 15 17Z"
        fill="currentColor"
      />
      <path
        d="M5 23C5.26087 23 5.47464 22.8081 5.51087 22.5367C5.86957 20.1186 6.19928 19.7819 8.52536 19.5176C8.79348 19.4851 9 19.2606 9 19C9 18.7357 8.7971 18.5186 8.52899 18.4787C6.21739 18.1566 5.93116 17.8742 5.51087 15.4597C5.46377 15.1919 5.25725 15 5 15C4.73551 15 4.52536 15.1919 4.48188 15.4633C4.13043 17.8778 3.80072 18.2145 1.47826 18.4787C1.2029 18.5149 1 18.7321 1 19C1 19.2606 1.19565 19.4778 1.47101 19.5176C3.78623 19.8471 4.06884 20.1258 4.48188 22.5403C4.53623 22.8118 4.74638 23 5 23Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function AIChipImageIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7279 21.7279L13.1314 15.1314C12.7354 14.7354 12.5373 14.5373 12.309 14.4632C12.1082 14.3979 11.8918 14.3979 11.691 14.4632C11.4627 14.5373 11.2646 14.7354 10.8686 15.1314L4.31608 21.6839M10 16L7.13137 13.1314C6.73535 12.7354 6.53735 12.5373 6.30902 12.4632C6.10817 12.3979 5.89183 12.3979 5.69098 12.4632C5.46265 12.5373 5.26465 12.7354 4.86863 13.1314L2 16M12.5 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H17.2C18.8802 22 19.7202 22 20.362 21.673C20.9265 21.3854 21.3854 20.9265 21.673 20.362C22 19.7202 22 18.8802 22 17.2V13.4632"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 13C17.3913 13 17.712 12.7122 17.7663 12.305C18.3043 8.67783 18.7989 8.17285 22.288 7.77647C22.6902 7.7276 23 7.39095 23 7C23 6.60362 22.6957 6.27783 22.2935 6.2181C18.8261 5.73484 18.3967 5.31131 17.7663 1.68959C17.6957 1.28778 17.3859 1 17 1C16.6033 1 16.288 1.28778 16.2228 1.69502C15.6957 5.31674 15.2011 5.82172 11.7174 6.2181C11.3043 6.2724 11 6.59819 11 7C11 7.39095 11.2935 7.71674 11.7065 7.77647C15.1793 8.27059 15.6033 8.68869 16.2228 12.3104C16.3043 12.7176 16.6196 13 17 13Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const ImageXIcon = React.forwardRef(function ImageXIcon(
  props: IconProps,
  ref: React.ForwardedRef<SVGSVGElement>,
) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M16.5 3L21.5 8M21.5 3L16.5 8M12.5 3.5H7.8C6.11984 3.5 5.27976 3.5 4.63803 3.82698C4.07354 4.1146 3.6146 4.57354 3.32698 5.13803C3 5.77976 3 6.61984 3 8.3V16.7C3 18.3802 3 19.2202 3.32698 19.862C3.6146 20.4265 4.07354 20.8854 4.63803 21.173C5.27976 21.5 6.11984 21.5 7.8 21.5H17C17.93 21.5 18.395 21.5 18.7765 21.3978C19.8117 21.1204 20.6204 20.3117 20.8978 19.2765C21 18.895 21 18.43 21 17.5M10.5 9C10.5 10.1046 9.60457 11 8.5 11C7.39543 11 6.5 10.1046 6.5 9C6.5 7.89543 7.39543 7 8.5 7C9.60457 7 10.5 7.89543 10.5 9ZM14.99 12.4181L6.53115 20.108C6.05536 20.5406 5.81747 20.7568 5.79643 20.9442C5.77819 21.1066 5.84045 21.2676 5.96319 21.3755C6.10478 21.5 6.42628 21.5 7.06929 21.5H16.456C17.8951 21.5 18.6147 21.5 19.1799 21.2582C19.8894 20.9547 20.4547 20.3894 20.7582 19.6799C21 19.1147 21 18.3951 21 16.956C21 16.4717 21 16.2296 20.9471 16.0042C20.8805 15.7208 20.753 15.4554 20.5733 15.2264C20.4303 15.0442 20.2412 14.8929 19.8631 14.5905L17.0658 12.3527C16.6874 12.0499 16.4982 11.8985 16.2898 11.8451C16.1061 11.798 15.9129 11.8041 15.7325 11.8627C15.5279 11.9291 15.3486 12.0921 14.99 12.4181Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export function AIImageEditorIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0472 16C19.0472 16 20.1762 16 20.6896 15.7457C21.1412 15.522 21.5083 15.165 21.7384 14.726C22 14.2269 22 13.5735 22 12.2667V5.73333C22 4.42654 22 3.77315 21.7384 3.27402C21.5083 2.83498 21.1412 2.47802 20.6896 2.25432C20.1762 2 19.5041 2 18.16 2H9.84C8.49587 2 7.82381 2 7.31042 2.25432C6.85883 2.47802 6.49168 2.83498 6.26158 3.27402C6.00894 3.75608 6.00031 4.38205 6.00001 5.60157M6.00001 5.60157C6 5.64474 6 7.95532 6 8L6.00001 5.60157ZM9.97541 8C9.51076 7.7278 9.2 7.23252 9.2 6.66667C9.2 5.80756 9.91634 5.11111 10.8 5.11111C11.6837 5.11111 12.4 5.80756 12.4 6.66667C12.4 7.23252 12.0892 7.7278 11.6246 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.81767 21.7884L10.0949 16.6577C10.4117 16.3497 10.5701 16.1957 10.7528 16.138C10.9135 16.0873 11.0865 16.0873 11.2472 16.138C11.4299 16.1957 11.5883 16.3497 11.9051 16.6577L17.1471 21.7542M12.6 17.3333L14.8949 15.1022C15.2117 14.7942 15.3701 14.6402 15.5528 14.5825C15.7135 14.5317 15.8865 14.5317 16.0472 14.5825C16.2299 14.6402 16.3883 14.7942 16.7051 15.1022L19 17.3333M9.4 12.6667C9.4 13.5258 8.68366 14.2222 7.8 14.2222C6.91634 14.2222 6.2 13.5258 6.2 12.6667C6.2 11.8076 6.91634 11.1111 7.8 11.1111C8.68366 11.1111 9.4 11.8076 9.4 12.6667ZM6.84 22H15.16C16.5041 22 17.1762 22 17.6896 21.7457C18.1412 21.522 18.5083 21.165 18.7384 20.726C19 20.2269 19 19.5735 19 18.2667V11.7333C19 10.4265 19 9.77315 18.7384 9.27402C18.5083 8.83498 18.1412 8.47802 17.6896 8.25432C17.1762 8 16.5041 8 15.16 8H6.84C5.49587 8 4.82381 8 4.31042 8.25432C3.85883 8.47802 3.49168 8.83498 3.26158 9.27402C3 9.77315 3 10.4265 3 11.7333V18.2667C3 19.5735 3 20.2269 3.26158 20.726C3.49168 21.165 3.85883 21.522 4.31042 21.7457C4.82381 22 5.49587 22 6.84 22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function AIQuoteGeneratorIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 5.75H8C9.24264 5.75 10.25 6.75736 10.25 8V13.25H5C3.75736 13.25 2.75 12.2426 2.75 11V8C2.75 6.75736 3.75736 5.75 5 5.75Z"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M10.25 12V15C10.25 17.2091 8.45914 19 6.25 19H5.25"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M16 6H19C20.1046 6 21 6.89543 21 8V13H16C14.8954 13 14 12.1046 14 11V8C14 6.89543 14.8954 6 16 6Z"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      <path
        d="M21 12V15C21 17.2091 19.2091 19 17 19H16"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export function Cat01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0196 14.9374C11.7284 14.9374 11.4307 14.9818 11.1784 15.0796C11.0546 15.1275 10.9032 15.2031 10.7699 15.3252C10.6361 15.4479 10.4632 15.6749 10.4632 15.9999C10.4632 16.3249 10.6361 16.5519 10.7699 16.6745C10.9032 16.7967 11.0546 16.8722 11.1784 16.9202C11.4307 17.018 11.7284 17.0624 12.0196 17.0624C12.3109 17.0624 12.6085 17.018 12.8609 16.9202C12.9846 16.8722 13.136 16.7967 13.2693 16.6745C13.4032 16.5519 13.5761 16.3249 13.5761 15.9999C13.5761 15.6749 13.4032 15.4479 13.2693 15.3252C13.136 15.2031 12.9846 15.1275 12.8609 15.0796C12.6085 14.9818 12.3109 14.9374 12.0196 14.9374Z"
        fill="currentColor"
      />
      <path
        d="M14.0365 12.6464C14.2015 12.38 14.5274 12.0625 15.0163 12.0625C15.5051 12.0625 15.831 12.38 15.996 12.6464C16.1681 12.9243 16.2501 13.2612 16.2501 13.5938C16.2501 13.9263 16.1681 14.2632 15.996 14.5411C15.831 14.8075 15.5051 15.125 15.0163 15.125C14.5274 15.125 14.2015 14.8075 14.0365 14.5411C13.8644 14.2632 13.7824 13.9263 13.7824 13.5938C13.7824 13.2612 13.8644 12.9243 14.0365 12.6464Z"
        fill="currentColor"
      />
      <path
        d="M9.01634 12.0625C8.52751 12.0625 8.20161 12.38 8.03658 12.6464C7.86445 12.9243 7.78247 13.2612 7.78247 13.5938C7.78247 13.9263 7.86445 14.2632 8.03658 14.5411C8.20161 14.8075 8.52751 15.125 9.01634 15.125C9.50518 15.125 9.83108 14.8075 9.9961 14.5411C10.1682 14.2632 10.2502 13.9263 10.2502 13.5938C10.2502 13.2612 10.1682 12.9243 9.9961 12.6464C9.83108 12.38 9.50518 12.0625 9.01634 12.0625Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09485 4.25C5.48148 4.25 4.77463 4.42871 4.20882 4.91616C3.62226 5.4215 3.27004 6.18781 3.27004 7.1875V9.0625L3.27005 9.06545C3.2712 9.35941 3.3211 9.94757 3.4888 10.4392C3.54365 10.6001 3.63129 10.8134 3.77764 11.0058C3.49364 11.5688 3.35904 12.1495 3.29787 12.7095C3.2468 13.1771 3.24611 13.6679 3.25424 14.1211C2.5932 14.3507 1.90877 14.6349 1.5932 14.8387C1.24524 15.0634 1.14534 15.5277 1.37006 15.8756C1.59478 16.2236 2.05903 16.3235 2.40698 16.0988C2.5234 16.0236 2.86686 15.8664 3.31867 15.6939C3.38755 16.173 3.52716 16.6095 3.7221 17.0063C3.56621 17.1035 3.42847 17.1935 3.31889 17.2652C3.27694 17.2926 3.23912 17.3173 3.20599 17.3387C2.85803 17.5634 2.75813 18.0277 2.98285 18.3756C3.20757 18.7236 3.67182 18.8235 4.01978 18.5988C4.0609 18.5722 4.10473 18.5436 4.15098 18.5134C4.28216 18.4278 4.43287 18.3294 4.59701 18.2288C5.18653 18.8313 5.91865 19.2964 6.67916 19.6462C8.45998 20.4654 10.569 20.75 12.0001 20.75C13.4311 20.75 15.5402 20.4654 17.321 19.6462C18.0815 19.2964 18.8136 18.8313 19.4031 18.2288C19.5673 18.3294 19.718 18.4278 19.8491 18.5134C19.8954 18.5436 19.9392 18.5722 19.9803 18.5988C20.3283 18.8235 20.7925 18.7236 21.0173 18.3756C21.242 18.0277 21.1421 17.5634 20.7941 17.3387C20.761 17.3173 20.7232 17.2926 20.6812 17.2652C20.5716 17.1935 20.4339 17.1035 20.2781 17.0063C20.473 16.6095 20.6127 16.173 20.6815 15.6938C21.1335 15.8663 21.4771 16.0236 21.5936 16.0988C21.9415 16.3235 22.4058 16.2236 22.6305 15.8756C22.8552 15.5277 22.7553 15.0634 22.4074 14.8387C22.0917 14.6349 21.4071 14.3506 20.7459 14.121C20.7541 13.6678 20.7534 13.177 20.7023 12.7095C20.6412 12.1495 20.5065 11.5688 20.2225 11.0058C20.3689 10.8134 20.4565 10.6001 20.5114 10.4392C20.6791 9.94758 20.729 9.35941 20.7301 9.06545L20.7302 9.0625V7.18761C20.7302 6.18792 20.3779 5.42162 19.7914 4.91628C19.2256 4.42882 18.5187 4.25011 17.9054 4.25011C17.4969 4.25011 17.0744 4.40685 16.7337 4.56076C16.3726 4.72392 15.9952 4.9359 15.6558 5.13136C15.5828 5.17339 15.5119 5.21444 15.443 5.25432L15.441 5.25548C15.177 5.4084 14.9427 5.5441 14.7339 5.65167C14.6042 5.7185 14.5035 5.7643 14.4285 5.79206C14.3969 5.80377 14.3767 5.80966 14.3663 5.81242C14.1129 5.81102 13.9514 5.79033 13.7181 5.76044C13.6681 5.75403 13.6147 5.74719 13.5564 5.74003C13.2098 5.69743 12.7722 5.65636 12.0001 5.65636C11.228 5.65636 10.7905 5.69743 10.4438 5.74003C10.3855 5.74719 10.3322 5.75403 10.2821 5.76044C10.0489 5.79033 9.88738 5.81102 9.63388 5.81242C9.62352 5.80966 9.60332 5.80376 9.57174 5.79206C9.49678 5.7643 9.39604 5.71849 9.26633 5.65166C9.05755 5.54408 8.82331 5.40842 8.55926 5.25548C8.48975 5.21523 8.41818 5.17377 8.34446 5.13132C8.00502 4.93584 7.62764 4.72384 7.26652 4.56067C6.92587 4.40675 6.50329 4.25 6.09485 4.25ZM6.16192 17.6138C6.49595 17.8657 6.8808 18.0879 7.30604 18.2835C8.83694 18.9877 10.7179 19.25 12.0001 19.25C13.2823 19.25 15.1632 18.9877 16.6941 18.2835C17.1194 18.0879 17.5042 17.8657 17.8382 17.6138C17.4858 17.5524 17.2179 17.245 17.2179 16.875C17.2179 16.4608 17.5537 16.125 17.9679 16.125C18.2951 16.125 18.6295 16.2068 18.9399 16.3204C19.0985 15.9885 19.1959 15.625 19.2226 15.2271C18.9249 15.1544 18.7193 15.125 18.6134 15.125C18.1992 15.125 17.8634 14.7892 17.8634 14.375C17.8634 13.9608 18.1992 13.625 18.6134 13.625C18.8081 13.625 19.0284 13.6542 19.2504 13.6974C19.2505 13.4213 19.2415 13.1502 19.2112 12.8724C19.1407 12.227 18.958 11.6541 18.5269 11.1447C18.3727 10.9625 18.1809 10.7813 17.9402 10.6045C17.6063 10.3594 17.5344 9.88999 17.7796 9.55611C18.0247 9.22224 18.4941 9.15031 18.828 9.39546C18.9471 9.48292 19.0597 9.57282 19.1659 9.66506C19.2099 9.43686 19.2295 9.19817 19.2302 9.06087V7.18761C19.2302 6.56231 19.0238 6.23486 18.8123 6.0527C18.5801 5.85266 18.2496 5.75011 17.9054 5.75011C17.835 5.75011 17.659 5.78868 17.3513 5.92771C17.064 6.0575 16.7432 6.23612 16.4043 6.43125C16.3407 6.4679 16.2759 6.50544 16.2106 6.54328C15.9428 6.69843 15.666 6.85883 15.4209 6.98509C15.2663 7.06473 15.1052 7.14099 14.9495 7.19867C14.8058 7.25192 14.607 7.3125 14.3941 7.3125C14.0223 7.3125 13.7617 7.27877 13.5115 7.2464C13.4654 7.24043 13.4196 7.23449 13.3735 7.22883C13.0848 7.19336 12.7084 7.15636 12.0001 7.15636C11.2919 7.15636 10.9154 7.19336 10.6267 7.22883C10.5807 7.23449 10.5349 7.24042 10.4887 7.24639C10.2386 7.27877 9.97796 7.3125 9.6061 7.3125C9.39326 7.3125 9.19445 7.25191 9.05069 7.19866C8.89497 7.14098 8.73386 7.06471 8.57928 6.98506C8.33423 6.8588 8.05742 6.69839 7.78968 6.54325C7.72435 6.50539 7.65955 6.46784 7.59589 6.43118C7.25702 6.23603 6.93614 6.05741 6.64888 5.92761C6.34115 5.78856 6.16522 5.75 6.09485 5.75C5.75062 5.75 5.42007 5.85254 5.18787 6.05259C4.97643 6.23475 4.77004 6.56219 4.77004 7.1875V9.06088C4.7707 9.19819 4.79025 9.43686 4.83425 9.66506C4.94053 9.57281 5.05309 9.48292 5.1722 9.39546C5.50608 9.15031 5.97547 9.22224 6.22062 9.55612C6.46577 9.88999 6.39385 10.3594 6.05997 10.6045C5.81926 10.7813 5.62748 10.9625 5.47331 11.1447C5.04223 11.6541 4.85949 12.227 4.789 12.8724C4.75865 13.1502 4.74966 13.4213 4.74975 13.6975C4.97192 13.6543 5.19231 13.625 5.38719 13.625C5.80141 13.625 6.13719 13.9608 6.13719 14.375C6.13719 14.7892 5.80141 15.125 5.38719 15.125C5.28121 15.125 5.07549 15.1544 4.77758 15.2271C4.80434 15.625 4.90168 15.9885 5.06027 16.3203C5.37069 16.2068 5.70504 16.125 6.03224 16.125C6.44646 16.125 6.78224 16.4608 6.78224 16.875C6.78224 17.245 6.51433 17.5524 6.16192 17.6138Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const StarOutlineIcon = function StarOutlineIcon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M8 18L12 14.95L16 18L14.5 13.05L18.5 10.2H13.6L12 5L10.4 10.2H5.5L9.5 13.05L8 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const WavesIcon = function WavesIcon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M2 6C2.6 6.5 3.2 7 4.5 7C7 7 7 5 9.5 5C10.8 5 11.4 5.5 12 6C12.6 6.5 13.2 7 14.5 7C17 7 17 5 19.5 5C20.8 5 21.4 5.5 22 6M2 18C2.6 18.5 3.2 19 4.5 19C7 19 7 17 9.5 17C10.8 17 11.4 17.5 12 18C12.6 18.5 13.2 19 14.5 19C17 19 17 17 19.5 17C20.8 17 21.4 17.5 22 18M2 12C2.6 12.5 3.2 13 4.5 13C7 13 7 11 9.5 11C10.8 11 11.4 11.5 12 12C12.6 12.5 13.2 13 14.5 13C17 13 17 11 19.5 11C20.8 11 21.4 11.5 22 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Brush01Icon = function Brush01Icon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M7.74997 9.6179L11.5278 13.3957M6.72485 19.3706C5.35801 20.7374 2.75 20.3957 0.75 20.3957C1.7751 18.3957 0.408265 15.7876 1.7751 14.4208C3.14194 13.054 5.35801 13.054 6.72485 14.4208C8.09168 15.7876 8.09168 18.0037 6.72485 19.3706ZM10.6716 14.3203L19.8087 4.45222C20.6135 3.58306 20.5875 2.23327 19.7499 1.39568C18.9124 0.558088 17.5626 0.532138 16.6934 1.33692L6.82534 10.474C6.3154 10.9462 6.06043 11.1823 5.91173 11.4341C5.55514 12.0378 5.54079 12.7842 5.87391 13.4012C6.01283 13.6586 6.25853 13.9043 6.74995 14.3957C7.24136 14.8871 7.48707 15.1328 7.74438 15.2717C8.3614 15.6048 9.10781 15.5905 9.71157 15.2339C9.96336 15.0852 10.1994 14.8302 10.6716 14.3203Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Perspective02Icon = function Perspective02Icon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M13.75 3.22956L13.75 17.2296M7.75 2.22956L7.75 18.2296M0.75 10.2296H18.75M0.75 4.21873L0.75 16.2404C0.75 17.6044 0.75 18.2864 1.03134 18.7592C1.27803 19.1737 1.6662 19.485 2.12434 19.6359C2.64685 19.808 3.31262 19.6601 4.64418 19.3642L16.2442 16.7864C17.1383 16.5877 17.5854 16.4884 17.9191 16.248C18.2134 16.0359 18.4445 15.7478 18.5877 15.4144C18.75 15.0365 18.75 14.5785 18.75 13.6626V6.79651C18.75 5.88058 18.75 5.42261 18.5877 5.04469C18.4445 4.71135 18.2134 4.42323 17.9191 4.21117C17.5854 3.97075 17.1383 3.87141 16.2442 3.67271L4.64418 1.09493C3.31262 0.799031 2.64685 0.651081 2.12434 0.823173C1.6662 0.974066 1.27803 1.28545 1.03134 1.69995C0.75 2.17268 0.75 2.85469 0.75 4.21873Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Cube01Icon = function Cube01Icon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M18.2502 5.88379L9.75018 10.606M9.75018 10.606L1.25018 5.88379M9.75018 10.606L9.75021 20.106M18.7502 14.6646V6.54749C18.7502 6.20484 18.7502 6.03352 18.6997 5.88072C18.6551 5.74555 18.5821 5.62147 18.4856 5.51678C18.3765 5.39844 18.2268 5.31524 17.9272 5.14883L10.5272 1.03772C10.2436 0.880166 10.1018 0.801387 9.95167 0.770501C9.81876 0.743166 9.68167 0.743166 9.54876 0.770501C9.39859 0.801387 9.25679 0.880166 8.97319 1.03772L1.57318 5.14884C1.27366 5.31524 1.1239 5.39844 1.01485 5.51678C0.918371 5.62147 0.845361 5.74555 0.800698 5.88073C0.750214 6.03352 0.750214 6.20485 0.750214 6.54749V14.6646C0.750214 15.0072 0.750214 15.1786 0.800698 15.3314C0.845361 15.4665 0.918371 15.5906 1.01485 15.6953C1.1239 15.8136 1.27366 15.8968 1.57319 16.0632L8.97319 20.1744C9.25679 20.3319 9.39859 20.4107 9.54876 20.4416C9.68167 20.4689 9.81876 20.4689 9.95167 20.4416C10.1018 20.4107 10.2436 20.3319 10.5272 20.1744L17.9272 16.0632C18.2268 15.8968 18.3765 15.8136 18.4856 15.6953C18.5821 15.5906 18.6551 15.4665 18.6997 15.3314C18.7502 15.1786 18.7502 15.0072 18.7502 14.6646Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const CodepenIcon = function CodepenIcon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M12 9L4.06386 14.1585C3.37601 14.6056 3.03209 14.8291 2.91297 15.1126C2.80888 15.3604 2.80888 15.6396 2.91297 15.8874M12 9L19.9361 14.1585C20.624 14.6056 20.9679 14.8291 21.087 15.1126C21.1911 15.3604 21.1911 15.6396 21.087 15.8874M12 9V2.5M12 15L4.06386 9.84151C3.37601 9.39441 3.03209 9.17086 2.91297 8.88736C2.80888 8.63961 2.80888 8.36039 2.91297 8.11264M12 15L19.9361 9.84151C20.624 9.39441 20.9679 9.17086 21.087 8.88736C21.1911 8.63961 21.1911 8.36039 21.087 8.11264M12 15V21.5M21.272 15.9732L12.872 21.4332C12.5564 21.6384 12.3985 21.7409 12.2285 21.7809C12.0782 21.8161 11.9218 21.8161 11.7715 21.7809C11.6015 21.7409 11.4436 21.6384 11.128 21.4332L2.72802 15.9732C2.46201 15.8003 2.32901 15.7139 2.23265 15.5985C2.14735 15.4965 2.08327 15.3784 2.04417 15.2512C2 15.1076 2 14.949 2 14.6317V9.3683C2 9.05104 2 8.89241 2.04417 8.74877C2.08327 8.62161 2.14735 8.50354 2.23265 8.40146C2.32901 8.28614 2.46201 8.19969 2.72802 8.02679L11.128 2.56679C11.4436 2.36164 11.6015 2.25906 11.7715 2.21915C11.9218 2.18387 12.0782 2.18387 12.2285 2.21915C12.3985 2.25906 12.5564 2.36164 12.872 2.56679L21.272 8.02679C21.538 8.19969 21.671 8.28614 21.7674 8.40146C21.8527 8.50354 21.9167 8.62161 21.9558 8.74877C22 8.89241 22 9.05104 22 9.3683V14.6317C22 14.949 22 15.1076 21.9558 15.2512C21.9167 15.3784 21.8527 15.4965 21.7674 15.5985C21.671 15.7139 21.538 15.8003 21.272 15.9732Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const DataIcon = function DataIcon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M21.2 22C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V10.8C22 10.52 22 10.38 21.9455 10.273C21.8976 10.1789 21.8211 10.1024 21.727 10.0545C21.62 10 21.48 10 21.2 10L18.8 10C18.52 10 18.38 10 18.273 10.0545C18.1789 10.1024 18.1024 10.1789 18.0545 10.273C18 10.38 18 10.52 18 10.8V13.2C18 13.48 18 13.62 17.9455 13.727C17.8976 13.8211 17.8211 13.8976 17.727 13.9455C17.62 14 17.48 14 17.2 14H14.8C14.52 14 14.38 14 14.273 14.0545C14.1789 14.1024 14.1024 14.1789 14.0545 14.273C14 14.38 14 14.52 14 14.8V17.2C14 17.48 14 17.62 13.9455 17.727C13.8976 17.8211 13.8211 17.8976 13.727 17.9455C13.62 18 13.48 18 13.2 18H10.8C10.52 18 10.38 18 10.273 18.0545C10.1789 18.1024 10.1024 18.1789 10.0545 18.273C10 18.38 10 18.52 10 18.8V21.2C10 21.48 10 21.62 10.0545 21.727C10.1024 21.8211 10.1789 21.8976 10.273 21.9455C10.38 22 10.52 22 10.8 22L21.2 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.8C10 6.51997 10 6.37996 10.0545 6.273C10.1024 6.17892 10.1789 6.10243 10.273 6.0545C10.38 6 10.52 6 10.8 6H13.2C13.48 6 13.62 6 13.727 6.0545C13.8211 6.10243 13.8976 6.17892 13.9455 6.273C14 6.37996 14 6.51997 14 6.8V9.2C14 9.48003 14 9.62004 13.9455 9.727C13.8976 9.82108 13.8211 9.89757 13.727 9.9455C13.62 10 13.48 10 13.2 10H10.8C10.52 10 10.38 10 10.273 9.9455C10.1789 9.89757 10.1024 9.82108 10.0545 9.727C10 9.62004 10 9.48003 10 9.2V6.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.8C3 12.52 3 12.38 3.0545 12.273C3.10243 12.1789 3.17892 12.1024 3.273 12.0545C3.37996 12 3.51997 12 3.8 12H6.2C6.48003 12 6.62004 12 6.727 12.0545C6.82108 12.1024 6.89757 12.1789 6.9455 12.273C7 12.38 7 12.52 7 12.8V15.2C7 15.48 7 15.62 6.9455 15.727C6.89757 15.8211 6.82108 15.8976 6.727 15.9455C6.62004 16 6.48003 16 6.2 16H3.8C3.51997 16 3.37996 16 3.273 15.9455C3.17892 15.8976 3.10243 15.8211 3.0545 15.727C3 15.62 3 15.48 3 15.2V12.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 2.8C2 2.51997 2 2.37996 2.0545 2.273C2.10243 2.17892 2.17892 2.10243 2.273 2.0545C2.37996 2 2.51997 2 2.8 2H5.2C5.48003 2 5.62004 2 5.727 2.0545C5.82108 2.10243 5.89757 2.17892 5.9455 2.273C6 2.37996 6 2.51997 6 2.8V5.2C6 5.48003 6 5.62004 5.9455 5.727C5.89757 5.82108 5.82108 5.89757 5.727 5.9455C5.62004 6 5.48003 6 5.2 6H2.8C2.51997 6 2.37996 6 2.273 5.9455C2.17892 5.89757 2.10243 5.82108 2.0545 5.727C2 5.62004 2 5.48003 2 5.2V2.8Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function CubeOutlineIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 20.75L11.223 21.5683C11.5066 21.7258 11.6484 21.8046 11.7986 21.8355C11.9315 21.8628 12.0685 21.8628 12.2015 21.8355C12.3516 21.8046 12.4934 21.7258 12.777 21.5683L14.25 20.75M5.25 18.25L3.82297 17.4572C3.52346 17.2908 3.37368 17.2076 3.26463 17.0892C3.16816 16.9845 3.09515 16.8605 3.05048 16.7253C3 16.5725 3 16.4012 3 16.0585V14.5M3 9.49996V7.94141C3 7.59877 3 7.42744 3.05048 7.27465C3.09515 7.13947 3.16816 7.01539 3.26463 6.9107C3.37368 6.79236 3.52345 6.70916 3.82297 6.54276L5.25 5.74996M9.75 3.24996L11.223 2.43164C11.5066 2.27409 11.6484 2.19531 11.7986 2.16442C11.9315 2.13709 12.0685 2.13709 12.2015 2.16442C12.3516 2.19531 12.4934 2.27409 12.777 2.43164L14.25 3.24996M18.75 5.74996L20.177 6.54276C20.4766 6.70916 20.6263 6.79236 20.7354 6.9107C20.8318 7.01539 20.9049 7.13947 20.9495 7.27464C21 7.42744 21 7.59876 21 7.94141V9.49996M21 14.5V16.0585C21 16.4012 21 16.5725 20.9495 16.7253C20.9049 16.8605 20.8318 16.9845 20.7354 17.0892C20.6263 17.2076 20.4766 17.2908 20.177 17.4572L18.75 18.25M9.75 10.75L12 12M12 12L14.25 10.75M12 12V14.5M3 6.99996L5.25 8.24996M18.75 8.24996L21 6.99996M12 19.5V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ImageRightIcon = function ImageRightIcon({
  ref,
  ...props
}: IconProps & {
  ref?: React.Ref<SVGSVGElement>
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M19 8L22 5M22 5L19 2M22 5L16 5M12.5 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H17C17.93 21 18.395 21 18.7765 20.8978C19.8117 20.6204 20.6204 19.8117 20.8978 18.7765C21 18.395 21 17.93 21 17M10.5 8.5C10.5 9.60457 9.60457 10.5 8.5 10.5C7.39543 10.5 6.5 9.60457 6.5 8.5C6.5 7.39543 7.39543 6.5 8.5 6.5C9.60457 6.5 10.5 7.39543 10.5 8.5ZM14.99 11.9181L6.53115 19.608C6.05536 20.0406 5.81747 20.2568 5.79643 20.4442C5.77819 20.6066 5.84045 20.7676 5.96319 20.8755C6.10478 21 6.42628 21 7.06929 21H16.456C17.8951 21 18.6147 21 19.1799 20.7582C19.8894 20.4547 20.4547 19.8894 20.7582 19.1799C21 18.6147 21 17.8951 21 16.456C21 15.9717 21 15.7296 20.9471 15.5042C20.8805 15.2208 20.753 14.9554 20.5733 14.7264C20.4303 14.5442 20.2412 14.3929 19.8631 14.0905L17.0658 11.8527C16.6874 11.5499 16.4982 11.3985 16.2898 11.3451C16.1061 11.298 15.9129 11.3041 15.7325 11.3627C15.5279 11.4291 15.3486 11.5921 14.99 11.9181Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Monitor02Icon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.04853 14C5.93839 13.5732 6.94063 13.3333 8.00065 13.3333C9.06067 13.3333 10.0629 13.5732 10.9528 14M4.53398 11.3333H11.4673C12.5874 11.3333 13.1475 11.3333 13.5753 11.1153C13.9516 10.9236 14.2576 10.6176 14.4493 10.2413C14.6673 9.81349 14.6673 9.25344 14.6673 8.13333V5.2C14.6673 4.0799 14.6673 3.51984 14.4493 3.09202C14.2576 2.71569 13.9516 2.40973 13.5753 2.21799C13.1475 2 12.5874 2 11.4673 2H4.53398C3.41388 2 2.85383 2 2.426 2.21799C2.04968 2.40973 1.74372 2.71569 1.55197 3.09202C1.33398 3.51984 1.33398 4.0799 1.33398 5.2V8.13333C1.33398 9.25344 1.33398 9.81349 1.55197 10.2413C1.74372 10.6176 2.04968 10.9236 2.426 11.1153C2.85383 11.3333 3.41388 11.3333 4.53398 11.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Camera01Icon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      {...props}
    >
      <path
        d="M0.75 7.12722C0.75 6.7769 0.75 6.60174 0.764617 6.45421C0.905601 5.03127 2.03127 3.9056 3.45421 3.76462C3.60174 3.75 3.78636 3.75 4.15558 3.75C4.29785 3.75 4.36899 3.75 4.42939 3.74634C5.20061 3.69963 5.87595 3.21288 6.16414 2.496C6.18671 2.43986 6.20781 2.37657 6.25 2.25C6.29219 2.12343 6.31329 2.06014 6.33586 2.004C6.62405 1.28712 7.29939 0.800365 8.07061 0.753658C8.13101 0.75 8.19772 0.75 8.33114 0.75H13.1689C13.3023 0.75 13.369 0.75 13.4294 0.753658C14.2006 0.800365 14.876 1.28712 15.1641 2.004C15.1867 2.06014 15.2078 2.12343 15.25 2.25C15.2922 2.37657 15.3133 2.43986 15.3359 2.496C15.624 3.21288 16.2994 3.69963 17.0706 3.74634C17.131 3.75 17.2021 3.75 17.3444 3.75C17.7136 3.75 17.8983 3.75 18.0458 3.76462C19.4687 3.9056 20.5944 5.03127 20.7354 6.45421C20.75 6.60174 20.75 6.7769 20.75 7.12722V14.95C20.75 16.6302 20.75 17.4702 20.423 18.112C20.1354 18.6765 19.6765 19.1354 19.112 19.423C18.4702 19.75 17.6302 19.75 15.95 19.75H5.55C3.86984 19.75 3.02976 19.75 2.38803 19.423C1.82354 19.1354 1.3646 18.6765 1.07698 18.112C0.75 17.4702 0.75 16.6302 0.75 14.95V7.12722Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 15.25C12.9591 15.25 14.75 13.4591 14.75 11.25C14.75 9.04086 12.9591 7.25 10.75 7.25C8.54086 7.25 6.75 9.04086 6.75 11.25C6.75 13.4591 8.54086 15.25 10.75 15.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function EffectWaveIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.81 7.84998C16.5 7.84998 16.5 3.84998 12.19 3.84998C7.87996 3.84998 7.88996 7.84998 3.57996 7.84998"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.81 13.92C16.5 13.92 16.5 9.92004 12.19 9.92004C7.87996 9.92004 7.88996 13.92 3.57996 13.92"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.23474 19.956C7.89265 19.5678 8.11379 15.99 12.19 15.99C16.2115 15.99 16.4807 19.4725 20 19.9386"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function Globe02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1019 1.838C18.3948 1.54526 18.8696 1.54516 19.1624 1.838C23.9461 6.62193 23.9462 14.3784 19.1624 19.1622C14.5809 23.7437 7.27401 23.9369 2.46125 19.7433C2.37317 19.6665 2.26744 19.5762 2.18293 19.4874C2.08769 19.3873 1.98217 19.2532 1.91242 19.0694C1.81643 18.8161 1.80675 18.5241 1.88508 18.2648L1.93586 18.128C1.99332 18.0008 2.06718 17.9002 2.13313 17.8214C2.21317 17.7258 2.31463 17.6243 2.40363 17.5353L4.16047 15.7784C2.96814 14.3479 2.25037 12.508 2.25031 10.5001C2.25031 5.94376 5.94396 2.25011 10.5003 2.25011C15.0565 2.25028 18.7503 5.94387 18.7503 10.5001C18.7502 15.0563 15.0564 18.7499 10.5003 18.7501C8.49208 18.7501 6.65167 18.0317 5.22102 16.839L3.46418 18.5968C3.45868 18.6023 3.45279 18.6072 3.44758 18.6124C7.66999 22.2911 14.082 22.1216 18.1019 18.1017C22.2999 13.9036 22.2997 7.09669 18.1019 2.89855C17.809 2.60566 17.809 2.1309 18.1019 1.838ZM10.5003 3.75011C6.77239 3.75011 3.75031 6.77219 3.75031 10.5001C3.75043 14.2279 6.77247 17.2501 10.5003 17.2501C14.228 17.2499 17.2502 14.2278 17.2503 10.5001C17.2503 6.77229 14.2281 3.75028 10.5003 3.75011Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Certificate02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 17.75C15.4142 17.75 15.75 18.0858 15.75 18.5C15.75 18.9142 15.4142 19.25 15 19.25H9C8.58579 19.25 8.25 18.9142 8.25 18.5C8.25 18.0858 8.58579 17.75 9 17.75H15Z"
        fill="currentColor"
      />
      <path
        d="M17 14.25C17.4142 14.25 17.75 14.5858 17.75 15C17.75 15.4142 17.4142 15.75 17 15.75H7C6.58579 15.75 6.25 15.4142 6.25 15C6.25 14.5858 6.58579 14.25 7 14.25H17Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.78125 5.35449C9.7943 4.53051 11.0634 4.60725 11.9971 5.22949C12.9293 4.60732 14.1874 4.5415 15.207 5.34863C16.4295 6.31659 16.5846 7.99586 15.6338 9.16113C15.2432 9.63974 14.4291 10.3848 13.7627 10.9727C13.4198 11.2751 13.0991 11.5503 12.8643 11.75C12.7467 11.85 12.6501 11.9319 12.583 11.9883C12.5499 12.0161 12.5238 12.0378 12.5059 12.0527C12.4969 12.0602 12.4891 12.0664 12.4844 12.0703C12.4821 12.0722 12.4795 12.0752 12.4795 12.0752L12.4775 12.0762C12.2344 12.2785 11.8952 12.304 11.6279 12.1523L11.5176 12.0762L11.5156 12.0752C11.5156 12.0752 11.513 12.0722 11.5107 12.0703C11.506 12.0664 11.4992 12.0602 11.4902 12.0527C11.4723 12.0378 11.4456 12.0164 11.4121 11.9883C11.3451 11.9319 11.2484 11.85 11.1309 11.75C10.896 11.5503 10.5753 11.2751 10.2324 10.9727C9.56602 10.3848 8.75189 9.63974 8.36133 9.16113C7.40333 7.98709 7.59198 6.32225 8.78125 5.35449ZM11.4395 6.71289C10.9641 6.1838 10.2465 6.09623 9.72754 6.51855C9.16333 6.97772 9.10439 7.69934 9.52344 8.21289C9.82148 8.57811 10.5357 9.23993 11.2246 9.84766C11.5098 10.0993 11.7809 10.3311 11.9971 10.5156C12.2133 10.331 12.485 10.0995 12.7705 9.84766C13.4594 9.23996 14.1736 8.57812 14.4717 8.21289C14.8978 7.69065 14.8363 6.9684 14.2754 6.52441C13.7335 6.09565 13.0255 6.18992 12.5557 6.71289C12.4135 6.87116 12.2108 6.96179 11.998 6.96191C11.7852 6.96191 11.5817 6.87127 11.4395 6.71289Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 1.25C20.5912 1.25 21.75 2.65743 21.75 4.22266V19.7773C21.75 21.3426 20.5912 22.75 19 22.75H5C3.40884 22.75 2.25 21.3426 2.25 19.7773V4.22266C2.25 2.65743 3.40884 1.25 5 1.25H19ZM5 2.75C4.38202 2.75 3.75 3.33329 3.75 4.22266V19.7773C3.75 20.6667 4.38202 21.25 5 21.25H19C19.618 21.25 20.25 20.6667 20.25 19.7773V4.22266C20.25 3.33329 19.618 2.75 19 2.75H5Z"
        fill="currentColor"
      />
    </svg>
  )
}
